/* eslint-disable default-case */
/* eslint-disable no-restricted-globals */
import React, { useState, useEffect, useMemo } from "react";
import { v4 as uuidv4 } from "uuid";
import {
  CloudLightning,
  Wind,
  Plane,
  Fingerprint,
  FileWarning,
  Droplets,
  Zap,
  X,
  Thermometer,
  Sun,
  Snowflake,
  Milestone,
  ArrowRight,
  Mic,
  HardDrive,
} from "lucide-react";
import {
  Flame,
  BadgeAlert,
  ThumbsDown,
  UserMinus,
  Skull,
  ShieldAlert,
  Ship,
  UserX,
  Glasses,
  ShieldX,
  AlertOctagon,
} from "lucide-react";
import {
  Clock,
  User,
  DollarSign,
  Info,
  Bell,
  Fish,
  Megaphone,
  BarChart3,
  Printer,
  Dog,
  Hotel,
  Smile,
  Flower,
  Wine,
  Feather,
  Sunrise,
  Settings,
  Coffee,
  Disc,
  Trophy,
  Minus,
  Film,
  Book,
  Building2,
  PieChart,
  Image,
  Trash2,
  SmilePlus,
  Wallet,
  AlertTriangle,
  UserCircle,
  HelpCircle,
  Utensils,
  Bed,
  Cloud,
  CloudOff,
  Star,
  Award,
  Users,
  Home,
  CheckCircle,
  AlertCircle,
  Briefcase,
  Heart,
  Gift,
  TrendingUp,
  PenTool,
  RefreshCw,
  FileText,
  Plus,
  BarChart2,
  Activity,
  Package,
  Shield,
  Umbrella,
  Car,
  Monitor,
  Wifi,
  Tv,
  Map,
  Maximize,
  ThumbsUp,
  Anchor,
  Music,
  Save,
  Download,
  Eye,
  EyeOff,
  Building,
  ArrowUp,
  ArrowDown,
  BarChart,
} from "lucide-react";
import MarketShareGraph from "../components/MarketShareGraph";
import StaffManagementTab from "../components/StaffManagerTab";
import GuestManagerTab from "../components/GuestManagerTab";
import MarketingTab from "../components/MarketingManagerTab";
import RoomManagementTab from "../components/RoomManagementTab";
import CompetitorManagerTab from "../components/CompetitorManagerTab";
import { gameAPI } from "../services/api";
import FinanceReportTab from "../components/FinanceReportTab";
import LeaderBoardTab from "../components/LeaderBoardTab";
import HowToPlayModal from "../components/HowToPlayModal";
import GameOverModal from "../components/GameOverModal";
import FacilityManagementTab from "../components/FacilityManagementTab";
import RandomEventModal from "../components/RandomEventModal";

/**
 * Formats a number as a currency string (e.g., $1,234.56).
 * @param {number} value The number to format.
 * @param {string} currencySymbol The currency symbol (default: '$').
 * @param {number} decimalPlaces The number of decimal places (default: 0 for cleaner display).
 * @returns {string} The formatted currency string.
 */
const formatCurrency = (value, currencySymbol = '$', decimalPlaces = 0) => {
  // Ensure value is a number
  const numberValue = Number(value);
  if (isNaN(numberValue)) {
    return `${currencySymbol}0`; // Or handle error differently
  }

  // Use Intl.NumberFormat for robust formatting (handles locale-specific separators)
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD', // Use USD as a base, the symbol is overridden
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    }).format(numberValue).replace('USD', currencySymbol).trim(); // Replace code with symbol if needed
     // A simpler fallback if Intl isn't needed/available:
     // return `${currencySymbol}${numberValue.toFixed(decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
  } catch (error) {
      console.error("Error formatting currency:", error);
      // Fallback to a simpler format if Intl fails
      return `${currencySymbol}${numberValue.toFixed(decimalPlaces)}`;
  }
};


// Calendar icon definition (wasn't imported properly)
const Calendar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

const VirtualHotelGame = () => {
  // Game state
  const [money, setMoney] = useState(100000);
  const [day, setDay] = useState(1);
  const [reputation, setReputation] = useState(3);
  const [activeFilter, setActiveFilter] = useState(null);

  const [rooms, setRooms] = useState([
    {
      id: 1,
      type: "Standard",
      price: 80,
      occupied: false,
      quality: 1,
      guest: null,
    },
    {
      id: 2,
      type: "Standard",
      price: 80,
      occupied: false,
      quality: 1,
      guest: null,
    },
  ]);
  const [staff, setStaff] = useState([
    {
      id: 1,
      name: "Jane",
      role: "Receptionist",
      salary: 220,
      skill: 2,
      happiness: 5,
    },
  ]);
  const [facilities, setFacilities] = useState([
    { id: 1, name: "Lobby", level: 1, upkeep: 70 },
  ]);
  const [guests, setGuests] = useState([]);

  const [pendingReload, setPendingReload] = useState(false);

  const [gameSpeed, setGameSpeed] = useState(1); // 1 = normal, 2 = fast, 0 = paused
  const [selectedTab, setSelectedTab] = useState("dashboard");

  // NEW: Save/Load functionality
  const [savedGames, setSavedGames] = useState([]);

  const [cloudSavedGames, setCloudSavedGames] = useState([]);

  const [showSaveModal, setShowSaveModal] = useState(false);
  const [showLoadModal, setShowLoadModal] = useState(false);
  const [saveName, setSaveName] = useState("");
  const [saveToCloud, setSaveToCloud] = useState(false);

  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [user, setUser] = useState(null);

  // NEW: Competing hotels
  const [competitors, setCompetitors] = useState([
    {
      id: 1,
      name: "Grand Plaza Hotel",
      reputation: 3.5,
      rooms: 10,
      occupancyRate: 0.7,
      avgRoomPrice: 120,
      facilities: ["Restaurant", "Pool", "Gym"],
      marketingLevel: 2,
      marketingActive: false,
      marketingEffort: 0,
    },
    {
      id: 2,
      name: "Budget Inn",
      reputation: 2.2,
      rooms: 15,
      occupancyRate: 0.6,
      avgRoomPrice: 55,
      facilities: ["Restaurant"],
      marketingLevel: 1,
      marketingActive: true,
      marketingEffort: 3,
    },
    {
      id: 3,
      name: "Luxury Suites",
      reputation: 4.2,
      rooms: 8,
      occupancyRate: 0.5,
      avgRoomPrice: 300,
      facilities: ["Restaurant", "Spa", "Pool", "Bar"],
      marketingLevel: 3,
      marketingActive: true,
      marketingEffort: 4,
    },
    {
      id: 4,
      name: "Pestans Hotel",
      reputation: 4.5,
      rooms: 37,
      occupancyRate: 0.8,
      avgRoomPrice: 150,
      facilities: ["Restaurant", "Pool", "Gym", "Spa"],
      marketingLevel: 4,
      marketingActive: true,
      marketingEffort: 4,
    },
    {
      id: 5,
      name: "Global Star Resorts",
      reputation: 4.6,
      rooms: 20,
      occupancyRate: 0.8,
      avgRoomPrice: 400,
      facilities: ["Restaurant", "Pool", "Spa", "Concierge"],
      marketingLevel: 4,
      marketingActive: true,
      marketingEffort: 4,
    },
  ]);

  const maxValue = 5000;

  // Track market share
  const [marketShare, setMarketShare] = useState(0);

  const [showBankRuptcyModal, setBankRuptcy] = useState(false);

  // Add this with your other state variables
  const [showTutorialModal, setShowTutorialModal] = useState(false);

  const [marketData, setMarketData] = useState([
    { day: 0, share: 0, reputation: 3 },
  ]);

  const [currentEvent, setCurrentEvent] = useState(null);
  const [eventResult, setEventResult] = useState(null);
  const [showEventModal, setShowEventModal] = useState(false);

  // Function to trigger a random event (can be called from your existing triggerRandomEvent function)
  const displayRandomEvent = (event) => {
    setCurrentEvent(event);
    if (event && typeof event.effect === "function") {
      const result = event.effect();
      setEventResult(result);
    }
    setShowEventModal(true);
    setGameSpeed(0);
  };

  // Handle declining the event (for events that offer choices)
  const handleDeclineEvent = () => {
    // For now, just close the modal
    // You could add specific decline effects later
    setShowEventModal(false);
    setCurrentEvent(null);
    setEventResult(null);
  };

  // Close the event modal
  const closeEventModal = () => {
    setShowEventModal(false);
    setCurrentEvent(null);
    setEventResult(null);
    setGameSpeed(1);
  };

  // Names for random guest generation - expanded list
  const firstNames = [
    "Alex",
    "Morgan",
    "Jordan",
    "Taylor",
    "Casey",
    "Riley",
    "Avery",
    "Quinn",
    "Blake",
    "Rowan",
    "Jamie",
    "Sam",
    "Chris",
    "Charlie",
    "Parker",
    "Robin",
    "Kendall",
    "Skyler",
    "Dakota",
    "Kerry",
  ];
  const lastNames = [
    "Smith",
    "Johnson",
    "Williams",
    "Brown",
    "Jones",
    "Miller",
    "Davis",
    "Garcia",
    "Rodriguez",
    "Wilson",
    "Chen",
    "Singh",
    "Nguyen",
    "Kim",
    "Patel",
    "Martinez",
    "Lee",
    "Wong",
    "Gonzalez",
    "Lopez",
  ];

  // Available room types
  const roomTypes = [
    {
      type: "Standard",
      baseCost: 5000,
      basePrice: 80,
      upkeep: 20,
      icon: <Bed className="w-4 h-4" />,
      description: "Basic comfortable room with essential amenities",
    },
    {
      type: "Deluxe",
      baseCost: 10000,
      basePrice: 150,
      upkeep: 35,
      icon: <Star className="w-4 h-4" />,
      description: "Spacious room with premium furnishings and city views",
    },
    {
      type: "Suite",
      baseCost: 20000,
      basePrice: 300,
      upkeep: 60,
      icon: <Home className="w-4 h-4" />,
      description:
        "Luxury suite with separate living area and premium services",
    },
    {
      type: "Executive",
      baseCost: 25000,
      basePrice: 400,
      upkeep: 80,
      icon: <Briefcase className="w-4 h-4" />,
      description: "Premium workspace, meeting area and executive benefits",
    },
    {
      type: "Penthouse",
      baseCost: 50000,
      basePrice: 800,
      upkeep: 120,
      icon: <Maximize className="w-4 h-4" />,
      description:
        "Ultra-luxury accommodation with panoramic views and butler service",
    },
  ];

  const facilityTypes = [
    {
      type: "Restaurant",
      baseCost: 15000,
      incomePerGuest: 40,
      upkeep: 200,
      icon: <Utensils className="w-4 h-4" />,
      description: "Earns good income and improves guest satisfaction",
      requiredStaff: ["Chef", "Bartender"],
    },
    {
      type: "Bar",
      baseCost: 8000,
      incomePerGuest: 100,
      upkeep: 150,
      icon: <Coffee className="w-4 h-4" />,
      description: "Affordable and provides steady income",
      requiredStaff: ["Bartender", "Sommelier"],
    },
    {
      type: "Spa",
      baseCost: 25000,
      incomePerGuest: 60,
      upkeep: 300,
      icon: <Heart className="w-4 h-4" />,
      description: "Expensive but generates high revenue and guest happiness",
      requiredStaff: ["Spa Therapist"],
    },
    {
      type: "Gym",
      baseCost: 12000,
      incomePerGuest: 15,
      upkeep: 100,
      icon: <Activity className="w-4 h-4" />,
      description: "Low maintenance and appeals to business travelers",
      requiredStaff: ["Fitness Instructor"],
    },
    {
      type: "Pool",
      baseCost: 20000,
      incomePerGuest: 30,
      upkeep: 250,
      icon: <Umbrella className="w-4 h-4" />,
      description: "Attractive to families and increases your hotel rating",
      requiredStaff: ["Maintenance", "Fitness Instructor"],
    },
    {
      type: "Conference Room",
      baseCost: 18000,
      incomePerGuest: 50,
      upkeep: 180,
      icon: <Users className="w-4 h-4" />,
      description: "Attracts business events and corporate clients",
      requiredStaff: ["Event Coordinator"],
    },
    {
      type: "Gift Shop",
      baseCost: 6000,
      incomePerGuest: 15,
      upkeep: 80,
      icon: <Gift className="w-4 h-4" />,
      description: "Low cost shop for guest souvenirs and essentials",
      requiredStaff: ["Receptionist"],
    },
    {
      type: "Casino",
      baseCost: 35000,
      incomePerGuest: 80,
      upkeep: 400,
      icon: <DollarSign className="w-4 h-4" />,
      description: "High risk, high reward entertainment venue",
      requiredStaff: ["Security", "Receptionist"],
    },
    {
      type: "Nightclub",
      baseCost: 30000,
      incomePerGuest: 70,
      upkeep: 350,
      icon: <Music className="w-4 h-4" />,
      description: "Evening entertainment that attracts guests and locals",
      requiredStaff: ["Bartender", "Security", "Singer"],
    },
    {
      type: "Rooftop Garden",
      baseCost: 10000,
      incomePerGuest: 10,
      upkeep: 120,
      icon: <Flower className="w-4 h-4" />,
      description:
        "Relaxing space that improves hotel ambiance and guest satisfaction",
      requiredStaff: ["Gardener", "Maintenance", "Concierge"],
    },
    {
      type: "Business Center",
      baseCost: 7500,
      incomePerGuest: 20,
      upkeep: 90,
      icon: <Printer className="w-4 h-4" />,
      description:
        "Work space with computers and printers for business travelers",
      requiredStaff: ["IT Specialist", "Receptionist"],
    },
    {
      type: "Kids Club",
      baseCost: 9000,
      incomePerGuest: 25,
      upkeep: 140,
      icon: <Smile className="w-4 h-4" />,
      description: "Childcare facility that makes your hotel family-friendly",
      requiredStaff: ["Receptionist", "Security"],
    },
    {
      type: "Art Gallery",
      baseCost: 15000,
      incomePerGuest: 35,
      upkeep: 110,
      icon: <Image className="w-4 h-4" />,
      description: "Cultural attraction that elevates your hotel's prestige",
      requiredStaff: ["Security", "Receptionist", "Maintenance"],
    },
    {
      type: "Pet Spa",
      baseCost: 8500,
      incomePerGuest: 40,
      upkeep: 130,
      icon: <Dog className="w-4 h-4" />,
      description: "Pet-friendly service that attracts animal-loving guests",
      requiredStaff: ["Receptionist", "Maintenance"],
    },
    {
      type: "Tennis Court",
      baseCost: 22000,
      incomePerGuest: 25,
      upkeep: 200,
      icon: <Disc className="w-4 h-4" />,
      description: "Outdoor activity that appeals to active and luxury guests",
      requiredStaff: ["Maintenance"],
    },
    {
      type: "Cigar Lounge",
      baseCost: 12000,
      incomePerGuest: 50,
      upkeep: 160,
      icon: <Minus className="w-4 h-4" />,
      description:
        "Upscale venue for guests seeking premium relaxation experiences",
      requiredStaff: ["Bartender", "Concierge"],
    },
    {
      type: "Movie Theater",
      baseCost: 28000,
      incomePerGuest: 35,
      upkeep: 220,
      icon: <Film className="w-4 h-4" />,
      description:
        "Entertainment option that keeps guests on property during evenings",
      requiredStaff: ["Receptionist"],
    },
    {
      type: "Library",
      baseCost: 5000,
      incomePerGuest: 5,
      upkeep: 60,
      icon: <Book className="w-4 h-4" />,
      description:
        "Low-cost amenity that improves guest satisfaction for intellectuals",
      requiredStaff: ["Receptionist"],
    },
    {
      type: "Gondola",
      baseCost: 40000, // Placeholder
      incomePerGuest: 60, // Placeholder
      upkeep: 300, // Placeholder
      icon: <Ship className="w-4 h-4" />,
      description: "Scenic transportation or experience for guests.", // Placeholder
      requiredStaff: ["Maintenance", "Receptionist"], // Placeholder - Could require an operator
    },
    {
      type: "Private Submarine Experience",
      baseCost: 100000, // Placeholder
      incomePerGuest: 200, // Placeholder
      upkeep: 1000, // Placeholder
      icon: <Fish className="w-4 h-4" />,
      description: "Exclusive underwater adventure for discerning guests.", // Placeholder
      requiredStaff: ["Maintenance", "Receptionist"], // Placeholder - Likely requires specialized staff
    },
    {
      type: "Rooftop Helipad & Skylounge",
      baseCost: 75000, // Placeholder
      incomePerGuest: 100, // Placeholder
      upkeep: 700, // Placeholder
      icon: <Plane className="w-4 h-4" />,
      description:
        "Luxury amenity with stunning views and potential for arrivals/departures.", // Placeholder
      requiredStaff: ["Bartender", "Security", "Receptionist"], // Placeholder
    },
  ];

  // Staff roles (Senior - Germany Salaries per Day in EUR)
  const staffRoles = [
    {
      role: "Receptionist",
      baseSalary: 220,
      effect: "guest happiness",
      icon: <User className="w-4 h-4" />,
      description: "Improves guest check-in experience and happiness",
    },
    {
      role: "Housekeeper",
      baseSalary: 200,
      effect: "room quality",
      icon: <CheckCircle className="w-4 h-4" />,
      description: "Maintains and improves room quality",
    },
    {
      role: "Chef",
      baseSalary: 300,
      effect: "restaurant quality",
      icon: <Utensils className="w-4 h-4" />,
      description: "Essential for restaurant operation and quality",
    },
    {
      role: "Manager",
      baseSalary: 400,
      effect: "overall efficiency",
      icon: <Briefcase className="w-4 h-4" />,
      description: "Improves overall hotel efficiency and staff happiness",
    },
    {
      role: "Concierge",
      baseSalary: 250,
      effect: "premium services",
      icon: <ThumbsUp className="w-4 h-4" />,
      description: "Provides personalized service for luxury guests",
    },
    {
      role: "Maintenance",
      baseSalary: 220,
      effect: "facility upkeep",
      icon: <PenTool className="w-4 h-4" />,
      description: "Reduces facility maintenance costs",
    },
    {
      role: "Security",
      baseSalary: 260,
      effect: "guest safety",
      icon: <Shield className="w-4 h-4" />,
      description: "Prevents incidents and improves hotel reputation",
    },
    {
      role: "Event Coordinator",
      baseSalary: 280,
      effect: "special events",
      icon: <Calendar className="w-4 h-4" />,
      description: "Organizes hotel events and increases facility usage",
    },
    {
      role: "Sommelier",
      baseSalary: 300,
      effect: "bar revenue",
      icon: <Wine className="w-4 h-4" />,
      description: "Enhances bar experience and increases beverage sales",
    },
    {
      role: "Valet",
      baseSalary: 180,
      effect: "arrival experience",
      icon: <Car className="w-4 h-4" />,
      description: "Improves guest arrival experience and first impressions",
    },
    {
      role: "IT Specialist",
      baseSalary: 320,
      effect: "technical systems",
      icon: <Monitor className="w-4 h-4" />,
      description:
        "Maintains hotel technology and improves operational efficiency",
    },
    {
      role: "Marketing Director",
      baseSalary: 350,
      effect: "guest acquisition",
      icon: <TrendingUp className="w-4 h-4" />,
      description: "Increases hotel visibility and attracts new guests",
    },
    {
      role: "Fitness Instructor",
      baseSalary: 210,
      effect: "gym experience",
      icon: <Activity className="w-4 h-4" />,
      description: "Enhances gym offering with classes and personal training",
    },
    {
      role: "Gardener",
      baseSalary: 190,
      effect: "grounds quality",
      icon: <Flower className="w-4 h-4" />,
      description: "Maintains hotel grounds and improves exterior appearance",
    },
    {
      role: "Guest Relations Manager",
      baseSalary: 300,
      effect: "guest loyalty",
      icon: <Star className="w-4 h-4" />,
      description: "Handles guest concerns and increases return visits",
    },
    {
      role: "Spa Therapist",
      baseSalary: 240,
      effect: "spa quality",
      icon: <Sunrise className="w-4 h-4" />,
      description: "Essential for spa operations and guest relaxation",
    },
    {
      role: "Bartender",
      baseSalary: 200,
      effect: "bar experience",
      icon: <Coffee className="w-4 h-4" />,
      description: "Crafts beverages and enhances social atmosphere in bars",
    },
    {
      role: "Sustainability Officer",
      baseSalary: 270,
      effect: "eco-friendly rating",
      icon: <Feather className="w-4 h-4" />,
      description:
        "Implements green initiatives and attracts eco-conscious guests",
    },
    {
      role: "Singer",
      baseSalary: 280,
      effect: "nightlife experience",
      icon: <Mic className="w-4 h-4" />,
      description:
        "Performs live music to enhance guest entertainment and bar revenue",
    },
  ];

  // Marketing campaigns
  const [marketingCampaigns, setMarketingCampaigns] = useState([
    {
      id: "local",
      name: "Local Advertising",
      cost: 500,
      duration: 5,
      effect: "increased_bookings",
      multiplier: 1.2,
      active: false,
      description: "Advertise locally to increase bookings by 20%",
    },
    {
      id: "social",
      name: "Social Media",
      cost: 1000,
      duration: 7,
      effect: "reputation_boost",
      boost: 0.2,
      active: false,
      description: "Boost your online presence to improve reputation",
    },
    {
      id: "discount",
      name: "Discount Promotion",
      cost: 800,
      duration: 3,
      effect: "price_sensitive",
      multiplier: 1.5,
      active: false,
      description: "Attract price-sensitive guests with special offers",
    },
    {
      id: "luxury",
      name: "Luxury Package",
      cost: 2000,
      duration: 10,
      effect: "high_end",
      multiplier: 1.3,
      active: false,
      description: "Target high-end guests willing to pay premium prices",
    },
    // NEW: Competitive marketing campaign
    {
      id: "competitive",
      name: "Competitive Marketing",
      cost: 3000,
      duration: 7,
      effect: "steal_guests",
      multiplier: 1.4,
      active: false,
      description: "Directly target customers of competing hotels",
    },
  ]);

  const [showSaveReminderModal, setShowSaveReminderModal] = useState(false);
  // Track if user is trying to navigate away
  const [isNavigatingAway, setIsNavigatingAway] = useState(false);

  // Staff training programs
  const [trainingPrograms, setTrainingPrograms] = useState([
    {
      id: "customer_service",
      name: "Customer Service",
      cost: 300,
      skillBoost: 0.5,
      happiness: 0.3,
      description: "Improve staff's ability to handle guest needs",
    },
    {
      id: "technical",
      name: "Technical Skills",
      cost: 400,
      skillBoost: 0.7,
      happiness: 0.1,
      description: "Enhance staff technical capabilities",
    },
    {
      id: "leadership",
      name: "Leadership Training",
      cost: 600,
      skillBoost: 0.4,
      happiness: 0.5,
      description: "Develop management skills for senior staff",
    },
  ]);

  // Hotel policies
  const [policies, setPolicies] = useState({
    petFriendly: false,
    earlyCheckin: false,
    lateCheckout: false,
    freeCancellation: false,
    breakfastIncluded: false,
  });

  // Seasons affect booking rates and guest preferences
  const [currentSeason, setCurrentSeason] = useState("summer");

  const [notifications, setNotifications] = useState([]);
  const [processedEvents, setProcessedEvents] = useState(new Set());

  useEffect(() => {
    // Season changes every 90 days
    const seasonDay = day % 360;
    let newSeason;

    if (seasonDay < 90) newSeason = "spring";
    else if (seasonDay < 180) newSeason = "summer";
    else if (seasonDay < 270) newSeason = "autumn";
    else newSeason = "winter";

    if (newSeason !== currentSeason) {
      setCurrentSeason(newSeason);
      addNotification(
        `Season has changed to ${
          newSeason.charAt(0).toUpperCase() + newSeason.slice(1)
        }. Guest preferences will change.`,
        true
      );
    }
  }, [day, currentSeason]);

  const restartGame = () => {
    // This will completely reload the page, resetting everything
    window.location.reload();
    localStorage.removeItem("hotelTycoonNotifications");

    // Note: The code below won't execute because the page will refresh
    console.log("Page refreshed");
  };

  const handleRefreshPage = () => {
    // If we have progressed in the game, show the save reminder
    if (day > 1) {
      setShowSaveReminderModal(true);
      setPendingReload(true);
    } else {
      // If day is still 1, just reload without warning
      localStorage.removeItem("hotelTycoonNotifications");
      setNotifications([]);
      window.location.reload();
    }
  };

  useEffect(() => {
    // Handler function for beforeunload event
    const handleBeforeUnload = (e) => {
      // Only show confirmation if the game has progressed beyond day 1
      if (day > 1) {
        // This displays browser's built-in confirmation
        const message =
          "You have unsaved game progress. Are you sure you want to leave?";
        e.preventDefault();
        e.returnValue = message;

        // Also show our custom modal
        setShowSaveReminderModal(true);
        setIsNavigatingAway(true);

        return message;
      }
    };

    // Add event listener when component mounts
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Remove event listener when component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [day]); // Depend on day so we only show the warning if the game has actually been played

  // Random events that can occur - expanded list
  const randomEvents = [
    {
      id: "viralBadReview",
      title: "Viral Bad Review",
      description:
        "A scathing review of your hotel has gone viral on social media!",
      icon: <ThumbsDown className="w-4 h-4" />,
      effect: () => {
        // Massive reputation hit
        const reputationDamage = 0.8 + Math.random() * 1.0; // 0.8-1.8 stars lost
        setReputation((prev) => Math.max(1, prev - reputationDamage));

        // Cancellations and drop in bookings
        const cancelledRooms = [];
        rooms.forEach((room) => {
          if (room.occupied && Math.random() < 0.25) {
            // 25% of guests leave
            cancelledRooms.push(room.id);
          }
        });

        // Process cancellations
        setRooms((prev) =>
          prev.map((room) =>
            cancelledRooms.includes(room.id)
              ? { ...room, occupied: false, guest: null }
              : room
          )
        );

        setGuests((prev) =>
          prev.filter((guest) => !cancelledRooms.includes(guest.roomId))
        );

        // Market share drop
        setMarketShare((prev) => Math.max(5, prev - 15));

        // Damage control costs - marketing to counter the bad press
        const marketingCosts = 5000 + Math.floor(Math.random() * 10000);
        setMoney((prev) => prev - marketingCosts);

        return `Viral bad review disaster! Reputation dropped by ${reputationDamage.toFixed(
          1
        )} stars, ${
          cancelledRooms.length
        } guests left, and $${marketingCosts} spent on damage control.`;
      },
    },
    {
      id: "staffEmbezzlement",
      title: "Staff Embezzlement",
      description:
        "One of your managers has been caught embezzling funds from the hotel!",
      icon: <UserMinus className="w-4 h-4" />,
      effect: () => {
        // Calculate amount stolen based on hotel size and revenue
        const baseAmount = 10000;
        const roomFactor = rooms.length * 500;
        const moneyFactor = Math.floor(money * 0.05); // 5% of current money

        const stolenAmount = baseAmount + roomFactor + moneyFactor;
        setMoney((prev) => Math.max(0, prev - stolenAmount));

        // Fire the manager
        let managerFired = false;
        setStaff((prev) => {
          const managers = prev.filter(
            (employee) => employee.role === "Manager"
          );
          if (managers.length > 0) {
            managerFired = true;
            const managerToFire =
              managers[Math.floor(Math.random() * managers.length)];
            return prev.filter((employee) => employee.id !== managerToFire.id);
          }
          return prev;
        });

        // Reputation damage
        setReputation((prev) => Math.max(1, prev - 0.5));

        // Other staff morale hit
        setStaff((prev) =>
          prev.map((employee) => ({
            ...employee,
            happiness: Math.max(1, employee.happiness - 1),
          }))
        );

        return `Staff embezzlement scandal! $${stolenAmount.toLocaleString()} stolen${
          managerFired ? ", manager fired" : ""
        }, and staff morale has decreased.`;
      },
    },
    {
      id: "massStaffResignation",
      title: "Mass Staff Resignation",
      description:
        "Several staff members have resigned at once, leaving you critically understaffed!",
      icon: <Users className="w-4 h-4" />,
      effect: () => {
        // Determine number of staff to resign (20-40% of staff)
        const resignationCount = Math.max(
          1,
          Math.floor(staff.length * (0.2 + Math.random() * 0.2))
        );
        const remainingCount = staff.length - resignationCount;

        // Keep the most essential staff if possible
        let staffToKeep = [];
        if (remainingCount > 0) {
          // Sort by importance - this simple algorithm keeps management and reception if possible
          const priorityRoles = ["Manager", "Receptionist", "Housekeeper"];

          // First add priority roles
          staff.forEach((employee) => {
            if (
              priorityRoles.includes(employee.role) &&
              staffToKeep.length < remainingCount
            ) {
              staffToKeep.push(employee.id);
            }
          });

          // Then fill remaining spots with random staff
          const nonPriorityStaff = staff.filter(
            (employee) =>
              !priorityRoles.includes(employee.role) &&
              !staffToKeep.includes(employee.id)
          );

          while (
            staffToKeep.length < remainingCount &&
            nonPriorityStaff.length > 0
          ) {
            const randomIndex = Math.floor(
              Math.random() * nonPriorityStaff.length
            );
            staffToKeep.push(nonPriorityStaff[randomIndex].id);
            nonPriorityStaff.splice(randomIndex, 1);
          }
        }

        // Process resignations
        setStaff((prev) =>
          prev.filter((employee) => staffToKeep.includes(employee.id))
        );

        // Operational impact - some rooms can't be maintained
        const unmaintainableRooms = Math.max(
          0,
          rooms.length - staffToKeep.length * 5
        );
        if (unmaintainableRooms > 0) {
          setRooms((prev) => {
            // Mark some rooms as under maintenance due to staff shortage
            const roomsToClose = prev
              .slice(0, unmaintainableRooms)
              .map((room) => room.id);

            return prev.map((room) => {
              if (roomsToClose.includes(room.id)) {
                return {
                  ...room,
                  underMaintenance: true,
                  occupied: false,
                  guest: null,
                };
              }
              return room;
            });
          });

          // Remove guests from unmaintainable rooms
          setGuests((prev) =>
            prev.filter((guest) => {
              const room = rooms.find((r) => r.id === guest.roomId);
              return room && !room.underMaintenance;
            })
          );
        }

        // Hiring costs to replace staff quickly
        const emergencyHiringCosts = resignationCount * 1000;
        setMoney((prev) => prev - emergencyHiringCosts);

        // Reputation damage
        setReputation((prev) => Math.max(1, prev - 0.7));

        return `Mass staff resignation! ${resignationCount} staff quit${
          unmaintainableRooms > 0
            ? `, ${unmaintainableRooms} rooms had to be closed`
            : ""
        }, and emergency hiring costs $${emergencyHiringCosts}.`;
      },
    },
    {
      id: "hotelRankingDemoted",
      title: "Hotel Rating Demoted",
      description:
        "The official hotel star rating agency has demoted your hotel's star rating!",
      icon: <BadgeAlert className="w-4 h-4" />,
      effect: () => {
        // Major reputation hit
        const reputationDamage = 1.0 + Math.random() * 0.5; // 1.0-1.5 stars lost
        setReputation((prev) => Math.max(1, prev - reputationDamage));

        // Need to lower prices due to demotion
        setRooms((prev) =>
          prev.map((room) => ({
            ...room,
            price: Math.round(room.price * 0.7), // 30% price reduction
          }))
        );

        // Count occupied rooms first to make sure we have guests
        const occupiedRooms = rooms.filter((room) => room.occupied);
        const totalOccupied = occupiedRooms.length;

        // If no occupied rooms, we can't have cancellations
        if (totalOccupied === 0) {
          // Market share collapse still happens
          setMarketShare((prev) => Math.max(5, prev - 20));

          // Renovation costs to try to regain status
          const renovationCosts = 20000 + Math.floor(Math.random() * 30000);
          setMoney((prev) => prev - renovationCosts);

          return `Hotel rating demoted! Reputation dropped by ${reputationDamage.toFixed(
            1
          )} stars. With no current guests, you still need $${renovationCosts} for renovations to regain status.`;
        }

        // Ensure at least some cancellations if we have guests
        // Minimum number of cancellations - at least 30% of rooms or 1, whichever is higher
        const minCancellations = Math.max(1, Math.ceil(totalOccupied * 0.3));

        // Cancellations from prestige-conscious guests
        const cancelledRooms = [];

        // First pass: try natural cancellations based on room type
        occupiedRooms.forEach((room) => {
          // More likely to cancel in higher-tier rooms
          const isSuite =
            room.type === "Suite" ||
            room.type === "Executive" ||
            room.type === "Penthouse";
          const cancelProb = isSuite ? 0.8 : 0.5; // Higher probabilities to ensure cancellations

          if (Math.random() < cancelProb) {
            cancelledRooms.push(room.id);
          }
        });

        // Second pass: if we didn't get enough cancellations, force some
        if (cancelledRooms.length < minCancellations) {
          const remainingRooms = occupiedRooms
            .filter((room) => !cancelledRooms.includes(room.id))
            .map((room) => room.id);

          // Shuffle the remaining rooms
          const shuffled = [...remainingRooms].sort(() => 0.5 - Math.random());

          // Add rooms until we reach minimum cancellations
          for (
            let i = 0;
            i < minCancellations - cancelledRooms.length && i < shuffled.length;
            i++
          ) {
            cancelledRooms.push(shuffled[i]);
          }
        }

        // Process cancellations
        setRooms((prev) =>
          prev.map((room) =>
            cancelledRooms.includes(room.id)
              ? { ...room, occupied: false, guest: null }
              : room
          )
        );

        setGuests((prev) =>
          prev.filter((guest) => !cancelledRooms.includes(guest.roomId))
        );

        // Market share collapse
        setMarketShare((prev) => Math.max(5, prev - 20));

        // Renovation costs to try to regain status
        const renovationCosts = 20000 + Math.floor(Math.random() * 30000);
        setMoney((prev) => prev - renovationCosts);

        return `Hotel rating demoted! Reputation dropped by ${reputationDamage.toFixed(
          1
        )} stars, ${
          cancelledRooms.length
        } guests cancelled, and $${renovationCosts} needed for renovations to regain status.`;
      },
    },
    {
      id: "organizedCrimeThreat",
      title: "Organized Crime Threat",
      description:
        "An organized crime syndicate is demanding 'protection money' from your hotel!",
      icon: <Skull className="w-4 h-4" />,
      effect: () => {
        // Calculate demand based on hotel's size and wealth
        const baseDemand = 15000;
        const wealthFactor = Math.floor(money * 0.08); // 8% of current money
        const demandAmount = baseDemand + wealthFactor;

        // You can either pay or face consequences
        const payUp = money >= demandAmount && Math.random() < 0.5;

        if (payUp) {
          // Pay the protection money
          setMoney((prev) => prev - demandAmount);
          return `You paid the crime syndicate $${demandAmount.toLocaleString()} in protection money to avoid trouble.`;
        } else {
          // Face severe consequences

          // Property damage
          let damagedRooms = 0;
          setRooms((prev) => {
            return prev.map((room) => {
              if (Math.random() < 0.3) {
                // 30% of rooms damaged
                damagedRooms++;
                return {
                  ...room,
                  quality: Math.max(1, room.quality - 1),
                  occupied: false,
                  guest: null,
                  underMaintenance: true,
                };
              }
              return room;
            });
          });

          // Staff intimidation - some quit
          let staffQuit = 0;
          setStaff((prev) => {
            const remainingStaff = prev.filter(() => {
              if (Math.random() < 0.2) {
                // 20% quit
                staffQuit++;
                return false;
              }
              return true;
            });
            return remainingStaff;
          });

          // All guests leave due to safety concerns
          const guestsLeft = guests.length;
          setGuests([]);

          // All rooms vacated
          setRooms((prev) =>
            prev.map((room) => ({
              ...room,
              occupied: false,
              guest: null,
            }))
          );

          // Massive reputation damage
          setReputation((prev) => Math.max(1, prev - 2.0));

          // Market share collapse
          setMarketShare((prev) => Math.max(5, prev - 25));

          return `Crime syndicate attack! ${damagedRooms} rooms damaged, ${staffQuit} staff quit in fear, all ${guestsLeft} guests fled, and reputation severely damaged.`;
        }
      },
    },
    {
      id: "foodPoisoning",
      title: "Food Poisoning Outbreak",
      description:
        "Several guests have become ill from food poisoning in your hotel restaurant!",
      icon: <ShieldAlert className="w-4 h-4" />,
      effect: () => {
        // Check if hotel has a restaurant
        const hasRestaurant = facilities.some(
          (facility) => facility.name === "Restaurant"
        );

        if (!hasRestaurant) {
          // If no restaurant, less severe event
          return "Health inspectors investigated a food poisoning report, but found no restaurant on premises. Inspection passed.";
        }

        // Number of affected guests
        const affectedGuests = Math.ceil(guests.length * 0.4); // 40% of guests affected

        // Legal settlements and medical costs
        const compensationPerGuest = 2000 + Math.floor(Math.random() * 3000);
        const totalCompensation = affectedGuests * compensationPerGuest;
        setMoney((prev) => prev - totalCompensation);

        // All current guests check out
        setRooms((prev) =>
          prev.map((room) => ({
            ...room,
            occupied: false,
            guest: null,
          }))
        );

        setGuests([]);

        // Shut down restaurant temporarily
        setFacilities((prev) =>
          prev.map((facility) => {
            if (facility.name === "Restaurant") {
              return {
                ...facility,
                level: Math.max(1, facility.level - 1), // Downgrade restaurant level
              };
            }
            return facility;
          })
        );

        // Severe reputation hit
        setReputation((prev) => Math.max(1, prev - 1.5));

        // Market share collapse
        setMarketShare((prev) => Math.max(5, prev - 15));

        return `Food poisoning outbreak! ${affectedGuests} guests affected, $${totalCompensation.toLocaleString()} paid in compensation, restaurant temporarily closed, and reputation severely damaged.`;
      },
    },
    {
      id: "staffDrugScandal",
      title: "Staff Drug Scandal",
      description:
        "Several staff members have been caught using drugs on hotel premises!",
      icon: <UserX className="w-4 h-4" />,
      effect: () => {
        // Determine how many staff involved
        const staffInvolved = Math.max(1, Math.floor(staff.length * 0.2)); // 20% of staff

        // Fire the involved staff
        setStaff((prev) => {
          const staffIds = prev.map((employee) => employee.id);
          const shuffled = [...staffIds].sort(() => 0.5 - Math.random());
          const staffToFire = shuffled.slice(0, staffInvolved);

          return prev.filter((employee) => !staffToFire.includes(employee.id));
        });

        // Legal costs and fines
        const legalCosts = 5000 + staffInvolved * 2000;
        setMoney((prev) => prev - legalCosts);

        // Reputation damage
        setReputation((prev) => Math.max(1, prev - 1.0));

        // Some guests leave due to scandal
        const cancelledRooms = [];
        rooms.forEach((room) => {
          if (room.occupied && Math.random() < 0.3) {
            // 30% chance of each guest leaving
            cancelledRooms.push(room.id);
          }
        });

        // Process cancellations
        setRooms((prev) =>
          prev.map((room) =>
            cancelledRooms.includes(room.id)
              ? { ...room, occupied: false, guest: null }
              : room
          )
        );

        setGuests((prev) =>
          prev.filter((guest) => !cancelledRooms.includes(guest.roomId))
        );

        return `Staff drug scandal! ${staffInvolved} staff fired, $${legalCosts} in legal costs, and ${cancelledRooms.length} guests left due to the scandal.`;
      },
    },
    {
      id: "healthInspectionFailure",
      title: "Critical Health Inspection Failure",
      description:
        "Your hotel has catastrophically failed a surprise health inspection!",
      icon: <Glasses className="w-4 h-4" />,
      effect: () => {
        // Massive fine
        const baseFine = 10000;
        const perRoomFine = 500 * rooms.length;
        const totalFine = baseFine + perRoomFine;
        setMoney((prev) => prev - totalFine);

        // Forced closure of facilities
        let facilityClosed = false;
        setFacilities((prev) => {
          const facilitiesToCheck = prev.filter(
            (f) =>
              f.name === "Restaurant" || f.name === "Bar" || f.name === "Spa"
          );

          if (facilitiesToCheck.length > 0) {
            facilityClosed = true;
            // Choose one facility to close
            const facilityToClose =
              facilitiesToCheck[
                Math.floor(Math.random() * facilitiesToCheck.length)
              ];

            return prev.filter((f) => f.id !== facilityToClose.id);
          }

          return prev;
        });

        // Forced room closures
        const roomsToClose = Math.ceil(rooms.length * 0.4); // 40% of rooms
        let closedRooms = 0;

        setRooms((prev) => {
          return prev.map((room, index) => {
            if (index < roomsToClose) {
              closedRooms++;
              return {
                ...room,
                underMaintenance: true,
                occupied: false,
                guest: null,
              };
            }
            return room;
          });
        });

        // Remove guests from closed rooms
        setGuests((prev) =>
          prev.filter((guest) => {
            const room = rooms.find((r) => r.id === guest.roomId);
            return room && !room.underMaintenance;
          })
        );

        // Severe reputation hit
        setReputation((prev) => Math.max(1, prev - 2.0));

        // Market share collapse
        setMarketShare((prev) => Math.max(5, prev - 20));

        // Renovation costs to fix issues
        const renovationCosts = roomsToClose * 5000;
        setMoney((prev) => prev - renovationCosts);

        return `Critical health inspection failure! $${totalFine.toLocaleString()} in fines, ${closedRooms} rooms forcibly closed${
          facilityClosed ? ", a facility was shut down" : ""
        }, and $${renovationCosts} needed for mandatory renovations.`;
      },
    },
    {
      id: "securityBreach",
      title: "Major Security Breach",
      description: "A serious security incident has occurred at your hotel!",
      icon: <ShieldX className="w-4 h-4" />,
      effect: () => {
        // Security incident type (random)
        const incidentTypes = [
          "armed robbery",
          "guest assault",
          "major theft ring",
          "staff assault",
        ];
        const incidentType =
          incidentTypes[Math.floor(Math.random() * incidentTypes.length)];

        // All guests check out immediately
        const guestsLeft = guests.length;
        setGuests([]);

        // All rooms vacated
        setRooms((prev) =>
          prev.map((room) => ({
            ...room,
            occupied: false,
            guest: null,
          }))
        );

        // Compensation and legal costs
        const baseCosts = 20000;
        const perGuestCosts = guestsLeft * 2000;
        const totalCosts = baseCosts + perGuestCosts;
        setMoney((prev) => prev - totalCosts);

        // Massive reputation damage
        setReputation((prev) => Math.max(1, prev - 2.5));

        // Market share collapses
        setMarketShare((prev) => Math.max(5, prev - 30));

        // Need to hire security staff
        const securityCosts = 10000;
        setMoney((prev) => prev - securityCosts);

        // Force hire security if none exists
        let securityHired = false;
        if (!staff.some((employee) => employee.role === "Security")) {
          securityHired = true;
          // Add security guard
          setStaff((prev) => [
            ...prev,
            {
              id: Date.now(),
              name: "Security Guard",
              role: "Security",
              salary: 150,
              skill: 3,
              happiness: 3,
            },
          ]);
        }

        return `Major ${incidentType} incident! All ${guestsLeft} guests evacuated, $${totalCosts.toLocaleString()} in compensation and legal fees${
          securityHired ? ", and security staff hired" : ""
        }. Reputation severely damaged.`;
      },
    },
    {
      id: "celebrityScandal",
      title: "Celebrity Scandal",
      description:
        "A famous celebrity caused a major scandal while staying at your hotel!",
      icon: <AlertOctagon className="w-4 h-4" />,
      effect: () => {
        // Determine scandal type (random)
        const scandalTypes = [
          "drug overdose",
          "property destruction",
          "violent altercation",
          "leaked inappropriate photos",
        ];
        const scandalType =
          scandalTypes[Math.floor(Math.random() * scandalTypes.length)];

        // Reputation impact - can be positive or negative depending on publicity
        // 30% chance it's actually good publicity (all publicity is good publicity)
        const isGoodPublicity = Math.random() < 0.3;

        if (isGoodPublicity) {
          // Good publicity - boost reputation
          const reputationBoost = 0.5 + Math.random() * 1.0;
          setReputation((prev) => Math.min(5, prev + reputationBoost));

          // Market share boost
          setMarketShare((prev) => Math.min(90, prev + 10));

          // Generate a surge of curiosity-seekers
          const extraGuests = 5 + Math.floor(Math.random() * 10);
          for (let i = 0; i < extraGuests; i++) {
            setTimeout(() => generateNewGuests(true), i * 100);
          }

          return `Celebrity ${scandalType} scandal brought positive publicity! Reputation increased by ${reputationBoost.toFixed(
            1
          )} stars and ${extraGuests} new potential guests are flocking to your hotel.`;
        } else {
          // Bad publicity - damage control needed

          // Reputation damage
          const reputationDamage = 0.8 + Math.random() * 1.2;
          setReputation((prev) => Math.max(1, prev - reputationDamage));

          // PR and damage control costs
          const damageCosts = 10000 + Math.floor(Math.random() * 20000);
          setMoney((prev) => prev - damageCosts);

          // Some rooms damaged
          let damagedRooms = 0;
          if (scandalType === "property destruction") {
            // More room damage for property destruction scandal
            setRooms((prev) => {
              return prev.map((room) => {
                if (Math.random() < 0.2) {
                  // 20% of rooms
                  damagedRooms++;
                  return {
                    ...room,
                    quality: Math.max(1, room.quality - 1),
                    underMaintenance: true,
                  };
                }
                return room;
              });
            });
          }

          // Cancellations
          const cancelledRooms = [];
          rooms.forEach((room) => {
            if (room.occupied && Math.random() < 0.4) {
              // 40% chance of each guest leaving
              cancelledRooms.push(room.id);
            }
          });

          // Process cancellations
          setRooms((prev) =>
            prev.map((room) =>
              cancelledRooms.includes(room.id)
                ? { ...room, occupied: false, guest: null }
                : room
            )
          );

          setGuests((prev) =>
            prev.filter((guest) => !cancelledRooms.includes(guest.roomId))
          );

          return `Celebrity ${scandalType} scandal brought negative publicity! Reputation dropped by ${reputationDamage.toFixed(
            1
          )}, ${cancelledRooms.length} guests left${
            damagedRooms > 0 ? `, ${damagedRooms} rooms damaged` : ""
          }, and $${damageCosts} spent on PR damage control.`;
        }
      },
    },
    {
      id: "hurricane",
      title: "Hurricane Warning",
      description:
        "A major hurricane is approaching the area! You need to prepare and may lose guests.",
      icon: <CloudLightning className="w-4 h-4" />,
      effect: () => {
        // Massive cancellations and property damage
        const cancelledRooms = [];
        rooms.forEach((room) => {
          if (room.occupied && Math.random() < 0.7) {
            // 70% of guests cancel
            cancelledRooms.push(room.id);
          }
        });

        // Process cancellations
        setRooms((prev) =>
          prev.map((room) => {
            if (cancelledRooms.includes(room.id)) {
              return { ...room, occupied: false, guest: null };
            }

            // Damage some rooms (even if not occupied)
            if (Math.random() < 0.3) {
              // 30% of rooms damaged
              return {
                ...room,
                quality: Math.max(1, room.quality - Math.random() * 2),
                underMaintenance: Math.random() < 0.5, // 50% of damaged rooms need maintenance
              };
            }

            return room;
          })
        );

        // Remove guests from cancelled rooms
        setGuests((prev) =>
          prev.filter((guest) => !cancelledRooms.includes(guest.roomId))
        );

        // Damage to facilities
        setFacilities((prev) =>
          prev.map((facility) => {
            if (facility.name === "Lobby") return facility; // Can't damage the lobby

            if (Math.random() < 0.2) {
              // 20% chance to damage each facility
              return {
                ...facility,
                level: Math.max(1, facility.level - 1),
              };
            }
            return facility;
          })
        );

        // Emergency expenses for preparations and repairs
        const emergencyCost = 5000 + Math.floor(Math.random() * 10000);
        setMoney((prev) => prev - emergencyCost);

        // Reputation hit (people remember how you handled the crisis)
        setReputation((prev) => Math.max(1, prev - 0.5));

        return `Hurricane disaster! ${cancelledRooms.length} bookings cancelled, rooms and facilities damaged. Emergency costs: $${emergencyCost}.`;
      },
    },
    {
      id: "tornado",
      title: "Tornado Damage",
      description:
        "A tornado has hit the area and caused significant damage to your hotel!",
      icon: <Wind className="w-4 h-4" />,
      effect: () => {
        // Even more devastating than hurricane
        // Destroy a few rooms completely (they'll need to be rebuilt)
        const totalRooms = rooms.length;
        const roomsToDestroy = Math.max(1, Math.floor(totalRooms * 0.15)); // Destroy up to 15% of rooms

        const destroyedRoomIds = [];
        for (let i = 0; i < roomsToDestroy; i++) {
          // Try to select unoccupied rooms first
          const availableRooms = rooms.filter(
            (r) => !r.occupied && !destroyedRoomIds.includes(r.id)
          );
          if (availableRooms.length > 0) {
            const randomRoom =
              availableRooms[Math.floor(Math.random() * availableRooms.length)];
            destroyedRoomIds.push(randomRoom.id);
          } else {
            // If no unoccupied rooms, might have to destroy occupied ones
            const occupiedRooms = rooms.filter(
              (r) => r.occupied && !destroyedRoomIds.includes(r.id)
            );
            if (occupiedRooms.length > 0) {
              const randomRoom =
                occupiedRooms[Math.floor(Math.random() * occupiedRooms.length)];
              destroyedRoomIds.push(randomRoom.id);
            }
          }
        }

        // Remove destroyed rooms
        setRooms((prev) =>
          prev.filter((room) => !destroyedRoomIds.includes(room.id))
        );

        // Evacuate guests from destroyed rooms
        setGuests((prev) =>
          prev.filter((guest) => !destroyedRoomIds.includes(guest.roomId))
        );

        // Destroy a facility
        let destroyedFacility = null;
        setFacilities((prev) => {
          const facilitiesToKeep = prev.filter((f) => f.name === "Lobby"); // Always keep the lobby
          const facilitiesThatCouldBeDestroyed = prev.filter(
            (f) => f.name !== "Lobby"
          );

          if (facilitiesThatCouldBeDestroyed.length > 0) {
            const index = Math.floor(
              Math.random() * facilitiesThatCouldBeDestroyed.length
            );
            destroyedFacility = facilitiesThatCouldBeDestroyed[index];
            return [
              ...facilitiesToKeep,
              ...facilitiesThatCouldBeDestroyed.filter((_, i) => i !== index),
            ];
          }

          return prev;
        });

        // Massive emergency expenses
        const emergencyCost = 20000 + Math.floor(Math.random() * 30000);
        setMoney((prev) => prev - emergencyCost);

        // Severe reputation hit
        setReputation((prev) => Math.max(1, prev - 1.0));

        return `Tornado disaster! ${
          destroyedRoomIds.length
        } rooms completely destroyed${
          destroyedFacility
            ? ` and your ${destroyedFacility.name} was destroyed`
            : ""
        }. Emergency costs: $${emergencyCost}.`;
      },
    },
    {
      id: "dataBreachScandal",
      title: "Data Breach Scandal",
      description:
        "Your hotel's guest data has been compromised in a cyber attack!",
      icon: <Fingerprint className="w-4 h-4" />,
      effect: () => {
        // Huge reputation damage
        const reputationDamage = 1.0 + Math.random() * 1.0; // 1.0-2.0 stars lost
        setReputation((prev) => Math.max(1, prev - reputationDamage));

        // Legal fees and compensations
        const legalCosts = 20000 + Math.floor(Math.random() * 80000); // $20k-$100k
        setMoney((prev) => prev - legalCosts);

        // Mass cancellations
        const cancellationRate = 0.5 + Math.random() * 0.3; // 50-80% cancellation
        const cancelledRooms = [];

        rooms.forEach((room) => {
          if (room.occupied && Math.random() < cancellationRate) {
            cancelledRooms.push(room.id);
          }
        });

        // Process cancellations
        setRooms((prev) =>
          prev.map((room) =>
            cancelledRooms.includes(room.id)
              ? { ...room, occupied: false, guest: null }
              : room
          )
        );

        setGuests((prev) =>
          prev.filter((guest) => !cancelledRooms.includes(guest.roomId))
        );

        // Long-term market share impact
        setMarketShare((prev) => Math.max(5, prev - 20));

        return `Data breach scandal! Your reputation dropped by ${reputationDamage.toFixed(
          1
        )} stars, ${
          cancelledRooms.length
        } bookings cancelled, and $${legalCosts} in legal costs.`;
      },
    },
    {
      id: "taxEvasionInvestigation",
      title: "Tax Evasion Investigation",
      description: "Your hotel is being investigated for possible tax evasion!",
      icon: <FileWarning className="w-4 h-4" />,
      effect: () => {
        // This is a major financial hit for wealthy players
        // Calculate penalty based on wealth - the more money they have, the bigger the hit
        let taxPenalty = 0;

        if (money > 1000000) {
          // Millionaires get hit hard
          taxPenalty = money * 0.4; // 40% of their fortune
        } else if (money > 500000) {
          taxPenalty = money * 0.3; // 30% of their fortune
        } else if (money > 100000) {
          taxPenalty = money * 0.25; // 25% of their fortune
        } else {
          taxPenalty = money * 0.2; // 20% of their fortune
        }

        taxPenalty = Math.floor(taxPenalty);
        setMoney((prev) => prev - taxPenalty);

        // Reputation damage
        setReputation((prev) => Math.max(1, prev - 1.5));

        // Some staff might resign
        const staffToResign = [];
        staff.forEach((employee) => {
          // More skilled/ethical employees are more likely to leave
          if (employee.skill > 3 && Math.random() < 0.4) {
            staffToResign.push(employee.id);
          }
        });

        if (staffToResign.length > 0) {
          setStaff((prev) =>
            prev.filter((employee) => !staffToResign.includes(employee.id))
          );
        }

        return `Tax evasion investigation! You've been fined $${taxPenalty.toLocaleString()}, reputation severely damaged${
          staffToResign.length > 0
            ? `, and ${staffToResign.length} staff members resigned in protest`
            : ""
        }.`;
      },
    },
    {
      id: "flooding",
      title: "Severe Flooding",
      description: "Heavy rains have caused flooding in and around your hotel!",
      icon: <Droplets className="w-4 h-4" />,
      effect: () => {
        // Damage to ground floor rooms and facilities
        let damagedRoomCount = 0;

        // Damage rooms (especially ground floor ones)
        setRooms((prev) => {
          return prev.map((room, index) => {
            // Assume earlier rooms are on lower floors
            const floorProbability = Math.min(
              0.9,
              0.7 - (index / prev.length) * 0.5
            );

            if (Math.random() < floorProbability) {
              damagedRoomCount++;
              return {
                ...room,
                quality: Math.max(1, room.quality - 1),
                occupied: false, // Force evacuation
                guest: null,
                underMaintenance: true,
              };
            }
            return room;
          });
        });

        // Remove guests from damaged rooms
        setGuests((prev) =>
          prev.filter((guest) => {
            const room = rooms.find((r) => r.id === guest.roomId);
            return room && !room.underMaintenance;
          })
        );

        // Damage to facilities
        let damagedFacilities = 0;
        setFacilities((prev) => {
          return prev.map((facility) => {
            if (facility.name !== "Lobby" && Math.random() < 0.4) {
              damagedFacilities++;
              return {
                ...facility,
                level: Math.max(1, facility.level - 1),
              };
            }
            return facility;
          });
        });

        // Repair costs
        const repairCosts =
          10000 + damagedRoomCount * 2000 + damagedFacilities * 5000;
        setMoney((prev) => prev - repairCosts);

        return `Severe flooding! ${damagedRoomCount} rooms and ${damagedFacilities} facilities damaged. Repairs will cost $${repairCosts}.`;
      },
    },
    {
      id: "powerOutage",
      title: "Extended Power Outage",
      description:
        "A major power outage is affecting the entire area, including your hotel!",
      icon: <Zap className="w-4 h-4" />,
      effect: () => {
        // Everyone checks out, no new bookings during outage
        const affectedGuests = guests.length;

        // Force checkout of all guests
        setRooms((prev) =>
          prev.map((room) => ({
            ...room,
            occupied: false,
            guest: null,
          }))
        );

        setGuests([]);

        // Emergency generator costs
        const generatorCosts = 5000 + Math.floor(Math.random() * 5000);
        setMoney((prev) => prev - generatorCosts);

        // Reputation hit
        setReputation((prev) => Math.max(1, prev - 0.7));

        // Market share hit
        setMarketShare((prev) => Math.max(5, prev - 5));

        return `Extended power outage! All ${affectedGuests} guests had to check out. Emergency generator costs: $${generatorCosts}.`;
      },
    },
    {
      id: "fire",
      title: "Hotel Fire",
      description:
        "A fire has broken out in your hotel! Damage control is needed immediately.",
      icon: <Flame className="w-4 h-4" />,
      effect: () => {
        // One of the most devastating events
        // Determine which section of the hotel is affected
        const fireLocation = Math.random();
        let affectedRooms = [];
        let destroyedFacility = null;

        if (fireLocation < 0.7) {
          // 70% chance fire affects guest rooms
          // Identify a "section" of rooms (simulate a wing or floor being damaged)
          const startingIndex = Math.floor(
            Math.random() * (rooms.length * 0.7)
          );
          const roomsAffected = Math.max(1, Math.ceil(rooms.length * 0.2)); // At least 20% of rooms

          for (let i = 0; i < roomsAffected; i++) {
            const roomIndex = (startingIndex + i) % rooms.length;
            affectedRooms.push(rooms[roomIndex].id);
          }

          // Process room damage - some rooms destroyed, others damaged
          setRooms((prev) => {
            return prev.map((room) => {
              if (affectedRooms.includes(room.id)) {
                if (Math.random() < 0.4) {
                  // 40% of affected rooms are completely destroyed
                  return {
                    ...room,
                    quality: 0, // Marked for removal
                    occupied: false,
                    guest: null,
                  };
                } else {
                  return {
                    ...room,
                    quality: Math.max(1, room.quality - 2),
                    occupied: false,
                    guest: null,
                    underMaintenance: true,
                  };
                }
              }
              return room;
            });
          });

          // Remove completely destroyed rooms
          setRooms((prev) => prev.filter((room) => room.quality > 0));
        } else {
          // 30% chance fire affects a facility
          setFacilities((prev) => {
            const facilitiesToDestroy = prev.filter((f) => f.name !== "Lobby");
            if (facilitiesToDestroy.length > 0) {
              const index = Math.floor(
                Math.random() * facilitiesToDestroy.length
              );
              destroyedFacility = facilitiesToDestroy[index];
              return prev.filter((f) => f.id !== destroyedFacility.id);
            }
            return prev;
          });
        }

        // All guests evacuate
        setGuests([]);

        // All rooms marked as unoccupied
        setRooms((prev) =>
          prev.map((room) => ({
            ...room,
            occupied: false,
            guest: null,
          }))
        );

        // Massive costs for damage, insurance deductibles, etc.
        const fireDamage = 50000 + Math.floor(Math.random() * 100000);
        setMoney((prev) => prev - fireDamage);

        // Severe reputation hit
        setReputation((prev) => Math.max(1, prev - 2));

        // Market share collapses
        setMarketShare((prev) => Math.max(5, prev - 25));

        return `Fire disaster! ${
          affectedRooms.length > 0
            ? `${affectedRooms.length} rooms damaged or destroyed`
            : ""
        }${
          destroyedFacility
            ? `${affectedRooms.length > 0 ? " and " : ""}${
                destroyedFacility.name
              } completely destroyed`
            : ""
        }. Damage costs: $${fireDamage.toLocaleString()}.`;
      },
    },
    {
      id: "heatwave",
      title: "Extreme Heatwave",
      description:
        "An unprecedented heatwave is affecting the city and your hotel!",
      icon: <Thermometer className="w-4 h-4" />,
      effect: () => {
        // AC failure and skyrocketing electricity costs
        const electricitySurcharge = 500 * rooms.length; // Scales with hotel size
        setMoney((prev) => prev - electricitySurcharge);

        // Some guests leave due to discomfort
        const cancelledRooms = [];
        rooms.forEach((room) => {
          if (room.occupied && Math.random() < 0.3) {
            // 30% chance of each guest leaving
            cancelledRooms.push(room.id);
          }
        });

        // Process cancellations
        setRooms((prev) =>
          prev.map((room) =>
            cancelledRooms.includes(room.id)
              ? { ...room, occupied: false, guest: null }
              : room
          )
        );

        setGuests((prev) =>
          prev.filter((guest) => !cancelledRooms.includes(guest.roomId))
        );

        // Emergency AC repairs
        const repairCosts = 5000 + Math.floor(Math.random() * 10000);
        setMoney((prev) => prev - repairCosts);

        // Temporary reduction in new bookings
        setMarketShare((prev) => Math.max(5, prev - 5));

        return `Extreme heatwave! AC systems struggling, electricity costs up $${electricitySurcharge}, ${cancelledRooms.length} guests left, and $${repairCosts} in emergency repairs needed.`;
      },
    },
    {
      id: "unionStrike",
      title: "Union Strike",
      description:
        "Your hotel staff is going on strike demanding better working conditions!",
      icon: <Milestone className="w-4 h-4" />,
      effect: () => {
        // Calculate the average staff salary
        const avgSalary =
          staff.reduce((sum, employee) => sum + employee.salary, 0) /
          (staff.length || 1);

        // Determine if the strike is successful based on salary levels
        const strikeDemands = Math.round(avgSalary * 0.3); // 30% raise demanded
        const totalRaiseCost = strikeDemands * staff.length;

        // You either pay the raise or suffer serious consequences
        if (Math.random() < 0.3 || money < totalRaiseCost) {
          // 30% chance you can't resolve or can't afford
          // Strike continues - massive operational problems

          // No staff working - all guests leave
          setRooms((prev) =>
            prev.map((room) => ({
              ...room,
              occupied: false,
              guest: null,
            }))
          );

          setGuests([]);

          // Reputation collapses
          setReputation((prev) => Math.max(1, prev - 2));

          // Market share plummets
          setMarketShare((prev) => Math.max(5, prev - 20));

          // Legal costs and lost revenue
          const strikeCosts = 20000 + Math.floor(Math.random() * 30000);
          setMoney((prev) => prev - strikeCosts);

          return `Prolonged staff strike! All guests have left, reputation severely damaged, and $${strikeCosts} in legal costs and lost revenue.`;
        } else {
          // You agree to the demands - financial hit but operations continue
          setMoney((prev) => prev - totalRaiseCost);

          // Increase all staff salaries
          setStaff((prev) =>
            prev.map((employee) => ({
              ...employee,
              salary: employee.salary + strikeDemands,
              happiness: Math.min(5, employee.happiness + 1), // Happier staff
            }))
          );

          // Small reputation hit from the publicity
          setReputation((prev) => Math.max(1, prev - 0.3));

          return `Strike resolved! You agreed to increase staff salaries by $${strikeDemands} each, costing $${totalRaiseCost} in additional wages.`;
        }
      },
    },
    {
      id: "serverCrash",
      title: "Booking System Failure",
      description: "Your hotel's reservation system has completely crashed!",
      icon: <HardDrive className="w-4 h-4" />,
      effect: () => {
        // Double bookings and reservation chaos
        // Random guests are assigned to the wrong rooms or find their reservation lost
        let affectedGuests = 0;

        // Some random check-ins are cancelled
        setGuests((prev) => {
          const notYetCheckedIn = prev.filter((guest) => !guest.roomId);
          affectedGuests = Math.ceil(notYetCheckedIn.length * 0.7); // 70% of pending check-ins affected

          // Keep only 30% of pending check-ins
          const keptGuests = notYetCheckedIn.filter(() => Math.random() > 0.7);
          const checkedInGuests = prev.filter((guest) => guest.roomId);

          return [...checkedInGuests, ...keptGuests];
        });

        // Double bookings cause compensation costs
        const compensationCosts = affectedGuests * 300; // $300 per affected guest
        setMoney((prev) => prev - compensationCosts);

        // IT repair costs
        const repairCosts = 5000 + Math.floor(Math.random() * 5000);
        setMoney((prev) => prev - repairCosts);

        // Reputation damage from the chaos
        setReputation((prev) => Math.max(1, prev - 0.5));

        return `Booking system failure! ${affectedGuests} reservations lost, $${compensationCosts} in guest compensation and $${repairCosts} in IT repair costs.`;
      },
    },
    {
      id: "conference",
      title: "Business Conference",
      description:
        "A business conference is in town! Many business travelers are looking for accommodation.",
      icon: <Briefcase className="w-4 h-4" />,
      effect: () => {
        // Generate extra guests with higher budgets
        const extraGuests = Math.floor(3 + Math.random() * 5);
        for (let i = 0; i < extraGuests; i++) {
          setTimeout(() => generateNewGuests(true), i * 200);
        }
        return `A business conference has brought ${extraGuests} potential guests to your hotel!`;
      },
    },
    {
      id: "celebrity",
      title: "Celebrity Visit",
      description:
        "A famous celebrity is staying at your hotel! This increases your reputation but requires special attention.",
      icon: <Star className="w-4 h-4" />,
      effect: () => {
        const reputationBoost = 0.3 + Math.random() * 0.4;
        setReputation((prev) => Math.min(5, prev + reputationBoost));
        return `A celebrity is staying at your hotel! Reputation increased by ${reputationBoost.toFixed(
          1
        )} stars.`;
      },
    },
    {
      id: "maintenance",
      title: "Maintenance Issue",
      description:
        "There's a maintenance problem in your hotel that needs immediate attention.",
      icon: <AlertCircle className="w-4 h-4" />,
      effect: () => {
        const cost = Math.floor(500 + Math.random() * 1000);
        setMoney((prev) => prev - cost);
        return `Emergency maintenance required! It cost you $${cost} to fix the issue.`;
      },
    },
    {
      id: "festival",
      title: "Local Festival",
      description:
        "A local festival is attracting tourists to the area. Expect more guests!",
      icon: <Music className="w-4 h-4" />,
      effect: () => {
        // Increase reputation temporarily
        setReputation((prev) => Math.min(5, prev + 0.2));
        // Generate extra guests
        const extraGuests = Math.floor(2 + Math.random() * 4);
        for (let i = 0; i < extraGuests; i++) {
          setTimeout(() => generateNewGuests(), i * 300);
        }
        return `A local festival is bringing more tourists to the area. Expect increased bookings!`;
      },
    },
    {
      id: "review",
      title: "Positive Online Review",
      description:
        "Someone left a glowing review of your hotel online! This boosts your reputation.",
      icon: <ThumbsUp className="w-4 h-4" />,
      effect: () => {
        const reputationBoost = 0.2 + Math.random() * 0.3;
        setReputation((prev) => Math.min(5, prev + reputationBoost));
        return `A guest left a wonderful review online! Reputation increased by ${reputationBoost.toFixed(
          1
        )} stars.`;
      },
    },
    {
      id: "badWeather",
      title: "Bad Weather",
      description:
        "Severe weather has caused travel disruptions. Expect cancellations.",
      icon: <Umbrella className="w-4 h-4" />,
      effect: () => {
        // Random cancellations
        const cancelledRooms = [];
        rooms.forEach((room) => {
          if (room.occupied && Math.random() < 0.3) {
            cancelledRooms.push(room.id);
          }
        });

        if (cancelledRooms.length > 0) {
          // Process cancellations
          setRooms((prev) =>
            prev.map((room) =>
              cancelledRooms.includes(room.id)
                ? { ...room, occupied: false, guest: null }
                : room
            )
          );

          setGuests((prev) =>
            prev.filter((guest) => !cancelledRooms.includes(guest.roomId))
          );
        }

        return `Bad weather has caused ${cancelledRooms.length} booking cancellations.`;
      },
    },
    {
      id: "competitorUpgrade",
      title: "Competitor Upgrade",
      description: "A competing hotel has upgraded their facilities!",
      icon: <ArrowUp className="w-4 h-4" />,
      effect: () => {
        // Randomly select a competitor to upgrade
        const index = Math.floor(Math.random() * competitors.length);
        const competitor = competitors[index];

        // Add a new facility to the competitor
        const allFacilityTypes = facilityTypes.map((f) => f.type);
        const currentFacilities = new Set(competitor.facilities);
        const availableFacilities = allFacilityTypes.filter(
          (f) => !currentFacilities.has(f)
        );

        if (availableFacilities.length) {
          const newFacility =
            availableFacilities[
              Math.floor(Math.random() * availableFacilities.length)
            ];

          // Update competitor
          setCompetitors((prev) =>
            prev.map((comp, i) => {
              if (i === index) {
                return {
                  ...comp,
                  facilities: [...comp.facilities, newFacility],
                  reputation: Math.min(5, comp.reputation + 0.3),
                };
              }
              return comp;
            })
          );

          return `${competitor.name} has added a new ${newFacility} to their property, increasing their reputation.`;
        }

        return `${competitor.name} has renovated their property, improving their reputation.`;
      },
    },
    {
      id: "competitorProblem",
      title: "Competitor Problem",
      description: "A competing hotel is facing customer service issues!",
      icon: <ArrowDown className="w-4 h-4" />,
      effect: () => {
        // Randomly select a competitor to have issues
        const index = Math.floor(Math.random() * competitors.length);
        const competitor = competitors[index];

        // Reduce competitor reputation
        setCompetitors((prev) =>
          prev.map((comp, i) => {
            if (i === index) {
              return {
                ...comp,
                reputation: Math.max(1, comp.reputation - 0.5),
                occupancyRate: Math.max(0.3, comp.occupancyRate - 0.1),
              };
            }
            return comp;
          })
        );

        // Boost your market share
        setMarketShare((prev) => Math.min(70, prev + 2));

        return `${competitor.name} is receiving negative reviews due to service issues. This could be an opportunity for your hotel.`;
      },
    },
  ];

  const triggerRandomEvent = () => {
    // Base chance increases as the game progresses
    const dayFactor = Math.min(1, day / 100); // Maxes out at day 100
    const baseChance = 0.1 + dayFactor * 0.15; // 10% at start, up to 25% later

    const hasStaff = Array.isArray(staff) && staff.length > 0;

    // FIXED: Only trigger events after day 200 and with calculated chance each day
    if (day > 200 && Math.random() < baseChance) {
      let availableEvents = [...randomEvents]; // Create a copy to avoid modifying original

      // Initialize tracking objects if they don't exist
      if (!window.recentEvents) {
        window.recentEvents = [];
      }

      if (!window.recentEventTypes) {
        window.recentEventTypes = {
          count: {},
          lastDay: {},
        };
      } else if (!window.recentEventTypes.count) {
        // Make sure the sub-objects exist too
        window.recentEventTypes.count = {};
        window.recentEventTypes.lastDay = {};
      }

      if (!window.lastEventValues) {
        window.lastEventValues = {};
      }

      // Progressively introduce more severe events as the game advances
      // FIXED: Events only start after day 200
      if (day <= 300) {
        // Early events after day 200
        const appropriateEventIds = [
          "review",
          "badWeather",
          "festival",
          "celebrity",
          "conference",
          "competitorProblem",
          "competitorUpgrade",
        ];
        availableEvents = randomEvents.filter((event) =>
          appropriateEventIds.includes(event.id)
        );
      }
      // In mid-late game (days 301-400), add more challenging events BUT NOT catastrophic ones
      else if (day <= 400) {
        // Medium difficulty events
        const mediumEventIds = [
          "maintenance",
          "review",
          "badWeather",
          "festival",
          "celebrity",
          "conference",
          "competitorProblem",
          "competitorUpgrade",
          "powerOutage",
          "serverCrash",
          "heatwave",
        ];
        availableEvents = randomEvents.filter((event) =>
          mediumEventIds.includes(event.id)
        );
      }
      // In late game (days 401-500), add more challenging events
      else if (day <= 500) {
        // Exclude only the most catastrophic events
        const excludedEvents = [
          "viralBadReview",
          "staffEmbezzlement",
          "massStaffResignation",
          "hotelRankingDemoted",
          "organizedCrimeThreat",
          "securityBreach",
          "hurricane",
          "dataBreachScandal",
          "tornado",
          "fire",
        ];
        availableEvents = randomEvents.filter(
          (event) => !excludedEvents.includes(event.id)
        );
      }
      // In late game with rich players, increase chance of devastating events
      else if (money > 200000) {
        // If player has a lot of money, give higher chance to extreme events
        if (Math.random() < 0.3) {
          // Focus on challenging events for wealthy established hotels
          const hardEventIds = [
            "viralBadReview",
            "staffEmbezzlement",
            "massStaffResignation",
            "hotelRankingDemoted",
            "organizedCrimeThreat",
            "foodPoisoning",
            "staffDrugScandal",
            "healthInspectionFailure",
            "securityBreach",
            "celebrityScandal",
            "hurricane",
            "tornado",
            "dataBreachScandal",
            "taxEvasionInvestigation",
            "flooding",
            "fire",
            "unionStrike",
          ];
          availableEvents = randomEvents.filter((event) =>
            hardEventIds.includes(event.id)
          );
        }
      }

      // Update event type tracking - with error checking
      if (window.recentEventTypes && window.recentEventTypes.count) {
        for (const eventId in window.recentEventTypes.count) {
          // Reduce counter for events that haven't been seen recently
          // (events that weren't triggered within the last 10 days)
          if (day - (window.recentEventTypes.lastDay[eventId] || 0) > 10) {
            window.recentEventTypes.count[eventId] = 0;
          }
        }
      }

      // Remove events that were triggered recently (within last 5 days)
      availableEvents = availableEvents.filter(
        (event) => !window.recentEvents.includes(event.id)
      );

      const recentDaysEvents = notifications
        .filter((n) => n.type === "event" && day - n.timestamp <= 2)
        .map((n) => {
          // Extract event ID from notification message
          const match = n.message.match(/EVENT: ([^-]+)/);
          return match ? match[1].trim() : null;
        })
        .filter(Boolean);

      availableEvents = availableEvents.filter(
        (event) => !recentDaysEvents.includes(event.title)
      );

      if (window.recentEventTypes && window.recentEventTypes.count) {
        availableEvents = availableEvents.filter((event) => {
          const count = window.recentEventTypes.count[event.id] || 0;

          // Special case for "festival" - limit frequency more strictly
          if (event.id === "festival") {
            const lastFestivalDay =
              window.recentEventTypes.lastDay[event.id] || 0;
            const daysSinceLastFestival = day - lastFestivalDay;

            // Only allow festivals every 15+ days, and no more than 2 in a 30-day period
            return daysSinceLastFestival > 15 && count < 2;
          }

          // For other events, limit based on how many times they've been triggered recently
          return count < 3; // No event should occur more than 3 times in a short period
        });
      }

      // If we filtered out all events, fallback to the full list for that time period
      if (availableEvents.length === 0) {
        // Just use whatever events were appropriate for this time period
        // FIXED: All fallbacks now respect the 200+ day requirement
        if (day <= 300) {
          // Early events after day 200
          const appropriateEventIds = [
            "review",
            "badWeather",
            "festival",
            "celebrity",
            "conference",
            "competitorProblem",
            "competitorUpgrade",
          ];
          availableEvents = randomEvents.filter((event) =>
            appropriateEventIds.includes(event.id)
          );
        } else if (day <= 400) {
          // Mid game - add tech issues and weather
          const mediumEventIds = [
            "maintenance",
            "review",
            "badWeather",
            "festival",
            "celebrity",
            "conference",
            "competitorProblem",
            "competitorUpgrade",
            "powerOutage",
            "serverCrash",
            "heatwave",
          ];
          availableEvents = randomEvents.filter((event) =>
            mediumEventIds.includes(event.id)
          );
        } else if (day <= 500) {
          // Mid-late game - add more challenging events
          const advancedEventIds = [
            "maintenance",
            "review",
            "badWeather",
            "festival",
            "celebrity",
            "conference",
            "competitorProblem",
            "competitorUpgrade",
            "powerOutage",
            "serverCrash",
            "heatwave",
            "staffShortage",
            "healthInspectionWarning",
            "cityRegulationChange",
          ];
          availableEvents = randomEvents.filter((event) =>
            advancedEventIds.includes(event.id)
          );
        } else {
          // Late game - almost all events
          const excludedEvents =
            day <= 600
              ? [
                  "viralBadReview",
                  "staffEmbezzlement",
                  "massStaffResignation",
                  "hotelRankingDemoted",
                  "organizedCrimeThreat",
                  "securityBreach",
                  "hurricane",
                  "dataBreachScandal",
                  "tornado",
                  "fire",
                ]
              : [];

          availableEvents = randomEvents.filter(
            (event) => !excludedEvents.includes(event.id)
          );
        }
      }

      // Check if the selected event makes sense for the current game state
      let validEvent = false;
      let event;
      let attempts = 0;

      // Try up to 5 times to find a suitable event
      while (!validEvent && attempts < 5) {
        event =
          availableEvents[Math.floor(Math.random() * availableEvents.length)];

        if (!event) {
          attempts++;
          continue;
        }

        // Additional validation logic for specific events
        switch (event.id) {
          case "hotelRankingDemoted":
            // Only if we have enough reputation to lose
            validEvent = reputation > 2.5;
            break;

          case "foodPoisoning":
            // Only if we have a restaurant and staff to cause the issue
            validEvent =
              facilities.some((facility) => facility.name === "Restaurant") &&
              hasStaff;
            break;

          case "staffDrugScandal":
          case "staffEmbezzlement":
          case "massStaffResignation":
          case "unionStrike":
            // Only if we have enough staff
            validEvent = hasStaff && staff.length >= 5;
            break;

          case "celebrityScandal":
          case "celebrity":
            // Only if reputation is decent and we have staff to interact with the celebrity
            validEvent = reputation >= 3 && hasStaff;
            break;

          case "viralBadReview":
            // Only if we have enough guests to write reviews
            validEvent = guests.length > 0 || day > 30;
            break;

          case "badWeather":
            // Check if we have guests or bookings to potentially be affected
            validEvent = guests && guests.length > 0;
            break;

          case "securityBreach":
            // Security breach should not happen in mid-game and requires specific conditions
            if (day <= 300) {
              // Increased to 300
              // Explicitly block this event before day 300
              validEvent = false;
            } else {
              // After day 300, only if we have valuable assets
              validEvent = money > 50000 || guests.length > 10;
            }
            break;

          case "maintenance":
            // Staff required for maintenance issues or the hotel wouldn't be maintained
            validEvent = hasStaff;
            break;

          case "healthInspectionFailure":
            // Needs both facilities to inspect and staff to be responsible
            validEvent = facilities.length > 0 && hasStaff;
            break;

          case "conference":
            // Need staff to host a conference
            validEvent = hasStaff && facilities.length > 1;
            break;

          case "staffShortage":
            // Makes sense when we actually have staff that could be short-staffed
            validEvent = hasStaff && staff.length >= 3;
            break;

          // Special handling - if we have no staff, generate specific no-staff events
          case "noStaffCrisis":
            // This is a special event that only happens when we have no staff
            validEvent = !hasStaff;
            break;

          default:
            // All other events are generally valid, but still ensure basic staff requirements
            // For most hotel operations, at least some staff would be needed
            validEvent =
              hasStaff ||
              ["competitorProblem", "competitorUpgrade"].includes(event.id);
        }

        attempts++;
      }

      // Special handler for no-staff scenario
      // If we have no staff and couldn't find a valid event, create a staff crisis event
      if (!validEvent && !hasStaff) {
        // Create a special no-staff event that encourages the player to hire
        event = {
          id: "noStaffCrisis",
          title: "Operational Crisis",
          effect: () => {
            // Lose reputation and some guests due to poor service
            setReputation((prev) => Math.max(1, prev - 0.3));

            // Potentially lose bookings/guests
            if (guests.length > 0) {
              const lostGuests = Math.max(1, Math.floor(guests.length * 0.2));
              setGuests((prev) => prev.slice(0, prev.length - lostGuests));

              // Lose money from refunds
              setMoney((prev) => Math.max(0, prev - lostGuests * 150));

              return `With no staff to run your hotel, ${lostGuests} guest(s) have left demanding refunds! Reputation damaged. Hire staff immediately!`;
            } else {
              return "Your hotel is in disarray with no staff. Potential guests are turned away by the poor management. Hire staff immediately!";
            }
          },
        };
        validEvent = true;
      }

      // If we couldn't find a valid event after 5 attempts, pick one of the safe events
      if (!validEvent) {
        const safeEvents = randomEvents.filter((e) =>
          ["competitorProblem", "competitorUpgrade"].includes(e.id)
        );

        // If maintenance is valid (we have staff), add it as a safe option
        if (Array.isArray(staff) && staff.length > 0) {
          const maintenanceEvents = randomEvents.filter(
            (e) => e.id === "maintenance"
          );
          safeEvents.push(...maintenanceEvents);
        }

        event = safeEvents[Math.floor(Math.random() * safeEvents.length)];
      }

      // Catastrophic event safety check - prevent these before day 400
      const catastrophicEvents = [
        "securityBreach",
        "hurricane",
        "tornado",
        "fire",
        "viralBadReview",
        "staffEmbezzlement",
        "massStaffResignation",
        "hotelRankingDemoted",
        "organizedCrimeThreat",
      ];

      // Define inline event generation functions if they don't exist
      const generateBadWeatherEvent = () => {
        // Cancel some bookings
        const cancelledRooms = [];
        rooms.forEach((room) => {
          if (room.occupied && Math.random() < 0.3) {
            cancelledRooms.push(room.id);
          }
        });

        if (cancelledRooms.length > 0) {
          // Process cancellations
          setRooms((prev) =>
            prev.map((room) =>
              cancelledRooms.includes(room.id)
                ? { ...room, occupied: false, guest: null }
                : room
            )
          );

          setGuests((prev) =>
            prev.filter((guest) => !cancelledRooms.includes(guest.roomId))
          );
        }

        return `Bad weather has caused ${cancelledRooms.length} booking cancellations.`;
      };

      const generateMaintenanceEvent = () => {
        const cost = Math.floor(500 + Math.random() * 1000);
        setMoney((prev) => prev - cost);
        return `Emergency maintenance required! It cost you $${cost} to fix the issue.`;
      };

      const generateFestivalEvent = () => {
        // Increase reputation temporarily
        setReputation((prev) => Math.min(5, prev + 0.2));
        // Generate extra guests
        const extraGuests = Math.floor(2 + Math.random() * 4);
        for (let i = 0; i < extraGuests; i++) {
          setTimeout(() => generateNewGuests(), i * 300);
        }
        return `A local festival is bringing more tourists to the area. Expect increased bookings!`;
      };

      const generateReviewEvent = () => {
        const reputationBoost = 0.2 + Math.random() * 0.3;
        setReputation((prev) => Math.min(5, prev + reputationBoost));
        return `A guest left a wonderful review online! Reputation increased by ${reputationBoost.toFixed(
          1
        )} stars.`;
      };

      // Execute the selected event with variance for repeatable events
      let resultMessage;

      // Final safety check - prevent catastrophic events before day 400
      if (catastrophicEvents.includes(event.id) && day <= 400) {
        // Force a safer event instead
        if (guests && guests.length > 0) {
          resultMessage = generateBadWeatherEvent();
        } else {
          // Check if we have staff for maintenance event
          if (Array.isArray(staff) && staff.length > 0) {
            resultMessage = generateMaintenanceEvent();
          } else {
            // No staff and no guests - competitive event as fallback
            resultMessage =
              "A competitor hotel has opened nearby, but your lack of staff gives you limited options to respond.";

            // Small reputation hit for being unprepared
            setReputation((prev) => Math.max(1, prev - 0.1));
          }
        }
      }
      // For common repeatable events, ensure we have variety in outcomes
      else if (event.id === "maintenance") {
        resultMessage = generateMaintenanceEvent();
      } else if (event.id === "badWeather") {
        resultMessage = generateBadWeatherEvent();
      } else if (event.id === "festival") {
        resultMessage = generateFestivalEvent();
      } else if (event.id === "review") {
        resultMessage = generateReviewEvent();
      } else {
        if (typeof event.effect === "function") {
          resultMessage = event.effect();
        } else {
          // Fallback message if effect is not a function
          resultMessage = "A special event has occurred at your hotel.";

          // Apply some default effects based on the event type/id
          if (event.id.includes("competitor")) {
            resultMessage =
              "A competing hotel has made changes to their business strategy.";
          } else if (event.id.includes("weather")) {
            resultMessage =
              "Weather conditions have affected your hotel operations.";
          } else if (event.id.includes("staff")) {
            resultMessage =
              "There have been some staffing issues at your hotel.";
          } else if (event.id.includes("guest")) {
            resultMessage =
              "Guest interactions have impacted your hotel reputation.";
          }
        }
      }

      // Add this event to recently triggered events
      window.recentEvents.push(event.id);

      // Track event type frequency - with safety checks
      if (window.recentEventTypes && window.recentEventTypes.count) {
        window.recentEventTypes.count[event.id] =
          (window.recentEventTypes.count[event.id] || 0) + 1;
        window.recentEventTypes.lastDay[event.id] = day;
      }

      // Keep only the last 4 events in the recent events list
      if (window.recentEvents.length > 4) {
        window.recentEvents.shift();
      }

      // Add an eye-catching notification

      displayRandomEvent(event);
      setNotifications((prev) =>
        [
          {
            id: Date.now(),
            message: `🎯 EVENT: ${event.title} - ${resultMessage}`,
            timestamp: day,
            isSpecial: true,
            type: "event",
          },
          ...prev,
        ].slice(0, 15)
      );
    }
  };

  // Custom maintenance event generator
  function generateMaintenanceEvent() {
    const lastCost = window.lastEventValues.maintenanceCost;
    let cost;

    // Generate a new cost that's different from the last one
    do {
      // Base cost range scales with day and hotel size
      const baseRange = 300 + day * 5;
      const minCost = Math.max(300, baseRange - 200);
      const maxCost = baseRange + 400;
      cost = Math.floor(minCost + Math.random() * (maxCost - minCost));
    } while (lastCost && Math.abs(cost - lastCost) < 100); // Ensure at least $100 difference

    // Save this cost for next time
    window.lastEventValues.maintenanceCost = cost;

    // Apply the financial penalty
    // Use your state update function instead of direct assignment
    setMoney((prevMoney) => prevMoney - cost);

    // Generate a variety of maintenance issues
    const issues = [
      "plumbing system",
      "electrical wiring",
      "air conditioning",
      "elevator",
      "roof leak",
      "water heater",
      "security system",
      "swimming pool",
      "kitchen equipment",
      "structural damage",
      "internet infrastructure",
      "fire safety system",
    ];

    // Select a random issue that's different from the last one
    let issue;
    do {
      issue = issues[Math.floor(Math.random() * issues.length)];
    } while (issue === window.lastEventValues.maintenanceIssue);

    window.lastEventValues.maintenanceIssue = issue;

    return `Emergency ${issue} maintenance required! It cost you $${cost} to fix the issue.`;
  }

  // Custom bad weather event generator
  function generateBadWeatherEvent() {
    // Work with existing game state (guests, bookings, or occupancy rate)
    let impactedGuests = 0;
    let lostRevenue = 0;

    // Variety of weather conditions
    const weatherTypes = [
      "heavy rain",
      "snowstorm",
      "high winds",
      "extreme heat",
      "flooding",
      "dense fog",
      "ice storm",
    ];

    // Select a random weather type different from last time
    let weatherType;
    do {
      weatherType =
        weatherTypes[Math.floor(Math.random() * weatherTypes.length)];
    } while (weatherType === window.lastEventValues.weatherType);

    window.lastEventValues.weatherType = weatherType;

    if (guests && guests.length > 0) {
      // Impact between 10-30% of current guests
      const impactPercentage = 0.1 + Math.random() * 0.2;
      impactedGuests = Math.max(
        1,
        Math.floor(guests.length * impactPercentage)
      );

      // Calculate financial impact based on room rate
      // Assuming you have an average room rate or can calculate one
      const averageRoomRate = 150; // Replace with your actual rate calculation
      lostRevenue = impactedGuests * averageRoomRate;

      // Apply the financial penalty
      setMoney((prevMoney) => prevMoney - lostRevenue);

      // Optionally reduce guest satisfaction
      // Use state update function instead of direct modification
      setGuests((prevGuests) => {
        // Create a copy to avoid modifying the original array
        const updatedGuests = [...prevGuests];
        for (
          let i = 0;
          i < Math.min(impactedGuests, updatedGuests.length);
          i++
        ) {
          if (updatedGuests[i] && updatedGuests[i].satisfaction) {
            updatedGuests[i] = {
              ...updatedGuests[i],
              satisfaction: Math.max(1, updatedGuests[i].satisfaction - 1),
            };
          }
        }
        return updatedGuests;
      });
    }

    // Return appropriate message based on impact
    if (impactedGuests > 0) {
      return `${
        weatherType.charAt(0).toUpperCase() + weatherType.slice(1)
      } has caused ${impactedGuests} guests to leave early, losing $${lostRevenue.toFixed(
        0
      )} in revenue.`;
    } else {
      // Even with no guests, weather affects potential bookings
      return `${
        weatherType.charAt(0).toUpperCase() + weatherType.slice(1)
      } has reduced new bookings today.`;
    }
  }

  // Festival event generator with more variety
  function generateFestivalEvent() {
    // Different festival types
    const festivalTypes = [
      "music festival",
      "food festival",
      "cultural celebration",
      "film festival",
      "arts fair",
      "seasonal market",
      "sports tournament",
      "carnival",
      "historical reenactment",
      "wine tasting fair",
    ];

    // Select a random festival type that differs from last time
    let festivalType;
    do {
      festivalType =
        festivalTypes[Math.floor(Math.random() * festivalTypes.length)];
    } while (festivalType === window.lastEventValues.festivalType);

    window.lastEventValues.festivalType = festivalType;

    // Different impacts the festival could have
    const impacts = [
      "Expect increased bookings!",
      "Your rooms are in high demand!",
      "Prepare for a busy week ahead!",
      "Consider increasing room rates temporarily.",
      "Consider offering festival packages to attract more guests.",
    ];

    const impact = impacts[Math.floor(Math.random() * impacts.length)];

    // Occasionally provide an actual booking boost
    if (Math.random() < 0.7) {
      // Increase bookings logic would go here
      // This depends on your game's booking system
    }

    return `A local ${festivalType} is bringing more tourists to the area. ${impact}`;
  }

  // Review event generator with more variety
  function generateReviewEvent() {
    // Different types of positive reviews
    const reviewTypes = [
      "glowing review about your staff",
      "5-star review mentioning cleanliness",
      "enthusiastic review highlighting your amenities",
      "detailed positive review from a business traveler",
      "wonderful review from a family vacation",
      "positive review specifically about room comfort",
      "excellent review mentioning your location",
      "high rating with compliments about your breakfast",
      "stellar review praising your customer service",
      "positive feedback about the value for money",
    ];

    // Select a random review type that differs from last time
    let reviewType;
    do {
      reviewType = reviewTypes[Math.floor(Math.random() * reviewTypes.length)];
    } while (reviewType === window.lastEventValues.reviewType);

    window.lastEventValues.reviewType = reviewType;

    // Vary the reputation boost
    const reputationBoost = 0.2 + Math.random() * 0.3; // Between 0.2 and 0.5

    // Apply the reputation boost
    setReputation((prevReputation) =>
      Math.min(5, prevReputation + reputationBoost)
    );

    return `A guest left a ${reviewType} online! Reputation increased by ${reputationBoost.toFixed(
      1
    )} stars.`;
  }

  useEffect(() => {
    // Check if user is logged in
    const userString = localStorage.getItem("user");
    if (userString) {
      try {
        const userData = JSON.parse(userString);
        setUser(userData);
      } catch (e) {
        console.error("Error parsing user data", e);
      }
    }

    // Load saved games
    loadSavedGamesFromServer();
  }, []);

  useEffect(() => {
    if (gameSpeed === 0) return; // Game is paused

    const gameLoop = setInterval(
      () => {
        // Advance day after a slight delay for visual feedback
        setTimeout(() => {
          setDay((prevDay) => prevDay + 1);

          // Daily operations
          calculateDailyExpenses();
          handleGuestDepartures();
          generateNewGuests();
          updateRoomStatus();
          updateStaffStatus();
          updateMarketingCampaigns();
          updateCompetitorHotels(); // NEW: Update competitor hotels
          calculateMarketShare(); // NEW: Calculate market share
          checkBankruptcy();
          triggerRandomEvent();
        }, 300);
      },
      gameSpeed === 1 ? 3000 : 1500
    ); // Faster gameplay for more fun

    return () => clearInterval(gameLoop);
  }, [
    gameSpeed,
    rooms,
    staff,
    facilities,
    guests,
    reputation,
    day,
    marketingCampaigns,
    competitors,
  ]);

  // Calculate daily expenses (staff salaries, facility upkeep)
  const calculateDailyExpenses = () => {
    // Staff salaries
    const staffCost = staff.reduce(
      (total, employee) => total + employee.salary,
      0
    );

    // Room and facility upkeep
    const roomUpkeep = rooms.reduce((total, room) => {
      const roomType = roomTypes.find((type) => type.type === room.type);
      return total + (roomType ? roomType.upkeep : 0);
    }, 0);

    const facilityUpkeep = facilities.reduce(
      (total, facility) => total + facility.upkeep,
      0
    );

    // Daily income from occupied rooms
    const roomIncome = rooms.reduce((total, room) => {
      return total + (room.occupied ? room.price : 0);
    }, 0);

    // Facility income - fixed to properly generate revenue
    let facilityIncome = 0;
    let facilityUsage = [];

    // Each guest has a chance to use each facility
    guests.forEach((guest) => {
      facilities.forEach((facility) => {
        if (facility.name === "Lobby") return;

        const facilityType = facilityTypes.find(
          (f) => f.type === facility.name
        );
        if (!facilityType) return;

        // Calculate usage probability based on reputation, guest type, and facility type
        let usageProbability = 0.3 + reputation * 0.1;

        // Different guests prefer different facilities
        if (
          guest.type === "Business" &&
          (facility.name === "Restaurant" || facility.name === "Bar")
        ) {
          usageProbability += 0.2;
        } else if (
          guest.type === "Family" &&
          (facility.name === "Restaurant" || facility.name === "Pool")
        ) {
          usageProbability += 0.2;
        } else if (
          guest.type === "Leisure" &&
          (facility.name === "Spa" || facility.name === "Bar")
        ) {
          usageProbability += 0.3;
        }

        // Cap probability
        usageProbability = Math.min(0.9, usageProbability);

        // Check if guest uses this facility
        if (Math.random() < usageProbability) {
          // Calculate spending amount with some randomness
          const baseSpending = facilityType.incomePerGuest;
          const actualSpending = Math.round(
            baseSpending * (0.8 + Math.random() * 0.4) * facility.level
          );

          facilityIncome += actualSpending;

          // Record this usage for notification
          facilityUsage.push({
            guestName: guest.name,
            facilityName: facility.name,
            spending: actualSpending,
          });
        }
      });
    });

    // Update money
    const dailyProfit =
      roomIncome + facilityIncome - staffCost - roomUpkeep - facilityUpkeep;
    setMoney((prevMoney) => prevMoney + dailyProfit);

    // Show main financial notification
    /*addNotification(
      `Day ${day} summary: +$${Math.round(
        roomIncome
      )} room income, +$${Math.round(
        facilityIncome
      )} facility income, -$${Math.round(
        staffCost + roomUpkeep + facilityUpkeep
      )} expenses`
    );

    // Show individual facility usage notifications
    facilityUsage.forEach((usage) => {
      addNotification(
        `${usage.guestName} spent $${usage.spending} at the ${usage.facilityName}`,
        false,
        "facility"
      );
    });*/
  };

  // Handle guest departures
  const handleGuestDepartures = () => {
    const departingGuests = guests.filter((guest) => guest.checkoutDay === day);

    departingGuests.forEach((guest) => {
      // Free up room
      setRooms((prevRooms) =>
        prevRooms.map((room) => {
          if (room.id === guest.roomId) {
            return { ...room, occupied: false, guest: null };
          }
          return room;
        })
      );

      // Review affects reputation
      const reviewScore = Math.min(5, Math.max(1, guest.happiness));
      const reputationChange = (reviewScore - 3) * 0.1;
      setReputation((prevRep) =>
        Math.min(5, Math.max(1, prevRep + reputationChange))
      );

      /*
      addNotification(
        `${guest.name} checked out and gave a ${reviewScore.toFixed(
          1
        )}-star review!`
      );*/
    });

    // Remove departing guests
    setGuests((prevGuests) =>
      prevGuests.filter((guest) => guest.checkoutDay !== day)
    );
  };

  // Memory-optimized guest generation with chunking to prevent UI freezing
  const generateNewGuests = (isBusinessTraveler = false) => {

    // STEP 1: Calculate how many potential guests to generate

    let potentialGuests;
    const seasonalModifier =
      currentSeason === "summer" ? 1.3 : currentSeason === "winter" ? 0.8 : 1.0;
    const randomFactor =
      1 + Math.random() * Math.min(3, Math.sqrt(rooms.length) / 2);

    // --- Calculation Path based on Game Day ---
    if (day > 200) {
        // --- LATE GAME Calculation (After Day 200) ---
        const cappedReputation = Math.min(5, Math.max(1, reputation)); // Now only calculated here
        const reputationFactor = Math.pow(cappedReputation, 1.3) / 2;
        // Note: marketShareFactor is *not* used in late game baseGuests calculation in the original code for day > 200

        const baseGuests = 1 + reputationFactor; // Late game base

        // Apply a stronger reputation influence for very small hotels (late game only)
        let smallHotelReputationModifier = 1;
        if (cappedReputation <= 2) {
            smallHotelReputationModifier = 0.7 + (cappedReputation / 2) * 0.3; // Reduce potential guests further for very small, low-reputation hotels
        }

        // Staff Influence (late game)
        let staffFactor = 1;
        if (staff.length === 0) {
            staffFactor = 0.1; // Significantly reduce potential guests if no staff (late game)
        } else {
            // Calculate a factor based on the ratio of staff to rooms (adjust as needed)
            const staffToRoomRatio = staff.length / rooms.length;
            // Using the late-game scaling example from original code
            staffFactor = Math.min(1, Math.max(0.2, staffToRoomRatio * 0.5));
        }

        potentialGuests = Math.min(
            40, // Cap remains
            Math.floor(
                baseGuests *
                randomFactor *
                seasonalModifier *
                smallHotelReputationModifier * // Applied only > day 200
                staffFactor                  // Applied only > day 200
            )
        );

    } else {
        // --- EARLY GAME Calculation (Day 1-200) ---
        // Use simpler factors, potentially ignoring some complex modifiers

        // Reputation still matters, but maybe less complexly capped? Let's keep the cap for consistency.
        const cappedReputation = Math.min(5, Math.max(1, reputation));
        const reputationFactor = Math.pow(cappedReputation, 1.3) / 2;

        // Base guests calculation for early game (includes market share)
        const baseGuests = 1 + reputationFactor;

        // No small hotel penalty or complex staff factor early on
        const smallHotelReputationModifier = 1; // Not applied
        const staffFactor = 1; // Not applied (or could have a very simple check if needed)

        potentialGuests = Math.min(
            40, // Cap remains
            Math.floor(
                baseGuests *
                randomFactor *
                seasonalModifier *
                smallHotelReputationModifier * // Effectively 1
                staffFactor                  // Effectively 1
            )
        );
    }

    // --- COMMON LOGIC Continues ---

    // Check if we have any available rooms first
    const availableRooms = rooms.filter((room) => !room.occupied);
    if (availableRooms.length === 0 || potentialGuests <= 0) {
      console.log("No available rooms or potential guests <= 0. Skipping guest generation."); // Added log
      return;
    }

    // STEP 2: Set up state for chunked processing
    const state = {
      guestsRemaining: potentialGuests,
      availableRooms: [...availableRooms], // Clone to avoid modifying original
      facilityTypes: {}, // Cache facility lookup
      newBookings: 0,
      totalRevenue: 0,
      pendingGuests: [],
      pendingRoomUpdates: {},
      currentIndex: 0, // Track current guest index
    };

    // Build facility lookup cache
    for (let i = 0; i < facilities.length; i++) {
      state.facilityTypes[facilities[i].name] = true;
    }

    // STEP 3: Define chunked processing function
    const processGuestChunk = () => {
      // Calculate average room quality (needed for booking probability)
      // This could also be calculated once outside the loop if rooms don't change during chunk processing
      const avgRoomQuality =
        rooms.length > 0
          ? rooms.reduce((sum, room) => sum + room.quality, 0) / rooms.length
          : 0;

      // Process a chunk of guests (adjust size based on performance needs)
      const CHUNK_SIZE = 5; // Keep chunk size relatively small
      const endIndex = Math.min(
        state.currentIndex + CHUNK_SIZE,
        potentialGuests // Use the calculated potentialGuests
      );

      // --- Start processing chunk ---
      for (let i = state.currentIndex; i < endIndex; i++) {
        // Stop if no more rooms
        if (state.availableRooms.length === 0) {
            console.log("No more available rooms during chunk processing."); // Added log
            break;
        };

        // Generate guest profile
        const firstName =
          firstNames[Math.floor(Math.random() * firstNames.length)];
        const lastName =
          lastNames[Math.floor(Math.random() * lastNames.length)];
        const guestName = `${firstName} ${lastName}`;

        // Determine stay length
        let stayLength;
        if (isBusinessTraveler) {
          const businessStayProb = Math.random();
          stayLength =
            businessStayProb < 0.3 ? 1 : businessStayProb < 0.8 ? 2 : 3;
        } else {
          const stayProb = Math.random();
          if (stayProb < 0.25) stayLength = 1;
          else if (stayProb < 0.65) stayLength = 2;
          else if (stayProb < 0.85) stayLength = 3;
          else if (stayProb < 0.95) stayLength = 4;
          else stayLength = 5 + Math.floor(Math.random() * 3);
        }

        // Determine guest type & preferences
        let guestType, roomPreference, priceSensitivity;
        const typeRandom = Math.random();
        const businessBonus = currentSeason === "autumn" ? 0.15 : 0;
        const familyBonus = currentSeason === "summer" ? 0.15 : 0;

        if (isBusinessTraveler || typeRandom < 0.35 + businessBonus) {
          guestType = "Business";
          const roomRand = Math.random();
          roomPreference =
            roomRand < 0.15
              ? "Standard"
              : roomRand < 0.5
              ? "Deluxe"
              : roomRand < 0.8
              ? "Executive"
              : "Suite";
          priceSensitivity = 0.6 + Math.random() * 0.3;
        } else if (typeRandom < 0.65 + familyBonus) {
          guestType = "Family";
          const roomRand = Math.random();
          roomPreference =
            roomRand < 0.55 ? "Standard" : roomRand < 0.85 ? "Deluxe" : "Suite";
          priceSensitivity = 0.3 + Math.random() * 0.4;
        } else {
          guestType = "Leisure";
          const roomRand = Math.random();
          roomPreference =
            roomRand < 0.4
              ? "Standard"
              : roomRand < 0.7
              ? "Deluxe"
              : roomRand < 0.9
              ? "Suite"
              : "Penthouse";
          priceSensitivity = 0.2 + Math.random() * 0.7;
        }

        // Select a room efficiently
        let chosenRoom = findBestRoom(
          state.availableRooms,
          roomPreference,
          guestType
        );
        if (!chosenRoom) {
            // console.log(`No suitable room found for ${guestType} preferring ${roomPreference}`); // Optional log
            continue; // Skip if no suitable room found
        }

        // Remove selected room from available pool
        const roomIndex = state.availableRooms.findIndex(
          (r) => r.id === chosenRoom.id
        );
        if (roomIndex >= 0) {
          state.availableRooms.splice(roomIndex, 1);
        } else {
            console.warn(`Chosen room ${chosenRoom.id} not found in availableRooms list.`); // Should not happen
            continue;
        }

        // Calculate price factors and booking probability
        const roomType = roomTypes.find(
          (type) => type.type === chosenRoom.type
        );
        const basePrice = roomType ? roomType.basePrice : chosenRoom.price;

        // Calculate price acceptance threshold (using cappedReputation, which might vary based on day)
        const currentCappedReputation = Math.min(5, Math.max(1, reputation)); // Recalculate for this scope if needed, or pass from outer scope
        let competitivePricePoint = basePrice;
        let relevantCompetitors = 0;
        let weightedSum = 0;
        let totalWeight = 0;

        // Find relevant competitors' prices
        for (let j = 0; j < competitors.length; j++) {
          const competitor = competitors[j];
          if (
            competitor.avgRoomPrice >= basePrice * 0.7 &&
            competitor.avgRoomPrice <= basePrice * 1.3
          ) {
            relevantCompetitors++;
            // Weight competitor price by their reputation relative to yours
            const weight = competitor.reputation / Math.max(1, currentCappedReputation);
            weightedSum += competitor.avgRoomPrice * weight;
            totalWeight += weight;
          }
        }

        if (relevantCompetitors > 0 && totalWeight > 0) {
          competitivePricePoint = weightedSum / totalWeight;
        }

        // Calculate final price threshold with reputation premium
        const reputationPremium = Math.pow(currentCappedReputation, 1.5) / 5;
        const priceAcceptanceThreshold =
          competitivePricePoint * (1 + priceSensitivity * reputationPremium);


        // Calculate all booking factors
        let reputationBonus = (currentCappedReputation - 3) * 0.3; // Use current capped reputation

        // Calculate facility bonus from cached lookup
        let facilityBonus = calculateFacilityBonus(
          state.facilityTypes,
          guestType
        );

        // Policy bonus
        let policyBonus = 0;
        if (
          policies.petFriendly &&
          guestType === "Family" &&
          Math.random() > 0.5
        )
          policyBonus += 0.15;
        if (policies.earlyCheckin && guestType === "Business")
          policyBonus += 0.1;
        if (policies.lateCheckout && guestType !== "Business")
          policyBonus += 0.08;
        if (policies.freeCancellation) policyBonus += 0.05;
        if (policies.breakfastIncluded) policyBonus += 0.12;

        // Marketing bonus
        let marketingBonus = 0;
        const activeMarketingCampaigns = marketingCampaigns.filter(
          (c) => c.active
        );
        for (let j = 0; j < activeMarketingCampaigns.length; j++) {
          const campaign = activeMarketingCampaigns[j];
          switch (campaign.effect) {
            case "increased_bookings":
              marketingBonus += 0.35;
              break;
            case "price_sensitive":
              if (priceSensitivity < 0.5) marketingBonus += 0.2;
              break;
            case "high_end":
              if (
                ["Suite", "Executive", "Penthouse"].includes(chosenRoom.type)
              ) {
                marketingBonus += 0.35;
              }
              break;
            case "steal_guests":
              marketingBonus += 0.28;
              break;
            case "reputation_boost":
              marketingBonus += 0.1 * (campaign.boost || 0.1);
              break;
          }
        }

        // Seasonal bonus
        let seasonalBonus = calculateSeasonalBonus(
          currentSeason,
          guestType,
          state.facilityTypes
        );

        // Calculate staff bonus (apply penalty conditionally based on day)
        let staffBonus = 0;
        if (staff.length > 0) {
          const staffTypes = {};
          for (let j = 0; j < staff.length; j++)
            staffTypes[staff[j].role] = true;

          if (staffTypes["Receptionist"]) staffBonus += 0.1;
          if (staffTypes["Manager"]) staffBonus += 0.05;
          if (staffTypes["Marketing Director"]) staffBonus += 0.15;

          const avgHappiness =
            staff.reduce((sum, s) => sum + s.happiness, 0) / staff.length;
          staffBonus += (avgHappiness - 3) * 0.03;
        } else {
          // Apply penalty only if applicable based on game stage and hotel size
          if (day > 200 && rooms.length > 5) { // Added day check
            staffBonus -= 0.3; // Significant penalty for no staff (late game, larger hotel)
          }
        }

        // Market share momentum
        const marketShareBonus = (marketShare / 100) * 0.2;

        // Price differential
        let priceFactor = Math.max(
          -0.95,
          Math.min(0, (chosenRoom.price - priceAcceptanceThreshold) / 100)
        );
        // Removing the specific small hotel price penalty as it's complex and potentially handled by reputation factor now
        /*if (rooms.length == 5 && currentCappedReputation <= 2) {
          priceFactor *= 1 + (2 - currentCappedReputation) * 0.5; // Increase the negative impact
        }*/

        // Quality Penalty based on average room quality
        const qualityPenalty = Math.max(
          0,
          (3 - (avgRoomQuality || 1.5)) * 0.05 // Use calculated avgRoomQuality
        );

        // Adjust base probability based on average room quality
        let baseProb = 0.45 - Math.max(0, (3 - (avgRoomQuality || 1.5)) * 0.03);

        // Final booking probability calculation
        const bookingProbability = Math.min(
          0.98,
          Math.max(
            0.05,
            baseProb +
              reputationBonus +
              facilityBonus +
              policyBonus +
              marketingBonus +
              seasonalBonus +
              staffBonus +
              marketShareBonus +
              priceFactor -
              qualityPenalty
          )
        );

        // Make booking decision
        if (Math.random() < bookingProbability) {
          // Guest books the room
          // Calculate happiness
          let baseHappiness = 3 + chosenRoom.quality * 0.4;

          // Adjust happiness based on preference vs actual room type
          const prefIndex = roomTypes.findIndex(
            (type) => type.type === roomPreference
          );
          const actualIndex = roomTypes.findIndex(
            (type) => type.type === chosenRoom.type
          );
          if (prefIndex >= 0 && actualIndex >= 0) {
              // Small bonus for upgrade, bigger penalty for downgrade
              baseHappiness += actualIndex > prefIndex ? 0.5 : -0.7;
          }

          const happinessVariation = -0.5 + Math.random();
          const initialHappiness = Math.min(
            5,
            Math.max(1, baseHappiness + happinessVariation)
          );

          // Create new guest object with minimal properties
          const guestId = Date.now().toString(36) + Math.random().toString(36).substring(2) + i; // More robust unique ID
          const newGuest = {
            id: guestId,
            name: guestName,
            roomId: chosenRoom.id,
            checkoutDay: day + stayLength,
            happiness: initialHappiness,
            type: guestType,
            checkInDay: day,
            preferences: { // Keep preferences simple for now
              roomQuality: 1 + Math.random() * 4,
              foodQuality: 1 + Math.random() * 4,
              serviceQuality: 1 + Math.random() * 4,
            },
            spending: chosenRoom.price * stayLength, // Base spending
          };

          // Add to pending updates
          state.pendingGuests.push(newGuest);
          state.pendingRoomUpdates[chosenRoom.id] = {
            occupied: true,
            guest: guestId, // Use the new guest ID
          };
          state.newBookings++;
          state.totalRevenue += chosenRoom.price * stayLength;
        }
      } // --- End processing chunk ---

      // Update current index
      state.currentIndex = endIndex;

      // STEP 4: Decide if we need to continue or finish
      if (
        state.currentIndex < potentialGuests && // Check against calculated potentialGuests
        state.availableRooms.length > 0
      ) {
        // Schedule next chunk with minimal delay
        setTimeout(processGuestChunk, 0); // Use 0 delay for fastest possible next tick
      } else {
        // We're done processing, apply all changes at once
        finishGuestGeneration(state);
      }
    };

    // STEP 5: Define helper functions (Keep these as they are, they are general purpose)
    // Find best available room
    function findBestRoom(availableRooms, preferredType, guestType) {
       // First look for exact matches
        const exactMatches = availableRooms.filter(
            (room) => room.type === preferredType
        );

        if (exactMatches.length > 0) {
            // Sort by quality descending
            exactMatches.sort((a, b) => b.quality - a.quality);

            // Favor higher quality, but add randomness unless it's a top-tier room
            const qualityRandom = Math.random();
            if (qualityRandom < 0.7 || exactMatches[0].quality >= 4.5 || exactMatches.length === 1) {
                return exactMatches[0]; // Pick the best one often or if it's exceptional/only option
            } else {
                // Pick randomly among the top few (e.g., top 3 or fewer if less available)
                const topCount = Math.min(3, exactMatches.length);
                return exactMatches[Math.floor(Math.random() * topCount)];
            }
        } else {
            // No exact match, find closest alternative based on score
            const preferenceIndex = roomTypes.findIndex(
                (type) => type.type === preferredType
            );

            let bestRoom = null;
            let bestScore = -Infinity; // Start with lowest possible score

            for (let i = 0; i < availableRooms.length; i++) {
                const room = availableRooms[i];
                let score = room.quality * 2; // Base score on quality

                const actualIndex = roomTypes.findIndex(
                    (type) => type.type === room.type
                );

                if (preferenceIndex >= 0 && actualIndex >= 0) {
                    // Adjust score based on type difference (higher difference = lower score)
                    const typeDifference = Math.abs(preferenceIndex - actualIndex);
                    score = score / (1 + typeDifference * 0.5); // Penalize bigger jumps

                    // Penalize downgrades more heavily, especially for Business
                    if (actualIndex < preferenceIndex) {
                         score *= (guestType === "Business" ? 0.5 : 0.7);
                    }
                    // Optional: Small bonus for upgrades?
                    // if (actualIndex > preferenceIndex) {
                    //     score *= 1.1;
                    // }

                } else {
                    // Handle cases where preference or actual type isn't standard (shouldn't happen with defined roomTypes)
                    score *= 0.8; // Penalize if types aren't comparable
                }


                // Add randomness to break ties or slightly prefer different rooms
                score += Math.random() * 0.5; // Small random factor

                if (score > bestScore) {
                    bestScore = score;
                    bestRoom = room;
                }
            }
            // Fallback if no room scored positively (unlikely but possible)
            return bestRoom || (availableRooms.length > 0 ? availableRooms[0] : null);
        }
    }

    // Calculate facility bonus based on guest type
    function calculateFacilityBonus(facilityTypes, guestType) {
      let bonus = 0;

      if (guestType === "Business") {
        if (facilityTypes["Gym"]) bonus += 0.1;
        if (facilityTypes["Restaurant"]) bonus += 0.15;
        if (facilityTypes["Business Center"]) bonus += 0.2;
        if (facilityTypes["Conference Room"]) bonus += 0.15;
        if (facilityTypes["Wifi"]) bonus += 0.1; // Assuming Wifi is a facility listed
      } else if (guestType === "Family") {
        if (facilityTypes["Pool"]) bonus += 0.25;
        if (facilityTypes["Restaurant"]) bonus += 0.1;
        if (facilityTypes["Kids Club"]) bonus += 0.2;
        if (facilityTypes["Game Room"]) bonus += 0.1;
      } else {
        // Leisure
        if (facilityTypes["Spa"]) bonus += 0.2;
        if (facilityTypes["Bar"]) bonus += 0.15;
        if (facilityTypes["Pool"]) bonus += 0.15;
        if (facilityTypes["Restaurant"]) bonus += 0.1;
      }

      // Luxury facilities benefit all (adjust bonus values as needed)
      if (facilityTypes["Private Submarine Experience"]) bonus += 0.2;
      if (facilityTypes["Rooftop Helipad & Skylounge"]) bonus += 0.15;
      if (facilityTypes["Gondola"] || facilityTypes["Gondola Ride"]) bonus += 0.1; // Check both names just in case

      return Math.min(bonus, 0.6); // Cap total facility bonus to prevent excessive stacking
    }

    // Calculate seasonal bonus
    function calculateSeasonalBonus(season, guestType, facilityTypes) {
      let bonus = 0;

      switch (season) {
        case "summer":
          if (guestType === "Family") bonus += 0.2;
          if (guestType === "Leisure") bonus += 0.15;
          if (facilityTypes["Pool"]) bonus += 0.15;
          if (facilityTypes["Private Submarine Experience"]) bonus += 0.1; // Specific summer appeal
          break;
        case "winter":
          if (guestType === "Business") bonus += 0.05; // Business travel might dip slightly unless specific facilities exist
          if (facilityTypes["Spa"]) bonus += 0.12;
          if (facilityTypes["Restaurant"]) bonus += 0.08; // Indoor dining appeal
          // Could add bonus for specific winter facilities if they exist (e.g., Ski Lift)
          break;
        case "spring":
          bonus += 0.08; // General pleasant season bonus
          if (facilityTypes["Gondola"] || facilityTypes["Gondola Ride"]) bonus += 0.1; // Scenic appeal
          break;
        case "autumn":
          if (guestType === "Business") bonus += 0.12; // Conference season
          if (facilityTypes["Conference Room"]) bonus += 0.1;
          break;
      }

      return bonus;
    }

    // Apply all state changes and send notifications
    function finishGuestGeneration(state) {
      console.log(`Guest generation finished. New bookings: ${state.newBookings}, Revenue: ${state.totalRevenue}`); // Added log
      // Apply all guest additions in one batch
      if (state.pendingGuests.length > 0) {
        // Ensure guests have unique IDs before adding
        const uniqueNewGuests = state.pendingGuests.filter((g, index, self) =>
            index === self.findIndex((t) => (t.id === g.id))
        );
         if(uniqueNewGuests.length !== state.pendingGuests.length){
             console.warn("Duplicate guest IDs detected during generation, filtering duplicates.");
         }
        setGuests((prevGuests) => [...prevGuests, ...uniqueNewGuests]);
      }

      // Apply all room updates in one batch
      if (Object.keys(state.pendingRoomUpdates).length > 0) {
        setRooms((prevRooms) =>
          prevRooms.map((room) => {
            const update = state.pendingRoomUpdates[room.id];
            // Ensure we don't overwrite essential room properties unintentionally
            return update ? { ...room, occupied: update.occupied, guest: update.guest } : room;
          })
        );
      }

      // Send appropriate notifications
      if (state.newBookings > 0) {
        // Simplified notification - consider making it more detailed if needed
        // addNotification(
        //    `${state.newBookings} new bookings generated $${formatCurrency(state.totalRevenue)}.`,
        //    state.newBookings > 5, // Highlight if many bookings
        //    "booking"
        // );

        // Notify if nearly full
        const finalAvailableRooms = rooms.filter(room => !state.pendingRoomUpdates[room.id]).length; // Estimate final count
        if (finalAvailableRooms <= 2 && rooms.length > 5) {
          addNotification(
            `Your hotel is nearly full! Only ${finalAvailableRooms} rooms remaining.`,
            true,
            "warning" // Use warning type for urgency
          );
        }
      } else {
         // Optional: Notify if potential guests existed but none booked
         if(potentialGuests > 0) {
             // addNotification("Potential guests were interested, but no new bookings occurred.", false, "info");
         }
      }
    }

    // Start the chunked processing
    console.log(`Starting guest generation for day ${day}. Potential guests: ${potentialGuests}`); // Added log
    processGuestChunk();
  };

  const calculateMarketShare = () => {
    // Calculate every 7 days to avoid too many fluctuations
    if (day % 7 !== 0) return;

    // STEP 1: Calculate base capacity metrics
    const yourRooms = rooms.length;
    const competitorRooms = competitors.reduce((sum, c) => sum + c.rooms, 0);
    const totalRooms = yourRooms + competitorRooms;

    // Early exit if no rooms exist (avoid division by zero)
    if (totalRooms === 0) return;

    // STEP 2: Calculate occupancy metrics
    const yourOccupiedRooms = rooms.filter((r) => r.occupied).length;
    const yourOccupancyRate = yourRooms > 0 ? yourOccupiedRooms / yourRooms : 0;
    const competitorOccupiedRooms = competitors.reduce(
      (sum, c) => sum + Math.floor(c.rooms * c.occupancyRate),
      0
    );
    const totalOccupiedRooms = yourOccupiedRooms + competitorOccupiedRooms;

    // Early exit if no rooms are occupied (avoid division by zero)
    if (totalOccupiedRooms === 0) {
      // Set to minimum market share based on room count
      const minSharePercentage =
        totalRooms > 0
          ? Math.max(5, Math.round((yourRooms / totalRooms) * 100))
          : 0;

      setMarketShare(minSharePercentage);
      return;
    }

    // STEP 3: Calculate reputation influence with luxury facilities boost
    // More weight to reputation as it's a key factor in the hospitality industry
    let reputationBoost = 0;

    // Check for luxury facilities that boost reputation
    const hasSubmarine = facilities.some(
      (f) => f.name === "Private Submarine Experience"
    );
    const hasHelipad = facilities.some(
      (f) => f.name === "Rooftop Helipad & Skylounge"
    );
    const hasGondola = facilities.some(
      (f) => f.name === "Gondola Ride" || f.name === "Gondola"
    );
    const hasTrattoria = facilities.some((f) => f.name === "Trattoria");

    // Apply reputation boosts based on unique luxury facilities
    if (hasSubmarine) reputationBoost += 0.8; // Major reputation boost
    if (hasHelipad) reputationBoost += 0.5; // Significant reputation boost
    if (hasGondola) reputationBoost += 0.3; // Moderate reputation boost for themed facility
    if (hasTrattoria) reputationBoost += 0.2; // Minor reputation boost for themed restaurant

    // Enhanced reputation calculation with luxury boosts
    const enhancedReputation = Math.min(5, reputation + reputationBoost);
    const reputationWeight =
      enhancedReputation > 0 ? Math.pow(enhancedReputation, 1.5) : 0.5;

    const avgCompetitorReputation =
      competitors.length > 0
        ? competitors.reduce((sum, c) => sum + c.reputation, 0) /
          competitors.length
        : 3; // Default to average reputation

    const competitorReputationSum = competitors.reduce(
      (sum, c) => sum + Math.pow(Math.max(0.1, c.reputation), 1.5), // Ensure min value of 0.1
      0
    );
    const totalReputationWeight = reputationWeight + competitorReputationSum;
    const reputationFactor =
      totalReputationWeight > 0
        ? 0.7 + 0.6 * (reputationWeight / totalReputationWeight)
        : 0.5;

    // STEP 4: Calculate marketing effectiveness with luxury facilities influence
    // Consider diminishing returns on marketing campaigns
    const activeMarketingCampaigns = marketingCampaigns.filter((c) => c.active);

    // Luxury facilities enhance marketing effectiveness
    const luxuryMarketingBoost = hasHelipad ? 0.25 : 0; // Helipad facilities enhance marketing reach

    const yourMarketingStrength = activeMarketingCampaigns.reduce(
      (total, campaign) => {
        // Different campaigns have different effectiveness
        const campaignPower = campaign.cost > 1000 ? 1.5 : 1.0;

        // Reputation and luxury facilities amplify marketing effectiveness
        const reputationMultiplier =
          enhancedReputation > 4
            ? 1.2 + luxuryMarketingBoost
            : enhancedReputation > 3
            ? 1.0 + luxuryMarketingBoost
            : 0.8 + luxuryMarketingBoost;

        return total + campaignPower * reputationMultiplier;
      },
      0
    );

    // Calculate competitor marketing strength with similar nuance
    const competitorMarketingStrength = competitors.reduce((sum, c) => {
      if (!c.marketingActive) return sum;
      const effectivenessMultiplier =
        c.reputation > 4 ? 1.2 : c.reputation > 3 ? 1.0 : 0.8;
      return sum + c.marketingLevel * effectivenessMultiplier;
    }, 0);

    const totalMarketingStrength =
      yourMarketingStrength + competitorMarketingStrength;
    const marketingFactor =
      totalMarketingStrength > 0
        ? 0.85 + 0.3 * (yourMarketingStrength / totalMarketingStrength)
        : 1;

    // STEP 5: Calculate seasonal effects with enhanced facility considerations
    let seasonalFactor = 1.0;

    // Standard seasonal effects
    if (
      currentSeason === "summer" &&
      facilities.some((f) => f.name === "Pool")
    ) {
      seasonalFactor = 1.1; // 10% boost for hotels with pools in summer
    } else if (
      currentSeason === "winter" &&
      facilities.some((f) => f.name === "Spa")
    ) {
      seasonalFactor = 1.08; // 8% boost for hotels with spas in winter
    }

    // Luxury and themed facility seasonal effects
    if (currentSeason === "summer" && hasSubmarine) {
      seasonalFactor += 0.05; // Additional summer boost for submarine experiences
    }

    if (
      hasGondola &&
      (currentSeason === "spring" || currentSeason === "summer")
    ) {
      seasonalFactor += 0.03; // Italian facilities more popular in spring/summer
    }

    if (hasHelipad) {
      seasonalFactor += 0.02; // Helipad provides year-round appeal
    }

    // STEP 6: Consider price positioning factor with luxury pricing
    // Calculate your average room price with a minimum value
    const yourAvgPrice =
      rooms.length > 0
        ? rooms.reduce((sum, r) => sum + r.price, 0) / rooms.length
        : 50; // Default to average price if no rooms

    // Calculate average competitor price with a minimum value
    const competitorAvgPrice =
      competitors.length > 0
        ? competitors.reduce((sum, c) => sum + c.avgRoomPrice, 0) /
          competitors.length
        : 50; // Default to average price if no competitors

    // Price-to-value ratio (based on reputation and price)
    // Avoid division by zero by using a minimum value
    const competitorReputationAvg =
      competitors.length > 0 ? competitorReputationSum / competitors.length : 1;

    // Luxury facilities improve perceived value even at high prices
    const luxuryValueBoost =
      (hasSubmarine ? 0.3 : 0) +
      (hasHelipad ? 0.2 : 0) +
      (hasGondola || hasTrattoria ? 0.1 : 0);

    const enhancedPriceValueRatio =
      (competitorAvgPrice / Math.max(1, yourAvgPrice)) *
      (enhancedReputation / Math.max(0.1, competitorReputationAvg)) *
      (1 + luxuryValueBoost); // Apply luxury boost to price-value ratio

    // If you offer better value, you gain market share
    const priceFactor =
      enhancedPriceValueRatio > 1.2
        ? 1.15 // Much better value
        : enhancedPriceValueRatio > 1
        ? 1.05 // Better value
        : enhancedPriceValueRatio > 0.8
        ? 0.95 // Worse value
        : 0.85; // Much worse value

    // STEP 7: Calculate VIP guest attraction from luxury facilities
    // Luxury facilities can attract high-profile guests even with lower room count
    const luxuryAttractiveness =
      (hasSubmarine ? 0.15 : 0) +
      (hasHelipad ? 0.12 : 0) +
      (hasGondola ? 0.05 : 0) +
      (hasTrattoria ? 0.03 : 0);

    // STEP 8: Calculate raw market share based on occupied rooms with luxury boost
    let rawShare =
      totalOccupiedRooms > 0
        ? (yourOccupiedRooms / totalOccupiedRooms) * 100
        : (yourRooms / Math.max(1, totalRooms)) * 100; // Use room capacity as fallback

    // Apply luxury attractiveness boost to raw share
    rawShare = rawShare * (1 + luxuryAttractiveness);

    // Ensure rawShare has a minimum value based on your market presence
    rawShare = Math.max(rawShare, (yourRooms / Math.max(1, totalRooms)) * 50);

    // STEP 9: Apply all factors to calculate adjusted market share
    const newMarketShare = Math.min(
      95, // Cap at 95% - monopolies are rare in hotel industry
      Math.max(
        5, // Minimum 5% if you have any rooms at all
        rawShare *
          reputationFactor *
          marketingFactor *
          seasonalFactor *
          priceFactor
      )
    );

    // STEP 10: Apply adaptive smoothing - more smoothing for larger changes
    // Get previous market share with a default value to handle initial state
    const previousMarketShare =
      typeof marketShare === "number" ? marketShare : 0;

    const changeAmount = Math.abs(newMarketShare - previousMarketShare);
    const smoothingFactor = Math.max(
      0.1,
      Math.min(0.9, 1 - changeAmount / 100)
    );
    const smoothedShare =
      previousMarketShare * smoothingFactor +
      newMarketShare * (1 - smoothingFactor);

    // Round to nearest integer and ensure it's at least 1% if you have rooms
    const finalMarketShare = Math.max(
      yourRooms > 0 ? 1 : 0,
      Math.round(smoothedShare)
    );

    // Update market share with rounding
    setMarketShare(finalMarketShare);

    // STEP 11: Record historical data with more metrics for advanced analysis
    // Include luxury facility data in market history
    setMarketData((prev) => {
      // Maintain a maximum number of data points to avoid memory issues
      const newData = [
        ...prev,
        {
          day,
          share: finalMarketShare,
          reputation: enhancedReputation,
          occupancyRate: Math.round(yourOccupancyRate * 100),
          priceValueRatio: parseFloat(enhancedPriceValueRatio.toFixed(2)),
          marketingActive: activeMarketingCampaigns.length > 0,
          luxuryFacilities: [
            hasSubmarine ? "Private Submarine Experience" : null,
            hasHelipad ? "Rooftop Helipad & Skylounge" : null,
            hasGondola ? "Gondola Ride" : null,
            hasTrattoria ? "Trattoria" : null,
          ].filter(Boolean),
        },
      ];

      // Limit history to last 365 days to prevent performance issues
      return newData.length > 365 ? newData.slice(-365) : newData;
    });

    // STEP 12: Improved notification system with smarter triggers and luxury facility mentions
    // Special case for new hotel or growing from zero market share
    if (previousMarketShare === 0 && finalMarketShare > 0) {
      // First-time market share achievement notification
      addNotification(
        `Your hotel has entered the market with ${finalMarketShare}% market share!`,
        true, // High priority - this is a milestone
        "market"
      );

      // Add explanatory context with luxury facility recommendations if reputation is good
      if (reputation > 3.5) {
        addNotification(
          `Your excellent reputation opens opportunities for luxury facilities to further increase your market presence.`,
          false,
          "market"
        );
      } else {
        addNotification(
          `Continue improving your hotel's reputation and facilities to increase your market presence.`,
          false,
          "market"
        );
      }
    }
    // Handle regular market share changes when already established
    else if (finalMarketShare > 0 && typeof previousMarketShare === "number") {
      // Calculate percentage change for better context
      const percentageChange =
        previousMarketShare > 0
          ? ((finalMarketShare - previousMarketShare) / previousMarketShare) *
            100
          : 100; // Treat any increase from very small numbers as significant

      // Only notify if change is significant
      const significantChange =
        (previousMarketShare < 5 && finalMarketShare > previousMarketShare) || // Always notify on growth when market share is tiny
        (previousMarketShare < 20 && Math.abs(percentageChange) > 10) || // 10% relative change for small market shares
        Math.abs(finalMarketShare - previousMarketShare) >= 2; // At least 2% absolute change for larger shares

      if (significantChange) {
        const increasing = finalMarketShare > previousMarketShare;

        // Create more contextual change messages
        let changeDescription;
        if (increasing) {
          changeDescription =
            percentageChange > 25 ? "significantly increased" : "increased";
        } else {
          changeDescription =
            percentageChange < -25 ? "significantly decreased" : "decreased";
        }

        // Format a more informative notification
        const changeValue = Math.abs(finalMarketShare - previousMarketShare);
        const message = `Your market share has ${changeDescription} from ${previousMarketShare}% to ${finalMarketShare}% (${
          increasing ? "+" : "-"
        }${changeValue.toFixed(1)}%).`;

        addNotification(
          message,
          Math.abs(percentageChange) > 20, // Higher priority for bigger changes
          "market"
        );

        // Add explanatory factor for large changes, including luxury facility impact
        if (Math.abs(percentageChange) > 15 || changeValue >= 3) {
          let reason = "";

          // Determine if luxury facilities played a significant role
          const luxuryImpact = luxuryAttractiveness > 0.1;

          // Determine most significant factor
          if (luxuryImpact && increasing) {
            // Luxury facilities are making a big positive difference
            const luxuryFacilities = [
              hasSubmarine ? "Private Submarine Experience" : null,
              hasHelipad ? "Rooftop Helipad & Skylounge" : null,
              hasGondola ? "Gondola Ride" : null,
            ].filter(Boolean);

            reason = `Your luxury facilities (${luxuryFacilities.join(
              ", "
            )}) are attracting high-profile guests and significantly boosting your market presence.`;
          } else if (
            Math.abs(reputationFactor - 1) > Math.abs(marketingFactor - 1) &&
            Math.abs(reputationFactor - 1) > Math.abs(priceFactor - 1)
          ) {
            reason = increasing
              ? `Your reputation (${enhancedReputation.toFixed(
                  1
                )}/5) is outperforming competitors (avg: ${avgCompetitorReputation.toFixed(
                  1
                )}/5).`
              : `Your reputation (${enhancedReputation.toFixed(
                  1
                )}/5) is lagging behind competitors (avg: ${avgCompetitorReputation.toFixed(
                  1
                )}/5).`;
          } else if (
            Math.abs(marketingFactor - 1) > Math.abs(priceFactor - 1)
          ) {
            reason = increasing
              ? `Your marketing campaigns are effectively attracting guests.`
              : `Your competitors are outspending you on marketing.`;
          } else {
            const pricingStatus =
              enhancedPriceValueRatio > 1
                ? "Your price-to-quality ratio offers better value than competitors."
                : "Your prices may be too high relative to your quality offerings.";
            reason = pricingStatus;
          }

          addNotification(`Market analysis: ${reason}`, false, "market");
        }
      }
    }
  };

  // Update competitor hotels with luxury facility considerations
  const updateCompetitorHotels = () => {
    // Update competitors less frequently (every 3 days)
    if (day % 3 !== 0) return;

    // Check your luxury facilities to determine competitive response
    const hasSubmarine = facilities.some(
      (f) => f.name === "Private Submarine Experience"
    );
    const hasHelipad = facilities.some(
      (f) => f.name === "Rooftop Helipad & Skylounge"
    );
    const hasItalianFacilities = facilities.some(
      (f) =>
        f.name === "Gondola Ride" ||
        f.name === "Gondola" ||
        f.name === "Trattoria"
    );

    // Luxury competition intensity - competitors react more strongly to luxury facilities
    const luxuryCompetitionIntensity =
      (hasSubmarine ? 0.3 : 0) +
      (hasHelipad ? 0.2 : 0) +
      (hasItalianFacilities ? 0.1 : 0);

    setCompetitors((prev) =>
      prev.map((competitor) => {
        // Small random adjustments to occupancy based on season and reputation
        let occupancyChange = (Math.random() - 0.5) * 0.05; // -2.5% to +2.5%

        // Seasonal effects
        if (
          currentSeason === "summer" &&
          competitor.facilities.includes("Pool")
        ) {
          occupancyChange += 0.02;
        } else if (
          currentSeason === "winter" &&
          !competitor.facilities.includes("Restaurant")
        ) {
          occupancyChange -= 0.01;
        }

        // Reputation effects
        if (competitor.reputation > 4) {
          occupancyChange += 0.01;
        } else if (competitor.reputation < 2.5) {
          occupancyChange -= 0.01;
        }

        // Competition effect - top competitors respond to luxury facilities
        if (
          competitor.reputation > 4 &&
          competitor.rooms > 70 &&
          luxuryCompetitionIntensity > 0
        ) {
          // Top competitors try to counter your luxury advantage with price adjustments or marketing
          const competitiveResponse = Math.random();

          if (competitiveResponse < 0.3) {
            // They might lower prices to compete
            competitor.avgRoomPrice = Math.max(
              40,
              Math.round(
                competitor.avgRoomPrice *
                  (1 - 0.05 * luxuryCompetitionIntensity)
              )
            );

            // Add notification about competitor price response
            if (
              typeof addNotification === "function" &&
              luxuryCompetitionIntensity > 0.2
            ) {
              addNotification(
                `${competitor.name} has lowered their prices to compete with your luxury offerings!`,
                false,
                "competitor"
              );
            }
          } else if (competitiveResponse < 0.7) {
            // They might increase marketing
            competitor.marketingActive = true;
            competitor.marketingLevel = Math.min(
              5,
              competitor.marketingLevel + 1
            );
            competitor.marketingEffort = 7; // Longer campaign

            // Add notification about competitor marketing response
            if (
              typeof addNotification === "function" &&
              luxuryCompetitionIntensity > 0.2
            ) {
              addNotification(
                `${competitor.name} has launched an aggressive marketing campaign to compete with your luxury facilities!`,
                false,
                "competitor"
              );
            }
          }
        }

        // Calculate new base occupancy rate (capped between 30-95%)
        let newOccupancyRate = Math.min(
          0.95,
          Math.max(0.3, competitor.occupancyRate + occupancyChange)
        );

        // Create a base updated competitor object
        let updatedCompetitor = {
          ...competitor,
          occupancyRate: newOccupancyRate,
        };

        // Handle marketing effects
        if (competitor.marketingActive) {
          // Apply marketing boost
          updatedCompetitor.occupancyRate = Math.min(
            0.95,
            updatedCompetitor.occupancyRate + 0.02 * competitor.marketingLevel
          );

          // Decrease marketing effort
          const newMarketingEffort = competitor.marketingEffort - 1;
          updatedCompetitor.marketingEffort = newMarketingEffort;

          // Turn off marketing if effort is depleted
          if (newMarketingEffort <= 0) {
            updatedCompetitor.marketingActive = false;
            updatedCompetitor.marketingEffort = 0;
          }
        } else {
          // Random chance for competitor to start marketing if not already active
          // Higher chance if you have luxury facilities and they're a high-end competitor
          const marketingBaseChance = competitor.reputation > 4 ? 0.07 : 0.05;
          const adjustedMarketingChance =
            marketingBaseChance * (1 + luxuryCompetitionIntensity);

          if (Math.random() < adjustedMarketingChance) {
            updatedCompetitor.marketingActive = true;
            updatedCompetitor.marketingEffort =
              3 + Math.floor(Math.random() * 3); // 3-5 days

            // Add notification for largest competitors starting marketing
            if (
              competitor.rooms > 50 &&
              typeof addNotification === "function"
            ) {
              addNotification(
                `${competitor.name} has launched a new marketing campaign!`,
                false,
                "competitor"
              );
            }
          }
        }

        // Random price adjustments (every 7 days)
        if (day % 7 === 0 && Math.random() < 0.3) {
          // Price change range is influenced by your luxury facilities
          // High-end competitors might raise prices to maintain luxury positioning
          const basePriceChange = (Math.random() - 0.5) * 0.1; // -5% to +5%
          const luxuryAdjustment =
            competitor.reputation > 4 && luxuryCompetitionIntensity > 0.2
              ? 0.05
              : 0;
          const priceChange = basePriceChange + luxuryAdjustment;

          const newPrice = Math.round(
            competitor.avgRoomPrice * (1 + priceChange)
          );
          updatedCompetitor.avgRoomPrice = Math.max(40, newPrice);

          // Add notification for significant price changes from main competitors
          if (
            Math.abs(priceChange) > 0.07 &&
            competitor.rooms > 75 &&
            typeof addNotification === "function"
          ) {
            const direction = priceChange > 0 ? "increased" : "decreased";
            const reason =
              priceChange > 0 && luxuryCompetitionIntensity > 0.2
                ? " to match your luxury positioning"
                : "";

            addNotification(
              `${
                competitor.name
              } has ${direction} their room prices by ${Math.abs(
                Math.round(priceChange * 100)
              )}%${reason}!`,
              false,
              "competitor"
            );
          }
        }

        return updatedCompetitor;
      })
    );
  };

  // Update room status (cleaning, maintenance, etc)
  const updateRoomStatus = () => {
    // Simple housekeeping logic
    const housekeepers = staff.filter(
      (employee) => employee.role === "Housekeeper"
    );
    const housekeepingQuality = housekeepers.reduce(
      (total, housekeeper) => total + housekeeper.skill,
      0
    );

    setRooms((prevRooms) =>
      prevRooms.map((room) => {
        if (!room.occupied) {
          // Empty rooms get cleaned and quality slightly improved based on housekeeping
          const qualityBoost = housekeepingQuality * 0.05;
          return {
            ...room,
            quality: Math.min(5, room.quality + qualityBoost),
          };
        }
        return room;
      })
    );
  };

  // Update staff status (happiness, skills)
  const updateStaffStatus = () => {
    setStaff((prevStaff) =>
      prevStaff.map((employee) => {
        // Random small changes in happiness
        const happinessChange =
          Math.random() > 0.7 ? (Math.random() > 0.5 ? 0.1 : -0.1) : 0;
        // Skill improves very slowly over time
        const skillImprovement = Math.random() > 0.9 ? 0.05 : 0;

        return {
          ...employee,
          happiness: Math.min(
            5,
            Math.max(1, employee.happiness + happinessChange)
          ),
          skill: employee.skill + skillImprovement,
        };
      })
    );
  };

  // Memory-optimized marketing campaign updates with chunking
  const updateMarketingCampaigns = () => {
    // Early exit if no active campaigns (prevents unnecessary processing)
    const hasActiveCampaigns = marketingCampaigns.some(
      (campaign) => campaign.active
    );
    if (!hasActiveCampaigns) return;

    // Create a state object to hold all processing information
    // This avoids closure variable issues and potential memory leaks
    const state = {
      campaignsToProcess: marketingCampaigns.filter(
        (campaign) => campaign.active
      ),
      currentIndex: 0,
      campaignUpdates: {}, // Store campaign state changes here
      campaignsEnded: [], // Track which campaigns ended
      reputationChange: 0, // Track total reputation change
    };

    // Skip processing if no active campaigns
    if (state.campaignsToProcess.length === 0) return;

    // Process campaigns in chunks to prevent UI freezing
    const processMarketingChunk = () => {
      // Define chunk size based on performance needs
      const CHUNK_SIZE = 5;
      const endIndex = Math.min(
        state.currentIndex + CHUNK_SIZE,
        state.campaignsToProcess.length
      );

      // Process this chunk of campaigns
      for (let i = state.currentIndex; i < endIndex; i++) {
        const campaign = state.campaignsToProcess[i];
        let campaignChanged = false;

        // Apply campaign effects
        if (campaign.effect === "reputation_boost" && day % 2 === 0) {
          state.reputationChange += 0.05;
        }

        // Check if campaign has ended
        if (campaign.endDay && campaign.endDay <= day) {
          // Mark this campaign as inactive in our updates
          state.campaignUpdates[campaign.id] = { active: false };
          state.campaignsEnded.push(campaign.name);
          campaignChanged = true;
        }
      }

      // Update current index for next chunk
      state.currentIndex = endIndex;

      // Decide if we need to continue or finish
      if (state.currentIndex < state.campaignsToProcess.length) {
        // Schedule next chunk with minimal delay
        setTimeout(processMarketingChunk, 0);
      } else {
        // We're done processing, apply all changes at once
        finishMarketingUpdates(state);
      }
    };

    // Apply all state changes and send notifications
    const finishMarketingUpdates = (state) => {
      // Apply reputation change if any
      if (state.reputationChange > 0) {
        setReputation((prev) => Math.min(5, prev + state.reputationChange));
      }

      // Only update campaigns state if we have changes
      if (Object.keys(state.campaignUpdates).length > 0) {
        setMarketingCampaigns((prevCampaigns) =>
          prevCampaigns.map((campaign) => {
            const update = state.campaignUpdates[campaign.id];
            return update ? { ...campaign, ...update } : campaign;
          })
        );
      }

      // Send notifications for ended campaigns
      state.campaignsEnded.forEach((campaignName) => {
        addNotification(
          `"${campaignName}" marketing campaign has ended.`,
          false,
          "marketing"
        );
      });
    };

    // Start the chunked processing
    processMarketingChunk();
  };

  // Check for bankruptcy
  const checkBankruptcy = () => {
    if (money < -5000) {
      setGameSpeed(0); // Pause the game
      addNotification(
        "BANKRUPTCY! Your hotel is in severe debt. Game over!",
        true
      );
      setBankRuptcy(true);
    }
  };

  // Build a new room
  const buildRoom = (type) => {
    const roomType = roomTypes.find((room) => room.type === type);
    if (!roomType || money + maxValue < roomType.baseCost) {
      addNotification(`Cannot afford to build a ${type} room!`);
      return;
    }

    // Add new room
    const newRoomId =
      rooms.length > 0 ? Math.max(...rooms.map((r) => r.id)) + 1 : 1;
    const newRoom = {
      id: newRoomId,
      type: type,
      price: roomType.basePrice,
      occupied: false,
      quality: 2,
      guest: null,
    };

    setRooms((prevRooms) => [...prevRooms, newRoom]);
    setMoney((prevMoney) => prevMoney - roomType.baseCost);
    addNotification(`Built a new ${type} room for $${roomType.baseCost}`);
  };

  // Hire new staff
  const hireStaff = (role) => {
    const staffRole = staffRoles.find((r) => r.role === role);
    if (!staffRole) return;

    // Check if can afford salary
    if (money < staffRole.baseSalary * 5) {
      addNotification(`Cannot afford to hire a ${role}!`);
      return;
    }

    const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
    const newStaffId =
      staff.length > 0 ? Math.max(...staff.map((s) => s.id)) + 1 : 1;
    const newStaff = {
      id: newStaffId,
      name: firstName,
      role: role,
      salary: staffRole.baseSalary,
      skill: 1 + Math.random() * 2, // Base skill level 1-3
      happiness: 3 + Math.random() * 2, // Start moderately happy
    };

    setStaff((prevStaff) => [...prevStaff, newStaff]);
    setMoney((prevMoney) => prevMoney - staffRole.baseSalary); // First day's salary
    addNotification(
      `Hired ${firstName} as a new ${role} for $${staffRole.baseSalary}/day`
    );
  };

  // Build a new facility
  const buildFacility = (type) => {
    const facilityType = facilityTypes.find((f) => f.type === type);
    if (!facilityType) {
      addNotification(`Facility type "${type}" not found!`);
      return;
    }

    if (money < facilityType.baseCost) {
      addNotification(`Cannot afford to build a ${type}!`);
      return;
    }

    // Check if facility already exists
    if (facilities.some((f) => f.name === type)) {
      addNotification(`You already have a ${type}!`);
      return;
    }

    // Check for required staff
    const requiredStaff = facilityType.requiredStaff || [];
    for (const requiredRole of requiredStaff) {
      if (!staff.some((s) => s.role === requiredRole)) {
        addNotification(
          `You need to hire a ${requiredRole} before building a ${type}!`
        );
        return;
      }
    }

    const newFacilityId =
      facilities.length > 0 ? Math.max(...facilities.map((f) => f.id)) + 1 : 1;
    const newFacility = {
      id: newFacilityId,
      name: type,
      level: 1,
      upkeep: facilityType.upkeep,
    };

    setFacilities((prevFacilities) => [...prevFacilities, newFacility]);
    setMoney((prevMoney) => prevMoney - facilityType.baseCost);
    addNotification(`Built a new ${type} for $${facilityType.baseCost}`);
  };

  // Adjust room prices
  const adjustRoomPrice = (roomId, newPrice) => {
    setRooms((prevRooms) =>
      prevRooms.map((room) => {
        if (room.id === roomId) {
          return { ...room, price: newPrice };
        }
        return room;
      })
    );
  };

  // Launch marketing campaign
  const launchMarketingCampaign = (campaignId) => {
    const campaign = marketingCampaigns.find((c) => c.id === campaignId);

    if (!campaign || campaign.active || money + maxValue < campaign.cost) {
      addNotification(
        `Cannot afford to create marketing ${campaign} campaign!`
      );
      return;
    }

    // Deduct cost
    setMoney((prev) => prev - campaign.cost);

    // Activate campaign
    setMarketingCampaigns((prev) =>
      prev.map((c) =>
        c.id === campaignId
          ? { ...c, active: true, endDay: day + c.duration }
          : c
      )
    );

    addNotification(
      `Started "${campaign.name}" marketing campaign for ${campaign.duration} days.`,
      true,
      "marketing"
    );
  };

  // Conduct staff training
  const conductTraining = (trainingId, staffId) => {
    const training = trainingPrograms.find((t) => t.id === trainingId);
    const employee = staff.find((s) => s.id === staffId);

    if (!training || !employee || money < training.cost) return;

    // Deduct cost
    setMoney((prev) => prev - training.cost);

    // Improve staff skills and happiness
    setStaff((prev) =>
      prev.map((s) =>
        s.id === staffId
          ? {
              ...s,
              skill: Math.min(5, s.skill + training.skillBoost),
              happiness: Math.min(5, s.happiness + training.happiness),
            }
          : s
      )
    );

    addNotification(
      `${employee.name} completed "${training.name}" training. Skills improved!`,
      false,
      "training"
    );
  };

  // Achievements system
  const [achievements, setAchievements] = useState([
    {
      id: "first_guest",
      title: "First Guest",
      description: "Welcome your first hotel guest",
      unlocked: false,
    },
    {
      id: "five_rooms",
      title: "Expanding",
      description: "Own 5 or more rooms",
      unlocked: false,
    },
    {
      id: "high_rating",
      title: "Five Stars",
      description: "Reach a 5-star reputation",
      unlocked: false,
    },
    {
      id: "profitable",
      title: "Profitable Business",
      description: "Earn $5,000 in a single day",
      unlocked: false,
    },
    {
      id: "full_house",
      title: "Full House",
      description: "Have all rooms occupied at once",
      unlocked: false,
    },
    {
      id: "staff_five",
      title: "Job Creator",
      description: "Hire 5 staff members",
      unlocked: false,
    },
    {
      id: "facility_all",
      title: "Full Service",
      description: "Build one of each facility type",
      unlocked: false,
    },
    // NEW: Market-related achievements
    {
      id: "market_leader",
      title: "Market Leader",
      description: "Achieve 50% market share",
      unlocked: false,
    },
    {
      id: "competitor_crusher",
      title: "Competitor Crusher",
      description: "Hold the highest reputation in the market",
      unlocked: false,
    },
  ]);

  // Check for achievements
  const checkAchievements = () => {
    const newAchievements = [...achievements];
    let achievementUnlocked = false;

    // First guest
    if (
      !newAchievements.find((a) => a.id === "first_guest").unlocked &&
      guests.length > 0
    ) {
      newAchievements.find((a) => a.id === "first_guest").unlocked = true;
      achievementUnlocked = true;
    }

    // 5 or more rooms
    if (
      !newAchievements.find((a) => a.id === "five_rooms").unlocked &&
      rooms.length >= 5
    ) {
      newAchievements.find((a) => a.id === "five_rooms").unlocked = true;
      achievementUnlocked = true;
    }

    // 5-star reputation
    if (
      !newAchievements.find((a) => a.id === "high_rating").unlocked &&
      reputation >= 4.8
    ) {
      newAchievements.find((a) => a.id === "high_rating").unlocked = true;
      achievementUnlocked = true;
    }

    // Full house
    if (
      !newAchievements.find((a) => a.id === "full_house").unlocked &&
      rooms.length > 0 &&
      rooms.every((room) => room.occupied)
    ) {
      newAchievements.find((a) => a.id === "full_house").unlocked = true;
      achievementUnlocked = true;
    }

    // 5 staff members
    if (
      !newAchievements.find((a) => a.id === "staff_five").unlocked &&
      staff.length >= 5
    ) {
      newAchievements.find((a) => a.id === "staff_five").unlocked = true;
      achievementUnlocked = true;
    }

    // One of each facility
    if (
      !newAchievements.find((a) => a.id === "facility_all").unlocked &&
      facilityTypes.every((type) =>
        facilities.some((f) => f.name === type.type)
      )
    ) {
      newAchievements.find((a) => a.id === "facility_all").unlocked = true;
      achievementUnlocked = true;
    }

    // NEW: Market leader
    if (
      !newAchievements.find((a) => a.id === "market_leader").unlocked &&
      marketShare >= 50
    ) {
      newAchievements.find((a) => a.id === "market_leader").unlocked = true;
      achievementUnlocked = true;
    }

    // NEW: Competitor crusher
    if (
      !newAchievements.find((a) => a.id === "competitor_crusher").unlocked &&
      competitors.every((c) => c.reputation < reputation)
    ) {
      newAchievements.find(
        (a) => a.id === "competitor_crusher"
      ).unlocked = true;
      achievementUnlocked = true;
    }

    if (achievementUnlocked) {
      setAchievements(newAchievements);
      const unlockedAchievement = newAchievements.find(
        (a) =>
          a.unlocked && !achievements.find((old) => old.id === a.id).unlocked
      );
      if (unlockedAchievement) {
        addNotification(
          `🏆 ACHIEVEMENT UNLOCKED: ${unlockedAchievement.title} - ${unlockedAchievement.description}`,
          true
        );
      }
    }
  };

  const addNotification = (message, isSpecial = false, type = "general") => {
    const newNotification = {
      id: uuidv4(),
      message,
      timestamp: day, // Use the current game day
      isSpecial,
      type,
    };

    // Create a unique hash for the notification content for de-duplication
    const notificationHash = `${day}-${type}-${message}`;
    console.log(
      `addNotification Check: Hash=${notificationHash}, Processed Size=${
        processedEvents.size
      }, Has? ${processedEvents.has(notificationHash)}`
    );

    // Check if this event hash has already been processed using the state variable
    if (!processedEvents.has(notificationHash)) {
      console.log(`ADDING Notification with Hash: ${notificationHash}`);
      // Update notifications state (prepend new notification)
      setNotifications((prevNotifications) => {
        const updatedNotifications = [newNotification, ...prevNotifications];
        // Save the updated list to localStorage
        try {
          localStorage.setItem(
            "hotelTycoonNotifications",
            JSON.stringify(updatedNotifications)
          );
        } catch (error) {
          console.error("Error saving notifications to localStorage:", error);
          // Handle potential storage errors (e.g., quota exceeded)
        }
        return updatedNotifications;
      });

      // Update the processedEvents state by adding the new hash
      setProcessedEvents((prevSet) => {
        const newSet = new Set(prevSet); // Create a new Set based on the previous state
        newSet.add(notificationHash);
        return newSet; // Return the new Set
      });
    } else {
      console.log(`SKIPPING Notification with Hash: ${notificationHash}`);
    }
  };

  // Upgrade a room (Simpler version with scaled cost)
  const upgradeRoom = (roomId) => {
    // 1. Find the room
    const roomIndex = rooms.findIndex((r) => r.id === roomId); // Use findIndex for easier update later
    if (roomIndex === -1) {
      console.error(`Room with ID ${roomId} not found for upgrade.`);
      return;
    }
    const room = rooms[roomIndex];

    // 2. Check if already at max quality
    const MAX_QUALITY = 5; // Define max quality here
    if (room.quality >= MAX_QUALITY) {
      addNotification(`Room ${room.id} (${room.type}) is already at maximum quality!`, false, "info");
      return;
    }

    // 3. Calculate a more scaled upgrade cost
    // Cost increases more significantly as quality gets higher
    const baseUpgradeCost = 600; // A base cost for any upgrade
    const qualityCostMultiplier = 1.6; // Makes each step significantly more expensive than the last
    // Cost = Base * (Multiplier ^ CurrentQuality)
    const upgradeCost = Math.floor(
      baseUpgradeCost * Math.pow(qualityCostMultiplier, room.quality)
    );
    // Example costs:
    // Q1 -> Q2: 600 * (1.6^1) = 960
    // Q2 -> Q3: 600 * (1.6^2) = 600 * 2.56 = 1536
    // Q3 -> Q4: 600 * (1.6^3) = 600 * 4.096 = 2457
    // Q4 -> Q5: 600 * (1.6^4) = 600 * 6.5536 = 3932

    // 4. Check affordability
    if (money < upgradeCost) {
      addNotification(`Need $${formatCurrency(upgradeCost)} to upgrade Room ${room.id}, but only have $${formatCurrency(money)}.`, false, "error");
      return;
    }

    // 5. Apply the upgrade instantly
    const newQuality = room.quality + 1;
    setRooms((prevRooms) =>
      prevRooms.map((r) => {
        if (r.id === roomId) {
          // Directly update the quality
          return { ...r, quality: newQuality };
        }
        return r;
      })
    );

    setMoney((prevMoney) => prevMoney - upgradeCost);

    // 7. Notify the player
    addNotification(
      `Upgraded Room ${room.id} (${room.type}) to quality level ${newQuality}. Cost: $${formatCurrency(upgradeCost)}`, true, "success" // Use 'success' type
    );
  };

  // Fire staff member
  const fireStaff = (staffId) => {
    const employee = staff.find((s) => s.id === staffId);
    if (!employee) return;

    setStaff((prevStaff) => prevStaff.filter((s) => s.id !== staffId));
    addNotification(
      `Fired ${employee.name} from their position as ${employee.role}`
    );
  };

  // Upgrade a facility
  const upgradeFacility = (facilityId) => {
    const facility = facilities.find((f) => f.id === facilityId);
    if (!facility) return;

    const upgradeCost = 5000 * facility.level;
    if (money < upgradeCost) {
      addNotification(`Cannot afford to upgrade ${facility.name}!`);
      return;
    }

    if (facility.level >= 5) {
      addNotification(`${facility.name} is already at maximum level!`);
      return;
    }

    setFacilities((prevFacilities) =>
      prevFacilities.map((f) => {
        if (f.id === facilityId) {
          return {
            ...f,
            level: f.level + 1,
            upkeep: Math.round(f.upkeep * 1.2), // Increase upkeep with level
          };
        }
        return f;
      })
    );

    setMoney((prevMoney) => prevMoney - upgradeCost);
    addNotification(`Upgraded ${facility.name} to level ${facility.level + 1}`);
  };

  // Change hotel policy
  const changePolicy = (policyKey, newValue) => {
    setPolicies((prev) => ({
      ...prev,
      [policyKey]: newValue,
    }));

    // Policies affect guest happiness and booking rates
    const policyEffect = () => {
      switch (policyKey) {
        case "petFriendly":
          return newValue
            ? "Pet-friendly policy attracts more families."
            : "Standard pet policy restored.";
        case "earlyCheckin":
          return newValue
            ? "Early check-in improves guest satisfaction."
            : "Standard check-in time restored.";
        case "lateCheckout":
          return newValue
            ? "Late check-out is popular with business travelers."
            : "Standard check-out time restored.";
        case "freeCancellation":
          return newValue
            ? "Free cancellation increases bookings but may lead to empty rooms."
            : "Cancellation fees restored.";
        case "breakfastIncluded":
          return newValue
            ? "Complimentary breakfast is highly rated by guests."
            : "Breakfast is now charged separately.";
        default:
          return "Policy updated.";
      }
    };

    addNotification(`Policy change: ${policyEffect()}`, false, "policy");
  };

  const saveGame = async () => {
    if (!saveName.trim()) {
      addNotification(
        "Please enter a name for your saved game.",
        false,
        "system"
      );
      return;
    }

    // Create game state object
    const gameState = {
      name: saveName,
      date: new Date().toLocaleString(),
      day,
      money,
      reputation,
      rooms,
      staff,
      facilities,
      guests,
      policies,
      competitors,
      marketShare,
      achievements,
      marketData,
    };

    // Set loading state
    setIsSaving(true);

    try {
      // Save to cloud database using the API service
      const response = await gameAPI.saveGame(saveName, gameState);

      // If saved successfully, add to local list with the server-generated ID
      const newSavedGame = {
        ...gameState,
        id: response.data.saveId,
      };

      const newSavedGames = [...savedGames, newSavedGame];
      setSavedGames(newSavedGames);

      // Also save to localStorage as backup
      try {
        localStorage.setItem(
          "hotelClashSavedGames",
          JSON.stringify(newSavedGames)
        );
      } catch (localError) {
        console.error("Error saving to localStorage:", localError);
      }

      addNotification(
        `Game saved successfully to cloud as "${saveName}"`,
        true,
        "system"
      );
    } catch (error) {
      console.error("Error saving game to server:", error);

      // Fall back to localStorage-only save if server save fails
      const newSavedGames = [...savedGames, gameState];
      setSavedGames(newSavedGames);

      try {
        localStorage.setItem(
          "hotelClashSavedGames",
          JSON.stringify(newSavedGames)
        );
        addNotification(
          `Game saved to local storage as "${saveName}" (cloud save failed)`,
          false,
          "system"
        );
      } catch (localError) {
        addNotification(
          "Error saving game. Browser storage might be full.",
          false,
          "system"
        );
      }
    } finally {
      const saveNotification = {
        id: Date.now(),
        message: `Game saved successfully as "${saveName}"`,
        timestamp: day,
        isSpecial: false,
        type: "system",
      };

      // Update notifications with the new save notification without limiting the count
      setNotifications((prev) => {
        const updated = [saveNotification, ...prev];
        // Update localStorage
        localStorage.setItem(
          "hotelTycoonNotifications",
          JSON.stringify(updated)
        );
        return updated;
      });

      setIsSaving(false);
      setShowSaveModal(false);
      setSaveName("");
    }
  };

  const loadSavedGamesFromServer = async () => {
    setIsLoading(true);

    try {
      // Get saved games from Firebase
      const response = await gameAPI.getSavedGames();

      // Merge cloud saves with any local saves
      const cloudSaves = response.data.savedGames || [];
      setCloudSavedGames(cloudSaves);

      // Load local saves as backup
      const localSavesString = localStorage.getItem("hotelClashSavedGames");
      let localSaves = [];

      if (localSavesString) {
        try {
          localSaves = JSON.parse(localSavesString);
        } catch (e) {
          console.error("Error parsing local saves", e);
        }
      }

      // Combine cloud and local saves, prioritizing cloud versions when IDs match
      const cloudSaveIds = new Set(cloudSaves.map((save) => save.id));
      const filteredLocalSaves = localSaves.filter(
        (save) => !cloudSaveIds.has(save.id)
      );

      const combinedSaves = [...cloudSaves, ...filteredLocalSaves];
      setSavedGames(combinedSaves);

      addNotification(
        `Loaded ${cloudSaves.length} cloud saves and ${filteredLocalSaves.length} local saves.`,
        true,
        "system"
      );
    } catch (error) {
      console.error("Error loading saved games from server:", error);

      // Fall back to localStorage if server fails
      const localSavesString = localStorage.getItem("hotelClashSavedGames");

      if (localSavesString) {
        try {
          const localSaves = JSON.parse(localSavesString);
          setSavedGames(localSaves);
          addNotification(
            "Loaded local saved games (cloud load failed).",
            false,
            "system"
          );
        } catch (e) {
          console.error("Error loading local saved games", e);
          addNotification(
            "Error loading saved games from local storage.",
            false,
            "system"
          );
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  const loadGame = async (savedGame) => {
    setIsLoading(true);

    try {
      let gameData = savedGame;

      // If this is a cloud save with an ID, load the latest version from the server
      if (
        savedGame.id &&
        cloudSavedGames.some((save) => save.id === savedGame.id)
      ) {
        try {
          const response = await gameAPI.loadSavedGame(savedGame.id);
          gameData = response.data.savedGame;
        } catch (error) {
          console.error("Error loading game from server:", error);
          addNotification(
            "Couldn't load from server, using local copy instead.",
            false,
            "system"
          );
          // Continue with the local copy
        }
      }

      // Set all game state from saved game
      setDay(gameData.day);
      setMoney(gameData.money);
      setReputation(gameData.reputation);
      setRooms(gameData.rooms);
      setStaff(gameData.staff);
      setFacilities(gameData.facilities);
      setGuests(gameData.guests);
      setPolicies(
        gameData.policies || {
          petFriendly: false,
          earlyCheckin: false,
          lateCheckout: false,
          freeCancellation: false,
          breakfastIncluded: false,
        }
      );
      setCompetitors(gameData.competitors || competitors);
      setMarketShare(gameData.marketShare || 0);
      setAchievements(gameData.achievements || achievements);
      setMarketData(
        gameData.marketData || [{ day: 0, share: 0, reputation: 3 }]
      );

      // Pause game after loading
      setGameSpeed(0);

      addNotification(
        `Game "${gameData.name}" loaded successfully! Game is paused.`,
        true,
        "system"
      );
    } catch (error) {
      console.error("Error in loadGame:", error);
      addNotification("Error loading game. Please try again.", false, "system");
    } finally {
      setIsLoading(false);
      setShowLoadModal(false);

      const loadNotification = {
        id: Date.now(),
        message: `Game loaded successfully! Game is paused.`,
        timestamp: Date.now().toString(),
        isSpecial: true,
        type: "system",
      };

      // Get existing notifications from localStorage
      let existingNotifications = [];
      try {
        const storedNotifications = localStorage.getItem(
          "hotelTycoonNotifications"
        );
        if (storedNotifications) {
          existingNotifications = JSON.parse(storedNotifications);
        }
      } catch (e) {
        console.error("Error loading notifications", e);
      }

      // Update notifications with the new load notification without limiting the count
      const updatedNotifications = [loadNotification, ...existingNotifications];
      setNotifications(updatedNotifications);

      // Also update localStorage
      localStorage.setItem(
        "hotelTycoonNotifications",
        JSON.stringify(updatedNotifications)
      );
    }
  };

  // Delete a saved game
  const deleteSavedGame = async (saveId, index) => {
    try {
      // If it's a cloud save with an ID
      if (saveId) {
        await gameAPI.deleteSavedGame(saveId);
      }

      // Update local state regardless
      const newSavedGames = [...savedGames];
      newSavedGames.splice(index, 1);
      setSavedGames(newSavedGames);

      // Update localStorage
      localStorage.setItem(
        "hotelClashSavedGames",
        JSON.stringify(newSavedGames)
      );

      addNotification("Saved game deleted successfully.", true, "system");
    } catch (error) {
      console.error("Error deleting saved game:", error);
      addNotification(
        "Error deleting from cloud, but removed from local list.",
        false,
        "system"
      );

      // Still remove from local list even if cloud delete fails
      const newSavedGames = [...savedGames];
      newSavedGames.splice(index, 1);
      setSavedGames(newSavedGames);
      localStorage.setItem(
        "hotelClashSavedGames",
        JSON.stringify(newSavedGames)
      );
    }
  };

  // Load saved games from localStorage on initial mount
  useEffect(() => {
    const savedGamesString = localStorage.getItem("hotelTycoonSavedGames");
    if (savedGamesString) {
      try {
        const parsed = JSON.parse(savedGamesString);
        if (Array.isArray(parsed)) {
          setSavedGames(parsed);
        }
      } catch (e) {
        console.error("Error loading saved games", e);
      }
    }
  }, []);

  // Check achievements in game loop
  useEffect(() => {
    checkAchievements();
  }, [rooms, guests, reputation, staff, facilities, marketShare]);

  // Format money display
  const formatMoney = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  // Render star rating (1-5)
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <Star
          key={`full-${i}`}
          className="w-4 h-4 text-yellow-400 fill-yellow-400"
        />
      );
    }

    if (hasHalfStar) {
      stars.push(
        <Star
          key="half"
          className="w-4 h-4 text-yellow-400 fill-yellow-400 opacity-50"
        />
      );
    }

    const emptyStars = 5 - stars.length;
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<Star key={`empty-${i}`} className="w-4 h-4 text-gray-300" />);
    }

    return <div className="flex">{stars}</div>;
  };

  // Calculate stats for the room dashboard
  const occupancyRate =
    rooms.length > 0
      ? Math.round(
          (rooms.filter((r) => r.occupied).length / rooms.length) * 100
        )
      : 0;

  const avgRoomPrice =
    rooms.length > 0
      ? Math.round(
          rooms.reduce((sum, room) => sum + room.price, 0) / rooms.length
        )
      : 0;

  const avgRoomQuality =
    rooms.length > 0
      ? rooms.reduce((sum, room) => sum + room.quality, 0) / rooms.length
      : 0;

  const sortNotifications = (notificationsToSort) => {
    // Return a new sorted array, don't mutate the original state array
    return [...notificationsToSort].sort((a, b) => {
      // Extract day number - assuming 'timestamp' reliably holds the day number
      const dayA = a.timestamp;
      const dayB = b.timestamp;

      // Sort primarily by day in descending order (newest day first)
      if (dayA !== dayB) {
        return dayB - dayA;
      }

      // For same day, use ID (timestamp from Date.now()) to break ties, descending (newest first)
      // Add safety checks for potentially undefined IDs
      return (b.id || 0) - (a.id || 0);
    });
  };

  // In your render method
  const sortedNotifications = sortNotifications(notifications);

  return (
    <div className="min-h-[100dvh] bg-gray-100 p-4">
      <div className="max-w-6xl mx-auto px-4">
        {/* Header section */}
        <header className="bg-gradient-to-r from-blue-700 to-indigo-800 text-white p-3 sm:p-5 rounded-lg shadow-xl mb-6 relative overflow-hidden">
          {/* Decorative background elements */}
          <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none z-0">
            <div className="absolute top-0 right-0 w-32 h-32 bg-yellow-300 rounded-full blur-xl"></div>
            <div className="absolute bottom-0 left-0 w-40 h-40 bg-blue-400 rounded-full blur-xl"></div>
          </div>

          <div className="flex flex-col md:flex-row justify-between md:items-center relative z-10">
            {/* Logo and Title */}
            <div className="flex items-center mb-4 md:mb-0">
              <div className="bg-white rounded-full p-1 mr-3 shadow-lg">
                <img
                  src="/logo.png"
                  alt="Luxury Hotel Tycoon Logo"
                  className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
                />
              </div>
              <div>
                <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">
                  HotelHero
                </h1>
                <div className="text-xs text-blue-200 mt-1">
                  Building your hospitality empire, one 5-star review at a time
                </div>
              </div>
            </div>

            {/* Stats Panel */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
              <div className="flex items-center bg-blue-900 bg-opacity-40 p-2 rounded-lg border border-blue-600 shadow-inner hover:bg-opacity-50 transition-all group">
                <DollarSign className="mr-2 text-green-300 w-5 h-5 group-hover:scale-110 transition-transform" />
                <div>
                  <div className="font-bold text-sm sm:text-base">
                    {formatMoney(money)}
                  </div>
                  <div className="text-xs text-blue-200">Balance</div>
                </div>
              </div>

              <div className="flex items-center bg-blue-900 bg-opacity-40 p-2 rounded-lg border border-blue-600 shadow-inner hover:bg-opacity-50 transition-all group">
                <Clock className="mr-2 text-yellow-300 w-5 h-5 group-hover:scale-110 transition-transform" />
                <div>
                  <div className="text-sm sm:text-base">Day {day}</div>
                  <div className="text-xs text-blue-200">Game Time</div>
                </div>
              </div>

              <div className="flex items-center bg-blue-900 bg-opacity-40 p-2 rounded-lg border border-blue-600 shadow-inner hover:bg-opacity-50 transition-all group">
                <Award className="mr-2 text-yellow-300 w-5 h-5 group-hover:scale-110 transition-transform" />
                <div>
                  <div className="text-sm sm:text-base">
                    {renderStars(reputation)}
                  </div>
                  <div className="text-xs text-blue-200">Reputation</div>
                </div>
              </div>

              <div className="flex items-center bg-blue-900 bg-opacity-40 p-2 rounded-lg border border-blue-600 shadow-inner hover:bg-opacity-50 transition-all group">
                <BarChart className="mr-2 text-yellow-300 w-5 h-5 group-hover:scale-110 transition-transform" />
                <div>
                  <div className="text-sm sm:text-base">{marketShare}%</div>
                  <div className="text-xs text-blue-200">Market Share</div>
                </div>
              </div>
            </div>
          </div>

          {/* Game controls, Premium Currency & Save/Load buttons - FIXED SECTION */}
          <div className="mt-4 flex flex-col sm:flex-row gap-3 items-center justify-between w-full max-w-full overflow-x-auto pb-2">
            {/* Game Controls - Fixed buttons */}
            <div className="flex flex-wrap gap-1.5 sm:gap-2 w-full sm:w-auto justify-center sm:justify-start">
              <button
                onClick={() => setShowTutorialModal(true)}
                className="text-sm px-3 py-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 active:bg-blue-300 transition-colors flex items-center cursor-pointer"
                type="button"
                aria-label="Show Tutorial"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="w-4 h-4 mr-1.5"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                  <path d="M12 17h.01"></path>
                </svg>
                <span>Tutorial</span>
              </button>

              <button
                onClick={() => setGameSpeed(0)}
                className={`min-w-16 px-3 sm:px-4 py-2 rounded-lg flex items-center justify-center transition-all text-sm cursor-pointer ${
                  gameSpeed === 0
                    ? "bg-white text-blue-700 shadow-lg font-medium"
                    : "bg-blue-700 hover:bg-blue-600 active:bg-blue-800 border border-blue-500 text-white"
                }`}
                type="button"
                aria-label="Pause Game"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 mr-1.5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>Pause</span>
              </button>

              <button
                onClick={() => setGameSpeed(1)}
                className={`min-w-16 px-3 sm:px-4 py-2 rounded-lg flex items-center justify-center transition-all text-sm cursor-pointer ${
                  gameSpeed === 1
                    ? "bg-white text-blue-700 shadow-lg font-medium"
                    : "bg-blue-700 hover:bg-blue-600 active:bg-blue-800 border border-blue-500 text-white"
                }`}
                type="button"
                aria-label="Normal Speed"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 mr-1.5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>Normal</span>
              </button>

              <button
                onClick={() => setGameSpeed(10)}
                className={`min-w-16 px-3 sm:px-4 py-2 rounded-lg flex items-center justify-center transition-all text-sm cursor-pointer ${
                  gameSpeed === 10
                    ? "bg-white text-blue-700 shadow-lg font-medium"
                    : "bg-blue-700 hover:bg-blue-600 active:bg-blue-800 border border-blue-500 text-white"
                }`}
                type="button"
                aria-label="Fast Speed"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 mr-1.5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                    clipRule="evenodd"
                  />
                  <path d="M12.555 7.168A1 1 0 0111 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" />
                </svg>
                <span>Fast</span>
              </button>
            </div>

            {/* Save/Load buttons - Fixed buttons */}
            {user &&
              !user.hasOwnProperty("isGuest") &&
              Object.keys(user).length > 0 && (
                <div className="flex gap-2 w-full sm:w-auto">
                  <button
                    onClick={() => setShowSaveModal(true)}
                    className="px-3 py-2 rounded-lg flex items-center bg-green-600 hover:bg-green-500 active:bg-green-700 text-white transition-all text-sm flex-1 sm:flex-auto justify-center shadow-md border border-green-500 cursor-pointer"
                    type="button"
                    aria-label="Save Game"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="w-4 h-4 mr-1.5"
                    >
                      <path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"></path>
                      <path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"></path>
                      <path d="M7 3v4a1 1 0 0 0 1 1h7"></path>
                    </svg>
                    <span>Save</span>
                  </button>

                  <button
                    onClick={() => setShowLoadModal(true)}
                    className="px-3 py-2 rounded-lg flex items-center bg-purple-600 hover:bg-purple-500 active:bg-purple-700 text-white transition-all text-sm flex-1 sm:flex-auto justify-center shadow-md border border-purple-500 cursor-pointer"
                    type="button"
                    aria-label="Load Game"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="w-4 h-4 mr-1.5"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                      <polyline points="7 10 12 15 17 10"></polyline>
                      <line x1="12" x2="12" y1="15" y2="3"></line>
                    </svg>
                    <span>Load</span>
                  </button>
                </div>
              )}
          </div>

          {/* Improved Hotel Performance Dashboard - replaces the old "Today's Overview" section */}
          <div className="mt-4 bg-blue-800 bg-opacity-30 rounded-lg p-3 hidden sm:block border border-blue-600">
            <div className="flex justify-between items-center mb-2">
              <div className="flex items-center">
                <BarChart2 className="w-4 h-4 mr-1.5 text-yellow-300" />
                <span className="text-xs font-medium">Daily Performance</span>
              </div>
              <div className="px-2 py-0.5 bg-blue-700 bg-opacity-50 rounded-md flex items-center">
                <Calendar className="w-3 h-3 mr-1 text-blue-200" />
                <span className="text-xs text-blue-100">
                  Day {day}:{" "}
                  {currentSeason.charAt(0).toUpperCase() +
                    currentSeason.slice(1)}
                </span>
              </div>
            </div>

            {/* Main stats grid with improved metrics */}
            <div className="grid grid-cols-3 gap-3 mb-2">
              {/* Occupancy with trend indicator */}
              <div className="bg-blue-900 bg-opacity-30 rounded-md p-2 border border-blue-700">
                <div className="flex justify-between items-center mb-1">
                  <div className="flex items-center">
                    <Users className="w-3 h-3 mr-1 text-blue-300" />
                    <span className="text-xs text-blue-200">Occupancy</span>
                  </div>
                  <div
                    className={
                      occupancyRate > 70
                        ? "text-green-400 text-xs"
                        : occupancyRate > 40
                        ? "text-yellow-400 text-xs"
                        : "text-red-400 text-xs"
                    }
                  >
                    {occupancyRate || 0}%
                    {/* Show trend arrow based on previous day's occupancy (hypothetical) */}
                    <span className="ml-1">
                      {occupancyRate > 50 ? "↑" : "↓"}
                    </span>
                  </div>
                </div>
                {/* Mini progress bar for occupancy */}
                <div className="w-full h-1.5 bg-blue-800 rounded-full overflow-hidden">
                  <div
                    className={
                      occupancyRate > 70
                        ? "h-full bg-green-500"
                        : occupancyRate > 40
                        ? "h-full bg-yellow-500"
                        : "h-full bg-red-500"
                    }
                    style={{ width: `${Math.min(100, occupancyRate)}%` }}
                  ></div>
                </div>
              </div>

              {/* Guest Satisfaction */}
              <div className="bg-blue-900 bg-opacity-30 rounded-md p-2 border border-blue-700">
                <div className="flex justify-between items-center mb-1">
                  <div className="flex items-center">
                    <ThumbsUp className="w-3 h-3 mr-1 text-green-300" />
                    <span className="text-xs text-blue-200">Satisfaction</span>
                  </div>
                  {guests.length > 0 ? (
                    <div
                      className={
                        guests.reduce(
                          (total, guest) => total + guest.happiness,
                          0
                        ) /
                          guests.length >
                        4
                          ? "text-green-400 text-xs"
                          : guests.reduce(
                              (total, guest) => total + guest.happiness,
                              0
                            ) /
                              guests.length >
                            3
                          ? "text-yellow-400 text-xs"
                          : "text-red-400 text-xs"
                      }
                    >
                      {(
                        guests.reduce(
                          (total, guest) => total + guest.happiness,
                          0
                        ) / guests.length
                      ).toFixed(1)}
                      ★
                    </div>
                  ) : (
                    <div className="text-gray-400 text-xs">N/A</div>
                  )}
                </div>
                {/* Star rating visualization */}
                {guests.length > 0 && (
                  <div className="flex">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <div
                        key={star}
                        className={
                          guests.reduce(
                            (total, guest) => total + guest.happiness,
                            0
                          ) /
                            guests.length >=
                          star
                            ? "text-yellow-400 text-xs"
                            : "text-gray-600 text-xs"
                        }
                      >
                        ★
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Market Share */}
              <div className="bg-blue-900 bg-opacity-30 rounded-md p-2 border border-blue-700">
                <div className="flex justify-between items-center mb-1">
                  <div className="flex items-center">
                    <PieChart className="w-3 h-3 mr-1 text-yellow-300" />
                    <span className="text-xs text-blue-200">Market Share</span>
                  </div>
                  <div
                    className={
                      marketShare > 40
                        ? "text-green-400 text-xs"
                        : marketShare > 20
                        ? "text-yellow-400 text-xs"
                        : "text-red-400 text-xs"
                    }
                  >
                    {marketShare}%{/* Trend based on market share value */}
                    <span className="ml-1">{marketShare > 25 ? "↑" : "↓"}</span>
                  </div>
                </div>
                {/* Market share visualization */}
                <div className="w-full h-1.5 bg-blue-800 rounded-full overflow-hidden">
                  <div
                    className={
                      marketShare > 40
                        ? "h-full bg-green-500"
                        : marketShare > 20
                        ? "h-full bg-yellow-500"
                        : "h-full bg-red-500"
                    }
                    style={{ width: `${Math.min(100, marketShare)}%` }}
                  ></div>
                </div>
              </div>
            </div>

            {/* Additional row with financial performance and forecast */}
            <div className="grid grid-cols-2 gap-3">
              {/* Daily Revenue */}
              <div className="bg-blue-900 bg-opacity-30 rounded-md p-2 border border-blue-700">
                <div className="flex justify-between items-center">
                  <div className="flex items-center">
                    <DollarSign className="w-3 h-3 mr-1 text-green-300" />
                    <span className="text-xs text-blue-200">
                      Today's Revenue
                    </span>
                  </div>
                  <div className="text-green-400 text-xs font-medium">
                    {formatMoney(
                      rooms.reduce(
                        (total, room) =>
                          total + (room.occupied ? room.price : 0),
                        0
                      )
                    )}
                  </div>
                </div>
              </div>

              {/* Season Effect */}
              <div className="bg-blue-900 bg-opacity-30 rounded-md p-2 border border-blue-700">
                <div className="flex justify-between items-center">
                  <div className="flex items-center">
                    {currentSeason === "summer" && (
                      <Sun className="w-3 h-3 mr-1 text-yellow-300" />
                    )}
                    {currentSeason === "winter" && (
                      <Snowflake className="w-3 h-3 mr-1 text-blue-300" />
                    )}
                    {currentSeason === "spring" && (
                      <Flower className="w-3 h-3 mr-1 text-pink-300" />
                    )}
                    {currentSeason === "autumn" && (
                      <Wind className="w-3 h-3 mr-1 text-orange-300" />
                    )}
                    <span className="text-xs text-blue-200">Season Effect</span>
                  </div>
                  <div className="text-xs">
                    {currentSeason === "summer" && (
                      <span className="text-yellow-300">Peak Tourism ↑</span>
                    )}
                    {currentSeason === "winter" && (
                      <span className="text-blue-300">Business Travel ↑</span>
                    )}
                    {currentSeason === "spring" && (
                      <span className="text-green-300">Balanced Demand</span>
                    )}
                    {currentSeason === "autumn" && (
                      <span className="text-orange-300">Events Season</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        <div className="bg-white p-2 rounded-lg shadow-md mb-4">
          {/* Desktop view - horizontal tabs */}
          <div className="hidden md:flex md:gap-2 md:flex-wrap">
            <button
              onClick={() => setSelectedTab("dashboard")}
              className={`px-4 py-2 rounded text-sm ${
                selectedTab === "dashboard"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex items-center">
                <BarChart2 className="w-4 h-4 mr-1" /> Dashboard
              </span>
            </button>
            <button
              onClick={() => setSelectedTab("rooms")}
              className={`px-4 py-2 rounded text-sm ${
                selectedTab === "rooms"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex items-center">
                <Bed className="w-4 h-4 mr-1" /> Rooms
              </span>
            </button>
            <button
              onClick={() => setSelectedTab("staff")}
              className={`px-4 py-2 rounded text-sm ${
                selectedTab === "staff"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex items-center">
                <Users className="w-4 h-4 mr-1" /> Staff
              </span>
            </button>
            <button
              onClick={() => setSelectedTab("facilities")}
              className={`px-4 py-2 rounded text-sm ${
                selectedTab === "facilities"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex items-center">
                <Package className="w-4 h-4 mr-1" /> Facilities
              </span>
            </button>
            <button
              onClick={() => setSelectedTab("guests")}
              className={`px-4 py-2 rounded text-sm ${
                selectedTab === "guests"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex items-center">
                <User className="w-4 h-4 mr-1" /> Guests
              </span>
            </button>
            <button
              onClick={() => setSelectedTab("marketing")}
              className={`px-4 py-2 rounded text-sm ${
                selectedTab === "marketing"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex items-center">
                <TrendingUp className="w-4 h-4 mr-1" /> Marketing
              </span>
            </button>
            <button
              onClick={() => setSelectedTab("competitors")}
              className={`px-4 py-2 rounded text-sm ${
                selectedTab === "competitors"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex items-center">
                <Building className="w-4 h-4 mr-1" /> Competition
              </span>
            </button>
            <button
              onClick={() => setSelectedTab("finance")}
              className={`px-4 py-2 rounded text-sm ${
                selectedTab === "finance"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex items-center">
                <DollarSign className="w-4 h-4 mr-1" /> Finance
              </span>
            </button>
            {user &&
              !user.hasOwnProperty("isGuest") &&
              Object.keys(user).length > 0 && (
                <button
                  onClick={() => setSelectedTab("leaderboard")}
                  className={`px-4 py-2 rounded text-sm ${
                    selectedTab === "leaderboard"
                      ? "bg-blue-600 text-white"
                      : "bg-gray-200 hover:bg-gray-300"
                  }`}
                >
                  <span className="flex items-center">
                    <Trophy className="w-4 h-4 mr-1" /> Leaderboard
                  </span>
                </button>
              )}
          </div>

          {/* Mobile view - grid layout */}
          <div className="grid grid-cols-3 gap-2 md:hidden">
            <button
              onClick={() => setSelectedTab("dashboard")}
              className={`px-2 py-2 rounded text-xs ${
                selectedTab === "dashboard"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex flex-col items-center">
                <BarChart2 className="w-4 h-4 mb-1" />
                <span>Dashboard</span>
              </span>
            </button>
            <button
              onClick={() => setSelectedTab("rooms")}
              className={`px-2 py-2 rounded text-xs ${
                selectedTab === "rooms"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex flex-col items-center">
                <Bed className="w-4 h-4 mb-1" />
                <span>Rooms</span>
              </span>
            </button>
            <button
              onClick={() => setSelectedTab("staff")}
              className={`px-2 py-2 rounded text-xs ${
                selectedTab === "staff"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex flex-col items-center">
                <Users className="w-4 h-4 mb-1" />
                <span>Staff</span>
              </span>
            </button>
            <button
              onClick={() => setSelectedTab("facilities")}
              className={`px-2 py-2 rounded text-xs ${
                selectedTab === "facilities"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex flex-col items-center">
                <Package className="w-4 h-4 mb-1" />
                <span>Facilities</span>
              </span>
            </button>
            <button
              onClick={() => setSelectedTab("guests")}
              className={`px-2 py-2 rounded text-xs ${
                selectedTab === "guests"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex flex-col items-center">
                <User className="w-4 h-4 mb-1" />
                <span>Guests</span>
              </span>
            </button>
            <button
              onClick={() => setSelectedTab("marketing")}
              className={`px-2 py-2 rounded text-xs ${
                selectedTab === "marketing"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex flex-col items-center">
                <TrendingUp className="w-4 h-4 mb-1" />
                <span>Marketing</span>
              </span>
            </button>
            <button
              onClick={() => setSelectedTab("competitors")}
              className={`px-2 py-2 rounded text-xs ${
                selectedTab === "competitors"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex flex-col items-center">
                <Building className="w-4 h-4 mb-1" />
                <span>Competition</span>
              </span>
            </button>
            <button
              onClick={() => setSelectedTab("finance")}
              className={`px-2 py-2 rounded text-xs ${
                selectedTab === "finance"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex flex-col items-center">
                <DollarSign className="w-4 h-4 mb-1" />
                <span>Finance</span>
              </span>
            </button>
            <button
              onClick={() => setSelectedTab("leaderboard")}
              className={`px-2 py-2 rounded text-xs ${
                selectedTab === "leaderboard"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              <span className="flex flex-col items-center">
                <Trophy className="w-4 h-4 mb-1" />
                <span>Leaderboard</span>
              </span>
            </button>
          </div>
        </div>
        {/* Main content area */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {/* Main panel - changes based on selected tab */}
          <div className="lg:col-span-2 bg-white p-3 sm:p-4 rounded-lg shadow-md">
            {/* Dashboard Tab */}
            {selectedTab === "dashboard" && (
              <div className="bg-white rounded-lg shadow-md p-5 mb-6">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-bold flex items-center">
                    <Hotel className="w-5 h-5 mr-2 text-blue-600" />
                    Hotel Overview
                  </h2>
                </div>

                {/* Stat cards with improved design */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                  {/* Rooms card */}
                  <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-4 rounded-lg border border-blue-200 shadow-sm transition-all hover:shadow-md">
                    <div className="flex justify-between">
                      <h3 className="font-bold flex items-center text-blue-800">
                        <Bed className="w-4 h-4 mr-2 text-blue-600" /> Rooms
                      </h3>
                      <span className="text-xs px-2 py-0.5 bg-blue-200 text-blue-800 rounded-full font-medium">
                        {rooms.length > 0
                          ? Math.round(
                              (rooms.filter((r) => r.occupied).length /
                                rooms.length) *
                                100
                            )
                          : 0}
                        % Occupied
                      </span>
                    </div>

                    <div className="mt-3 grid grid-cols-2 gap-2">
                      <div className="bg-white bg-opacity-50 p-2 rounded border border-blue-200">
                        <div className="text-xs text-blue-600 mb-1">
                          Total Rooms
                        </div>
                        <div className="text-xl font-bold text-blue-900">
                          {rooms.length}
                        </div>
                        <div className="text-xs text-blue-500 mt-1 flex items-center">
                          <Users className="w-3 h-3 mr-1" />
                          Capacity: {rooms.length * 2} guests
                        </div>
                      </div>

                      <div className="bg-white bg-opacity-50 p-2 rounded border border-blue-200">
                        <div className="text-xs text-blue-600 mb-1">
                          Room Quality
                        </div>
                        <div className="text-xl font-bold text-blue-900">
                          {rooms.length > 0
                            ? (
                                rooms.reduce(
                                  (total, room) => total + room.quality,
                                  0
                                ) / rooms.length
                              ).toFixed(1)
                            : "N/A"}
                          <span className="text-xs ml-1">/ 5</span>
                        </div>
                        <div className="flex mt-1">
                          {[1, 2, 3, 4, 5].map((star) => (
                            <Star
                              key={star}
                              className={`w-3 h-3 ${
                                star <=
                                rooms.reduce(
                                  (total, room) => total + room.quality,
                                  0
                                ) /
                                  rooms.length
                                  ? "text-yellow-400 fill-yellow-400"
                                  : "text-gray-300"
                              }`}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Staff card */}
                  <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 p-4 rounded-lg border border-indigo-200 shadow-sm transition-all hover:shadow-md">
                    <div className="flex justify-between">
                      <h3 className="font-bold flex items-center text-indigo-800">
                        <User className="w-4 h-4 mr-2 text-indigo-600" /> Staff
                      </h3>
                      <span className="text-xs px-2 py-0.5 bg-indigo-200 text-indigo-800 rounded-full font-medium">
                        {staff.length > 0
                          ? Math.round(
                              (staff.reduce(
                                (sum, emp) => sum + emp.happiness,
                                0
                              ) /
                                staff.length) *
                                20
                            )
                          : 0}
                        % Happy
                      </span>
                    </div>

                    <div className="mt-3 grid grid-cols-2 gap-2">
                      <div className="bg-white bg-opacity-50 p-2 rounded border border-indigo-200">
                        <div className="text-xs text-indigo-600 mb-1">
                          Employees
                        </div>
                        <div className="text-xl font-bold text-indigo-900">
                          {staff.length}
                        </div>
                        <div className="text-xs text-indigo-500 mt-1 flex items-center">
                          <Briefcase className="w-3 h-3 mr-1" />
                          {staff.length > 0
                            ? Math.round((rooms.length / staff.length) * 10) /
                              10
                            : 0}{" "}
                          rooms/staff
                        </div>
                      </div>

                      <div className="bg-white bg-opacity-50 p-2 rounded border border-indigo-200">
                        <div className="text-xs text-indigo-600 mb-1">
                          Daily Payroll
                        </div>
                        <div className="text-xl font-bold text-indigo-900">
                          $
                          {staff
                            .reduce(
                              (total, employee) => total + employee.salary,
                              0
                            )
                            .toLocaleString()}
                        </div>
                        <div className="text-xs text-indigo-500 mt-1 flex items-center">
                          <DollarSign className="w-3 h-3 mr-1" />$
                          {Math.round(
                            staff.reduce(
                              (total, employee) => total + employee.salary,
                              0
                            ) / Math.max(1, staff.length)
                          )}
                          /employee
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Facilities card */}
                  <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 p-4 rounded-lg border border-emerald-200 shadow-sm transition-all hover:shadow-md">
                    <div className="flex justify-between">
                      <h3 className="font-bold flex items-center text-emerald-800">
                        <Coffee className="w-4 h-4 mr-2 text-emerald-600" />{" "}
                        Facilities
                      </h3>
                      <span className="text-xs px-2 py-0.5 bg-emerald-200 text-emerald-800 rounded-full font-medium">
                        {facilities.length > 1 ? facilities.length - 1 : 0}{" "}
                        Extra
                      </span>
                    </div>

                    <div className="mt-3 grid grid-cols-2 gap-2">
                      <div className="bg-white bg-opacity-50 p-2 rounded border border-emerald-200">
                        <div className="text-xs text-emerald-600 mb-1">
                          Total Facilities
                        </div>
                        <div className="text-xl font-bold text-emerald-900">
                          {facilities.length}
                        </div>
                        <div className="text-xs text-emerald-500 mt-1 flex items-center">
                          <Award className="w-3 h-3 mr-1" />
                          Avg. Level:{" "}
                          {facilities.length > 0
                            ? (
                                facilities.reduce(
                                  (total, facility) => total + facility.level,
                                  0
                                ) / facilities.length
                              ).toFixed(1)
                            : "N/A"}
                        </div>
                      </div>

                      <div className="bg-white bg-opacity-50 p-2 rounded border border-emerald-200">
                        <div className="text-xs text-emerald-600 mb-1">
                          Maintenance
                        </div>
                        <div className="text-xl font-bold text-emerald-900">
                          $
                          {facilities
                            .reduce(
                              (total, facility) => total + facility.upkeep,
                              0
                            )
                            .toLocaleString()}
                        </div>
                        <div className="text-xs text-emerald-500 mt-1 flex items-center">
                          <PenTool className="w-3 h-3 mr-1" />$
                          {Math.round(
                            facilities.reduce(
                              (total, facility) => total + facility.upkeep,
                              0
                            ) / facilities.length
                          )}
                          /facility
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Finances card */}
                  <div className="bg-gradient-to-br from-amber-50 to-amber-100 p-4 rounded-lg border border-amber-200 shadow-sm transition-all hover:shadow-md">
                    <div className="flex justify-between">
                      <h3 className="font-bold flex items-center text-amber-800">
                        <DollarSign className="w-4 h-4 mr-2 text-amber-600" />{" "}
                        Finances
                      </h3>
                      <span
                        className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                          rooms.reduce(
                            (total, room) =>
                              total + (room.occupied ? room.price : 0),
                            0
                          ) >
                          staff.reduce(
                            (total, employee) => total + employee.salary,
                            0
                          ) +
                            facilities.reduce(
                              (total, facility) => total + facility.upkeep,
                              0
                            )
                            ? "bg-green-200 text-green-800"
                            : "bg-red-200 text-red-800"
                        }`}
                      >
                        {rooms.reduce(
                          (total, room) =>
                            total + (room.occupied ? room.price : 0),
                          0
                        ) >
                        staff.reduce(
                          (total, employee) => total + employee.salary,
                          0
                        ) +
                          facilities.reduce(
                            (total, facility) => total + facility.upkeep,
                            0
                          )
                          ? "Profitable"
                          : "Unprofitable"}
                      </span>
                    </div>

                    <div className="mt-3 grid grid-cols-2 gap-2">
                      <div className="bg-white bg-opacity-50 p-2 rounded border border-amber-200">
                        <div className="text-xs text-amber-600 mb-1">
                          Daily Revenue
                        </div>
                        <div className="text-xl font-bold text-green-600">
                          +$
                          {rooms
                            .reduce(
                              (total, room) =>
                                total + (room.occupied ? room.price : 0),
                              0
                            )
                            .toLocaleString()}
                        </div>
                        <div className="text-xs text-amber-500 mt-1 flex items-center">
                          <TrendingUp className="w-3 h-3 mr-1" />$
                          {Math.round(
                            rooms.reduce(
                              (total, room) =>
                                total + (room.occupied ? room.price : 0),
                              0
                            ) /
                              Math.max(
                                1,
                                rooms.filter((r) => r.occupied).length
                              )
                          )}
                          /occupied room
                        </div>
                      </div>

                      <div className="bg-white bg-opacity-50 p-2 rounded border border-amber-200">
                        <div className="text-xs text-amber-600 mb-1">
                          Daily Expenses
                        </div>
                        <div className="text-xl font-bold text-red-600">
                          -$
                          {(
                            staff.reduce(
                              (total, employee) => total + employee.salary,
                              0
                            ) +
                            facilities.reduce(
                              (total, facility) => total + facility.upkeep,
                              0
                            )
                          ).toLocaleString()}
                        </div>
                        <div className="text-xs text-amber-500 mt-1 flex items-center">
                          <ArrowDown className="w-3 h-3 mr-1" />$
                          {Math.round(
                            (staff.reduce(
                              (total, employee) => total + employee.salary,
                              0
                            ) +
                              facilities.reduce(
                                (total, facility) => total + facility.upkeep,
                                0
                              )) /
                              (staff.length + facilities.length)
                          )}
                          /entity
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Market Share Graph with improved responsive container */}
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-200 shadow-sm p-4 mb-6 overflow-hidden">
                  <h3 className="font-bold mb-3 flex items-center text-gray-800">
                    <BarChart3 className="w-4 h-4 mr-2 text-blue-600" />
                    Market Performance
                  </h3>
                  <div className="w-full overflow-x-auto">
                    <div className="min-w-full min-h-[250px]">
                      <MarketShareGraph data={marketData} />
                    </div>
                  </div>
                </div>

                {/* Seasons information with improved visual design */}
                <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-4 rounded-lg mb-4 border border-blue-200 shadow-sm">
                  <h3 className="font-bold mb-3 flex items-center text-blue-800">
                    <Zap className="w-5 h-5 mr-2 text-yellow-500" />
                    Seasonal Effects
                  </h3>

                  <div className="text-sm mb-4 text-gray-700">
                    Each season affects guest preferences, booking rates, and
                    revenue potential differently:
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 text-sm">
                    {/* Spring Card */}
                    <div
                      className={`p-3 rounded-lg transition-all ${
                        currentSeason === "spring"
                          ? "bg-green-100 border-2 border-green-300 shadow"
                          : "bg-white border border-gray-200"
                      }`}
                    >
                      <div className="font-bold mb-2 flex items-center text-green-800">
                        <Flower className="w-4 h-4 mr-1.5 text-green-600" />
                        Spring
                        {currentSeason === "spring" && (
                          <span className="ml-auto text-xs px-1.5 py-0.5 bg-green-200 rounded-full">
                            Active
                          </span>
                        )}
                      </div>
                      <div className="space-y-1">
                        <div className="flex items-center text-green-700">
                          <ArrowRight className="w-3 h-3 mr-1.5 flex-shrink-0" />
                          <span>Moderate booking rates</span>
                        </div>
                        <div className="flex items-center text-green-700">
                          <ArrowRight className="w-3 h-3 mr-1.5 flex-shrink-0" />
                          <span>Balance of business and leisure</span>
                        </div>
                        <div className="flex items-center text-green-700">
                          <ArrowRight className="w-3 h-3 mr-1.5 flex-shrink-0" />
                          <span>Outdoor facilities more popular</span>
                        </div>
                      </div>
                    </div>

                    {/* Summer Card */}
                    <div
                      className={`p-3 rounded-lg transition-all ${
                        currentSeason === "summer"
                          ? "bg-yellow-100 border-2 border-yellow-300 shadow"
                          : "bg-white border border-gray-200"
                      }`}
                    >
                      <div className="font-bold mb-2 flex items-center text-yellow-800">
                        <Sun className="w-4 h-4 mr-1.5 text-yellow-600" />
                        Summer
                        {currentSeason === "summer" && (
                          <span className="ml-auto text-xs px-1.5 py-0.5 bg-yellow-200 rounded-full">
                            Active
                          </span>
                        )}
                      </div>
                      <div className="space-y-1">
                        <div className="flex items-center text-yellow-700">
                          <ArrowRight className="w-3 h-3 mr-1.5 flex-shrink-0" />
                          <span>High booking rates</span>
                        </div>
                        <div className="flex items-center text-yellow-700">
                          <ArrowRight className="w-3 h-3 mr-1.5 flex-shrink-0" />
                          <span>More families and tourists</span>
                        </div>
                        <div className="flex items-center text-yellow-700">
                          <ArrowRight className="w-3 h-3 mr-1.5 flex-shrink-0" />
                          <span>Pool facilities highly valued</span>
                        </div>
                      </div>
                    </div>

                    {/* Autumn Card */}
                    <div
                      className={`p-3 rounded-lg transition-all ${
                        currentSeason === "autumn"
                          ? "bg-orange-100 border-2 border-orange-300 shadow"
                          : "bg-white border border-gray-200"
                      }`}
                    >
                      <div className="font-bold mb-2 flex items-center text-orange-800">
                        <Wind className="w-4 h-4 mr-1.5 text-orange-600" />
                        Autumn
                        {currentSeason === "autumn" && (
                          <span className="ml-auto text-xs px-1.5 py-0.5 bg-orange-200 rounded-full">
                            Active
                          </span>
                        )}
                      </div>
                      <div className="space-y-1">
                        <div className="flex items-center text-orange-700">
                          <ArrowRight className="w-3 h-3 mr-1.5 flex-shrink-0" />
                          <span>Moderate booking rates</span>
                        </div>
                        <div className="flex items-center text-orange-700">
                          <ArrowRight className="w-3 h-3 mr-1.5 flex-shrink-0" />
                          <span>More business travelers</span>
                        </div>
                        <div className="flex items-center text-orange-700">
                          <ArrowRight className="w-3 h-3 mr-1.5 flex-shrink-0" />
                          <span>Conference facilities in demand</span>
                        </div>
                      </div>
                    </div>

                    {/* Winter Card */}
                    <div
                      className={`p-3 rounded-lg transition-all ${
                        currentSeason === "winter"
                          ? "bg-blue-100 border-2 border-blue-300 shadow"
                          : "bg-white border border-gray-200"
                      }`}
                    >
                      <div className="font-bold mb-2 flex items-center text-blue-800">
                        <Snowflake className="w-4 h-4 mr-1.5 text-blue-600" />
                        Winter
                        {currentSeason === "winter" && (
                          <span className="ml-auto text-xs px-1.5 py-0.5 bg-blue-200 rounded-full">
                            Active
                          </span>
                        )}
                      </div>
                      <div className="space-y-1">
                        <div className="flex items-center text-blue-700">
                          <ArrowRight className="w-3 h-3 mr-1.5 flex-shrink-0" />
                          <span>Lower booking rates</span>
                        </div>
                        <div className="flex items-center text-blue-700">
                          <ArrowRight className="w-3 h-3 mr-1.5 flex-shrink-0" />
                          <span>Spa services more popular</span>
                        </div>
                        <div className="flex items-center text-blue-700">
                          <ArrowRight className="w-3 h-3 mr-1.5 flex-shrink-0" />
                          <span>Indoor amenities preferred</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <CompetitorManagerTab
              selectedTab={selectedTab}
              marketShare={marketShare}
              competitors={competitors}
              marketingCampaigns={marketingCampaigns}
              money={money}
              launchMarketingCampaign={launchMarketingCampaign}
            />

            <RoomManagementTab
              selectedTab={selectedTab}
              roomTypes={roomTypes}
              buildRoom={buildRoom}
              money={money}
              rooms={rooms}
              renderStars={renderStars}
              adjustRoomPrice={adjustRoomPrice}
              upgradeRoom={upgradeRoom}
              occupancyRate={occupancyRate}
              avgRoomPrice={avgRoomPrice}
              avgRoomQuality={avgRoomQuality}
            />

            <StaffManagementTab
              selectedTab={selectedTab}
              staffRoles={staffRoles}
              hireStaff={hireStaff}
              fireStaff={fireStaff}
              staff={staff}
              rooms={rooms}
              facilities={facilities}
              guests={guests}
              setSelectedTab={setSelectedTab}
            />

            {/* Facilities Tab */}
            {selectedTab === "facilities" && (
              <FacilityManagementTab
                selectedTab={selectedTab}
                facilityTypes={facilityTypes}
                buildFacility={buildFacility}
                upgradeFacility={upgradeFacility}
                money={money}
                staff={staff}
                facilities={facilities}
                renderStars={renderStars}
                guests={guests}
                reputation={reputation}
              />
            )}

            <GuestManagerTab
              selectedTab={selectedTab}
              guests={guests}
              rooms={rooms}
              renderStars={renderStars}
              gameDay={day}
              setSelectedTab={setSelectedTab}
            />

            <MarketingTab
              selectedTab={selectedTab}
              marketingCampaigns={marketingCampaigns}
              trainingPrograms={trainingPrograms}
              policies={policies}
              changePolicy={changePolicy}
              launchMarketingCampaign={launchMarketingCampaign}
              conductTraining={conductTraining}
              money={money}
              day={day}
              staff={staff}
              addNotification={addNotification}
              reputation={reputation}
            />

            <FinanceReportTab
              selectedTab={selectedTab}
              rooms={rooms}
              staff={staff}
              facilities={facilities}
              money={money}
              day={day}
              guests={guests}
            />

            <LeaderBoardTab selectedTab={selectedTab} />
          </div>

          {/* Responsive Sidebar with Notifications, Stats, and Instructions */}
          <div className="col-span-1">
            {/* Notification panel */}
            <div className="bg-white p-3 sm:p-4 rounded-lg shadow-md">
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-3 gap-2">
                <h2 className="text-lg sm:text-xl font-bold flex items-center">
                  <Bell className="w-4 h-4 mr-2 text-blue-600" />
                  Notifications
                </h2>
              </div>
              {/* Filter Icons - Add this above your notification panel div */}
              <div className="mb-3 flex items-center gap-1 p-2 bg-gray-50 rounded-lg">
                <span className="text-xs text-gray-500 mr-1">Filters:</span>

                {/* All */}
                <button
                  onClick={() => setActiveFilter(null)}
                  className={`p-1 rounded-full ${
                    !activeFilter
                      ? "bg-gray-200"
                      : "bg-gray-100 hover:bg-gray-200"
                  }`}
                  title="All"
                >
                  <Bell className="w-4 h-4 text-gray-600" />
                </button>

                {/* System */}
                <button
                  onClick={() =>
                    setActiveFilter(activeFilter === "system" ? null : "system")
                  }
                  className={`p-1 rounded-full ${
                    activeFilter === "system"
                      ? "bg-blue-100"
                      : "bg-gray-100 hover:bg-gray-200"
                  }`}
                  title="System"
                >
                  <Settings className="w-4 h-4 text-blue-500" />
                </button>

                {/* Facility */}
                <button
                  onClick={() =>
                    setActiveFilter(
                      activeFilter === "facility" ? null : "facility"
                    )
                  }
                  className={`p-1 rounded-full ${
                    activeFilter === "facility"
                      ? "bg-green-100"
                      : "bg-gray-100 hover:bg-gray-200"
                  }`}
                  title="Facility"
                >
                  <Building2 className="w-4 h-4 text-green-500" />
                </button>

                {/* Market */}
                <button
                  onClick={() =>
                    setActiveFilter(activeFilter === "market" ? null : "market")
                  }
                  className={`p-1 rounded-full ${
                    activeFilter === "market"
                      ? "bg-red-100"
                      : "bg-gray-100 hover:bg-gray-200"
                  }`}
                  title="Market"
                >
                  <TrendingUp className="w-4 h-4 text-red-500" />
                </button>

                {/* Marketing */}
                <button
                  onClick={() =>
                    setActiveFilter(
                      activeFilter === "marketing" ? null : "marketing"
                    )
                  }
                  className={`p-1 rounded-full ${
                    activeFilter === "marketing"
                      ? "bg-purple-100"
                      : "bg-gray-100 hover:bg-gray-200"
                  }`}
                  title="Marketing"
                >
                  <BarChart className="w-4 h-4 text-purple-500" />
                </button>

                {/* Special */}
                <button
                  onClick={() =>
                    setActiveFilter(
                      activeFilter === "special" ? null : "special"
                    )
                  }
                  className={`p-1 rounded-full ${
                    activeFilter === "special"
                      ? "bg-yellow-100"
                      : "bg-gray-100 hover:bg-gray-200"
                  }`}
                  title="Special"
                >
                  <AlertTriangle className="w-4 h-4 text-yellow-500" />
                </button>
              </div>

              {/* Your existing notification panel div */}
              <div className="overflow-y-auto max-h-64 sm:max-h-96 rounded-lg border border-gray-100">
                {sortedNotifications.length === 0 ? (
                  <div className="text-center py-6 text-gray-500">
                    <Bell className="w-8 h-8 mx-auto text-gray-300 mb-2" />
                    <p className="text-sm italic">
                      No notifications match your filter.
                    </p>
                  </div>
                ) : (
                  <ul className="divide-y divide-gray-100">
                    {sortedNotifications.map((notification) => {
                      let borderColor = "border-blue-500";
                      let bgColor = "bg-gray-50";
                      let icon = <Info className="w-4 h-4 text-blue-500" />;

                      // Special styling for different notification types
                      if (notification.isSpecial) {
                        borderColor = "border-yellow-500";
                        bgColor = "bg-yellow-50";
                        icon = (
                          <AlertTriangle className="w-4 h-4 text-yellow-500" />
                        );
                      } else if (notification.type === "facility") {
                        borderColor = "border-green-500";
                        bgColor = "bg-green-50";
                        icon = <Building2 className="w-4 h-4 text-green-500" />;
                      } else if (notification.type === "marketing") {
                        borderColor = "border-purple-500";
                        bgColor = "bg-purple-50";
                        icon = <BarChart className="w-4 h-4 text-purple-500" />;
                      } else if (notification.type === "system") {
                        borderColor = "border-blue-500";
                        bgColor = "bg-blue-50";
                        icon = <Settings className="w-4 h-4 text-blue-500" />;
                      } else if (notification.type === "market") {
                        borderColor = "border-red-500";
                        bgColor = "bg-red-50";
                        icon = <TrendingUp className="w-4 h-4 text-red-500" />;
                      }

                      return (
                        <li
                          key={notification.id}
                          className={`p-2 sm:p-3 ${bgColor} border-l-4 ${borderColor} transition-all hover:shadow-sm`}
                        >
                          <div className="flex justify-between items-center mb-1">
                            <div className="text-xs sm:text-sm text-gray-500 flex items-center">
                              <Calendar className="w-3 h-3 mr-1" />
                              Day {notification.timestamp}
                            </div>
                            {notification.type && (
                              <span
                                className={`text-xs px-2 py-0.5 rounded-full flex items-center
                    ${
                      notification.type === "facility"
                        ? "bg-green-100 text-green-800"
                        : notification.type === "marketing"
                        ? "bg-purple-100 text-purple-800"
                        : notification.type === "market"
                        ? "bg-red-100 text-red-800"
                        : notification.type === "system"
                        ? "bg-blue-100 text-blue-800"
                        : "bg-gray-100 text-gray-800"
                    }
                  `}
                              >
                                {icon}
                                <span className="ml-1 hidden sm:inline">
                                  {notification.type.charAt(0).toUpperCase() +
                                    notification.type.slice(1)}
                                </span>
                              </span>
                            )}
                          </div>
                          <div className="text-sm">{notification.message}</div>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            </div>

            {/* Stats Summary */}
            <div className="bg-white p-3 sm:p-4 rounded-lg shadow-md mt-3 sm:mt-4">
              <h2 className="text-lg font-bold mb-2 sm:mb-3 flex items-center">
                <BarChart3 className="w-4 h-4 mr-2 text-blue-600" />
                Hotel Statistics
              </h2>
              <div className="grid grid-cols-2 gap-2 sm:gap-3">
                <div className="p-2 sm:p-3 bg-gray-50 rounded-lg border border-gray-100">
                  <div className="text-xs text-gray-500 mb-1">
                    Occupancy Rate
                  </div>
                  <div className="font-semibold flex items-center">
                    <Hotel className="w-3 h-3 mr-1 text-amber-500" />
                    <span>
                      {rooms.length > 0
                        ? Math.round(
                            (rooms.filter((room) => room.occupied).length /
                              rooms.length) *
                              100
                          )
                        : 0}
                      <span className="text-xs ml-0.5">%</span>
                    </span>
                  </div>
                </div>
                <div className="p-2 sm:p-3 bg-gray-50 rounded-lg border border-gray-100">
                  <div className="text-xs text-gray-500 mb-1">Room Quality</div>
                  <div className="font-semibold flex items-center">
                    <Star className="w-3 h-3 mr-1 text-yellow-500" />
                    <span>
                      {rooms.length > 0
                        ? (
                            rooms.reduce(
                              (total, room) => total + room.quality,
                              0
                            ) / rooms.length
                          ).toFixed(1)
                        : "N/A"}
                    </span>
                  </div>
                </div>
                <div className="p-2 sm:p-3 bg-gray-50 rounded-lg border border-gray-100">
                  <div className="text-xs text-gray-500 mb-1">
                    Staff Happiness
                  </div>
                  <div className="font-semibold flex items-center">
                    <UserCircle className="w-3 h-3 mr-1 text-green-500" />
                    <span>
                      {staff.length > 0
                        ? (
                            staff.reduce(
                              (total, employee) => total + employee.happiness,
                              0
                            ) / staff.length
                          ).toFixed(1)
                        : "N/A"}
                    </span>
                  </div>
                </div>
                <div className="p-2 sm:p-3 bg-gray-50 rounded-lg border border-gray-100">
                  <div className="text-xs text-gray-500 mb-1">
                    Guest Happiness
                  </div>
                  <div className="font-semibold flex items-center">
                    <SmilePlus className="w-3 h-3 mr-1 text-blue-500" />
                    <span>
                      {guests.length > 0
                        ? (
                            guests.reduce(
                              (total, guest) => total + guest.happiness,
                              0
                            ) / guests.length
                          ).toFixed(1)
                        : "N/A"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="mt-3 p-2 sm:p-3 bg-blue-50 rounded-lg border border-blue-100">
                <div className="flex justify-between items-center">
                  <div className="text-xs text-blue-700">Market Share</div>
                  <div className="font-semibold text-blue-800 flex items-center">
                    <PieChart className="w-3 h-3 mr-1" />
                    {marketShare}%
                  </div>
                </div>
                <div className="mt-1 h-2 w-full bg-blue-100 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-blue-600 rounded-full"
                    style={{ width: `${Math.min(100, marketShare)}%` }}
                  ></div>
                </div>
              </div>
            </div>

            {/* Game instructions */}
            <div className="bg-white p-3 sm:p-4 rounded-lg shadow-md mt-3 sm:mt-4">
              <h2 className="text-lg font-bold mb-2 flex items-center">
                <HelpCircle className="w-4 h-4 mr-2 text-blue-600" />
                How to Play
              </h2>
              <ul className="text-sm space-y-1.5">
                <li className="flex items-start">
                  <Building className="w-3 h-3 text-blue-500 mt-1 mr-2 flex-shrink-0" />
                  <span>Build rooms and facilities to attract guests</span>
                </li>
                <li className="flex items-start">
                  <Users className="w-3 h-3 text-green-500 mt-1 mr-2 flex-shrink-0" />
                  <span>Hire staff to improve service quality</span>
                </li>
                <li className="flex items-start">
                  <DollarSign className="w-3 h-3 text-amber-500 mt-1 mr-2 flex-shrink-0" />
                  <span>Balance prices to maximize profits</span>
                </li>
                <li className="flex items-start">
                  <Heart className="w-3 h-3 text-red-500 mt-1 mr-2 flex-shrink-0" />
                  <span>Keep guests happy to improve reputation</span>
                </li>
                <li className="flex items-start">
                  <Wallet className="w-3 h-3 text-purple-500 mt-1 mr-2 flex-shrink-0" />
                  <span>
                    Manage your finances carefully to avoid bankruptcy
                  </span>
                </li>
                <li className="flex items-start">
                  <Eye className="w-3 h-3 text-blue-500 mt-1 mr-2 flex-shrink-0" />
                  <span>Monitor your competitors and adjust your strategy</span>
                </li>
                <li className="flex items-start">
                  <Megaphone className="w-3 h-3 text-green-500 mt-1 mr-2 flex-shrink-0" />
                  <span>
                    Use marketing campaigns to boost your market share
                  </span>
                </li>
                <li className="flex items-start">
                  <Save className="w-3 h-3 text-blue-500 mt-1 mr-2 flex-shrink-0" />
                  <span>Don't forget to save your progress!</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {showSaveModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-xl font-bold mb-4">Save Game</h2>
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Save Name
              </label>
              <input
                type="text"
                value={saveName}
                onChange={(e) => setSaveName(e.target.value)}
                placeholder="Enter a name for your save"
                className="w-full p-2 border rounded-lg"
              />
            </div>

            {/* NEW: Cloud save toggle */}
            {user ? (
              <div className="mb-4 flex items-center">
                <div
                  className={`w-5 h-5 border rounded mr-2 cursor-pointer flex items-center justify-center ${
                    saveToCloud
                      ? "bg-blue-600 border-blue-600"
                      : "border-gray-300"
                  }`}
                  onClick={() => setSaveToCloud(!saveToCloud)}
                >
                  {saveToCloud && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-3 w-3 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={3}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  )}
                </div>
                <label
                  className="text-sm flex items-center cursor-pointer"
                  onClick={() => setSaveToCloud(!saveToCloud)}
                >
                  {saveToCloud ? (
                    <Cloud className="w-4 h-4 mr-1 text-blue-600" />
                  ) : (
                    <CloudOff className="w-4 h-4 mr-1 text-gray-500" />
                  )}
                  Save to Cloud
                </label>
              </div>
            ) : (
              <p className="text-xs text-amber-600 mb-4">
                <AlertCircle className="w-3 h-3 inline mr-1" />
                Sign in to enable cloud saves
              </p>
            )}

            <div className="flex justify-end space-x-2">
              <button
                onClick={() => setShowSaveModal(false)}
                className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={saveGame}
                disabled={!saveName.trim() || isSaving}
                className={`px-4 py-2 rounded-lg flex items-center ${
                  !saveName.trim() || isSaving
                    ? "bg-gray-300 text-gray-500"
                    : "bg-green-600 text-white hover:bg-green-700"
                }`}
              >
                {isSaving ? (
                  <>
                    <RefreshCw className="w-4 h-4 mr-1 animate-spin" />
                    Saving...
                  </>
                ) : (
                  <>
                    <Save className="w-4 h-4 mr-1" />
                    Save
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {showLoadModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96 max-h-[80vh] overflow-auto">
            <h2 className="text-xl font-bold mb-4 flex items-center justify-between">
              <span>Load Game</span>
              {isLoading && (
                <RefreshCw className="w-5 h-5 animate-spin text-blue-600" />
              )}
            </h2>

            {/* Refresh button to reload saves from server */}
            {user && (
              <button
                onClick={loadSavedGamesFromServer}
                disabled={isLoading}
                className="text-xs flex items-center bg-blue-50 text-blue-600 px-3 py-1 rounded mb-3 hover:bg-blue-100"
              >
                <RefreshCw className="w-3 h-3 mr-1" />
                Refresh from cloud
              </button>
            )}

            {savedGames.length === 0 ? (
              <div className="text-center py-8">
                <p className="text-gray-500 italic">No saved games found.</p>
                {!user && (
                  <p className="text-xs text-amber-600 mt-2">
                    <AlertCircle className="w-3 h-3 inline mr-1" />
                    Sign in to access cloud saves
                  </p>
                )}
              </div>
            ) : (
              <div className="space-y-3 mb-4 max-h-64 overflow-y-auto">
                {savedGames.map((game, index) => {
                  // Check if this is a cloud save
                  const isCloudSave = cloudSavedGames.some(
                    (cloudGame) => cloudGame.id === game.id
                  );

                  return (
                    <div
                      key={game.id || index}
                      className="border p-3 rounded-lg hover:bg-gray-50"
                    >
                      <div className="flex justify-between items-center">
                        <div>
                          <h3 className="font-bold flex items-center">
                            {game.name}
                            {isCloudSave && (
                              <Cloud className="w-3 h-3 ml-1 text-blue-500" />
                            )}
                          </h3>
                          <p className="text-xs text-gray-500">
                            Day {game.day} • {game.date}
                          </p>
                          <div className="flex items-center mt-1 text-xs">
                            <span className="text-green-600 mr-2">
                              ${game.money.toLocaleString()}
                            </span>
                            <span className="flex items-center text-amber-600 mr-2">
                              {game.reputation.toFixed(1)}
                              <Star className="w-3 h-3 ml-1" />
                            </span>
                            <span className="text-blue-600">
                              {game.marketShare || 0}% Market
                            </span>
                          </div>
                        </div>
                        <div className="flex space-x-2">
                          <button
                            onClick={() => loadGame(game)}
                            disabled={isLoading}
                            className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm flex items-center"
                          >
                            {isLoading ? (
                              <RefreshCw className="w-3 h-3 animate-spin" />
                            ) : (
                              "Load"
                            )}
                          </button>
                          <button
                            onClick={() => deleteSavedGame(game.id, index)}
                            className="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 text-sm"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            <div className="flex justify-end">
              <button
                onClick={() => setShowLoadModal(false)}
                className="px-4 py-2 bg-gray-200 rounded-lg hover:bg-gray-300"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add this at the bottom of your component render */}
      <HowToPlayModal
        isOpen={showTutorialModal}
        onClose={() => setShowTutorialModal(!showTutorialModal)}
      />

      {showSaveReminderModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96 max-w-full mx-4">
            <h2 className="text-xl font-bold mb-4 text-red-600 flex items-center">
              <AlertTriangle className="w-6 h-6 mr-2" />
              Unsaved Progress!
            </h2>
            <p className="mb-6">
              {pendingReload
                ? "You're about to refresh the game without saving your progress."
                : "You're about to leave the game without saving your progress."}
              All your changes since your last save will be lost!
            </p>
            <div className="flex justify-between">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setShowSaveReminderModal(false);
                  setShowSaveModal(true); // Open save modal instead
                  setPendingReload(false); // Cancel pending reload
                }}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                Save Game
              </button>
              <button
                onClick={(e) => {
                  setShowSaveReminderModal(false);
                  e.preventDefault();
                  // If this was a requested refresh, do it now
                  localStorage.removeItem("hotelTycoonNotifications");
                  setNotifications([]);
                  window.location.reload();
                }}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                Leave Without Saving
              </button>
            </div>
          </div>
        </div>
      )}

      {showEventModal && currentEvent && (
        <RandomEventModal
          event={currentEvent}
          onClose={closeEventModal}
          onDecline={handleDeclineEvent}
          hasChoice={!eventResult} // Only show choices before the event is handled
          eventMessage={eventResult}
          day={day}
        />
      )}

      {showBankRuptcyModal && (
        <GameOverModal
          handleRefreshPage={restartGame}
          money={money}
          days={day}
          user={user.id}
          reputation={reputation}
          marketShare={marketShare}
        />
      )}
    </div>
  );
};

export default VirtualHotelGame;
